import * as e from "valibot";
import t from "http-link-header";
import { serialize as n } from "object-to-formdata";
import r from "query-string";
import { isBlurhashValid as i } from "blurhash";
import { WebSocket as a } from "isows";
//#region \0rolldown/runtime.js
var o = Object.create, s = Object.defineProperty, c = Object.getOwnPropertyDescriptor, l = Object.getOwnPropertyNames, u = Object.getPrototypeOf, d = Object.prototype.hasOwnProperty, f = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), ee = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = l(t), a = 0, o = i.length, u; a < o; a++) u = i[a], !d.call(e, u) && u !== n && s(e, u, {
		get: ((e) => t[e]).bind(null, u),
		enumerable: !(r = c(t, u)) || r.enumerable
	});
	return e;
}, te = (e, t, n) => (n = e == null ? {} : o(u(e)), ee(t || !e || !e.__esModule ? s(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), p = (e, t) => {
	let n = {};
	for (let r of t) r in e && (n[r] = e[r]);
	return n;
}, ne = (e, t) => {
	let n = { ...e };
	for (let e of t) delete n[e];
	return n;
}, re = [
	"/assets/default_header.webp",
	"/headers/original/missing.png",
	"/api/v1/accounts/identicon",
	/\/static\/img\/missing\.[a-z0-9]+\.png$/,
	"/storage/headers/missing.png",
	"/images/banner.png",
	"/assets/transparent.png"
], ie = (e = "") => e === "" || re.some((t) => typeof t == "string" ? e.endsWith(t) : t.test(e)), ae = [
	/\/assets\/default_avatars\/GoToSocial_icon[1-6]\.webp$/,
	"/avatars/original/missing.png",
	"/api/v1/accounts/identicon",
	"/s/img/avatar.svg",
	"/avatars/default.jpg",
	"/images/avi.png"
], oe = (e = "") => e === "" || ae.some((t) => typeof t == "string" ? e.endsWith(t) : t.test(e)), se = (e) => {
	try {
		let t = e.url;
		return new URL(t).host;
	} catch {
		return "";
	}
}, ce = (e) => {
	let t = e.acct, [n, r] = t.split("@");
	return r ? t : [n, se(e)].join("@");
}, m = e.object({
	shortcode: e.string(),
	url: e.string(),
	static_url: e.fallback(e.string(), ""),
	visible_in_picker: e.fallback(e.boolean(), !0),
	category: e.fallback(e.nullable(e.string()), null)
}), h = e.object({
	blocked_by: e.fallback(e.boolean(), !1),
	blocking: e.fallback(e.boolean(), !1),
	domain_blocking: e.fallback(e.boolean(), !1),
	endorsed: e.fallback(e.boolean(), !1),
	followed_by: e.fallback(e.boolean(), !1),
	following: e.fallback(e.boolean(), !1),
	id: e.string(),
	muting: e.fallback(e.boolean(), !1),
	muting_notifications: e.fallback(e.boolean(), !1),
	note: e.fallback(e.string(), ""),
	notifying: e.fallback(e.boolean(), !1),
	notifying_reblogs: e.fallback(e.boolean(), !1),
	notifying_replies: e.fallback(e.boolean(), !1),
	requested: e.fallback(e.boolean(), !1),
	showing_reblogs: e.fallback(e.boolean(), !1),
	languages: e.fallback(e.nullable(e.array(e.string())), null)
}), le = e.pipe(e.string(), e.regex(/^#[a-f0-9]{6}$/i)), ue = e.object({
	id: e.fallback(e.string(), ""),
	name: e.fallback(e.string(), ""),
	color: e.fallback(le, ""),
	permissions: e.fallback(e.string(), ""),
	highlighted: e.fallback(e.boolean(), !0),
	collection_limit: e.fallback(e.optional(e.number()), void 0)
}), g = e.pipe(e.string(), e.regex(/^\d{4}-\d{2}-\d{2}T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d+)?(([+-]\d{2}:?\d{2})|(Z)?)$/)), de = e.pipe(e.string(), e.transform((e) => e.slice(0, 10)), e.regex(/^\d{4}-\d{2}-\d{2}$/)), _ = (t) => e.pipe(e.fallback(e.array(e.any()), []), e.transform((n) => (n || []).map((n) => {
	let r = e.safeParse(t, n);
	return r.success ? r.output : void 0;
}).filter((e) => !!e))), fe = e.pipe(e.string(), e.transform((e) => e === "❤" ? "❤️" : e), e.emoji()), pe = e.pipe(e.string(), e.regex(/^\w+\/[-+.\w]+$/)), v = (t) => e.optional(e.pipe(e.any(), e.transform((e) => typeof e == "object" && !Array.isArray(e) && e !== null ? e : {}), e.object(t)), {}), me = (t) => t?.filter((e) => e.startsWith("badge:")).map((t) => e.parse(ue, {
	id: t,
	name: t.replace(/^badge:/, "")
})), he = [
	"https://pl.fediverse.pl/users/mkljczk",
	"https://gts.mkljczk.pl/users/mkljczk",
	"https://gts.mkljczk.pl/@mkljczk"
], ge = e.variant("type", [e.object({
	type: e.literal("link"),
	name: e.fallback(e.nullable(e.string()), null),
	href: e.fallback(e.nullable(e.string()), null),
	object_id: e.fallback(e.nullable(e.string()), null)
}), e.object({
	type: e.literal("monero-subscription"),
	chain_id: e.fallback(e.nullable(e.string()), null),
	price: e.fallback(e.nullable(e.number()), null),
	amount_min: e.fallback(e.nullable(e.number()), null),
	object_id: e.fallback(e.nullable(e.string()), null)
})]), _e = e.transform((e) => {
	if (!e?.acct) return null;
	let t = e.username || e.acct.split("@")[0], n = e.fqn || ce(e), r = n.split("@")[1] || "", i = (e.pleroma?.is_cat ?? e.is_cat) || he.includes(e.uri ?? e.url), a = e.pleroma?.speak_as_cat ?? e.speak_as_cat ?? i;
	return {
		username: t,
		fqn: n,
		domain: r,
		avatar: e.avatar || e.avatar_static,
		header: e.header || e.header_static,
		avatar_default: oe(e.avatar || e.avatar_static || ""),
		header_default: ie(e.header || e.header_static || ""),
		local: typeof e.pleroma?.is_local == "boolean" ? e.pleroma.is_local : e.acct.split("@")[1] === void 0,
		discoverable: e.discoverable || e.pleroma?.source?.discoverable,
		verified: e.verified || e.pleroma?.tags?.includes("verified"),
		...e.role?.permissions ? { is_admin: (e.role?.permissions & 1) == 1 } : {},
		ap_id: e.pleroma?.ap_id ?? e.actor_id,
		...p(e.pleroma || {}, [
			"background_image",
			"relationship",
			"is_moderator",
			"is_admin",
			"privileges",
			"hide_favorites",
			"hide_followers",
			"hide_follows",
			"hide_followers_count",
			"hide_follows_count",
			"accepts_chat_messages",
			"favicon",
			"birthday",
			"deactivated",
			"avatar_description",
			"header_description",
			"settings_store",
			"chat_token",
			"allow_following_move",
			"unread_conversation_count",
			"unread_notifications_count",
			"notification_settings",
			"location"
		]),
		...p(e.akkoma || {}, ["permit_followback"]),
		is_cat: i,
		speak_as_cat: a,
		...p(e.other_settings || {}, ["birthday", "location"]),
		__meta: p(e, ["pleroma", "source"]),
		...e,
		display_name: e.display_name?.replace(/^[\s\u180E\u200B-\u200D\u2060\uFEFF]+|[\s\u180E\u200B-\u200D\u2060\uFEFF]+$/g, "").trim() || t,
		roles: e.roles?.length ? e.roles : me(e.pleroma?.tags),
		source: e.source ? {
			...p(e.pleroma?.source || {}, [
				"show_role",
				"no_rich_text",
				"discoverable",
				"actor_type",
				"show_birthday"
			]),
			...e.source
		} : void 0
	};
}), ve = e.object({
	name: e.string(),
	value: e.string(),
	verified_at: e.fallback(e.nullable(g), null)
}), ye = e.object({
	automatic: e.fallback(e.array(e.picklist([
		"public",
		"followers",
		"following",
		"unsupported_policy"
	])), []),
	manual: e.fallback(e.array(e.picklist([
		"public",
		"followers",
		"following",
		"unsupported_policy"
	])), []),
	current_user: e.fallback(e.picklist([
		"automatic",
		"manual",
		"denied",
		"missing",
		"unknown"
	]), "unknown")
}), be = e.object({
	id: e.string(),
	username: e.fallback(e.string(), ""),
	acct: e.fallback(e.string(), ""),
	url: e.pipe(e.string(), e.url()),
	display_name: e.fallback(e.string(), ""),
	note: e.fallback(e.pipe(e.string(), e.transform((e) => e === "<p></p>" ? "" : e)), ""),
	avatar: e.fallback(e.string(), ""),
	avatar_static: e.fallback(e.pipe(e.string(), e.url()), ""),
	header: e.fallback(e.pipe(e.string(), e.url()), ""),
	header_static: e.fallback(e.pipe(e.string(), e.url()), ""),
	locked: e.fallback(e.boolean(), !1),
	fields: _(ve),
	emojis: _(m),
	bot: e.fallback(e.boolean(), !1),
	group: e.fallback(e.boolean(), !1),
	discoverable: e.fallback(e.boolean(), !1),
	indexable: e.fallback(e.nullable(e.boolean()), null),
	noindex: e.fallback(e.nullable(e.boolean()), null),
	memorial: e.fallback(e.nullable(e.boolean()), null),
	suspended: e.fallback(e.optional(e.boolean()), void 0),
	limited: e.fallback(e.optional(e.boolean()), void 0),
	created_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString()),
	last_status_at: e.fallback(e.nullable(e.pipe(e.string(), e.isoDate())), null),
	statuses_count: e.fallback(e.number(), 0),
	followers_count: e.fallback(e.number(), 0),
	following_count: e.fallback(e.number(), 0),
	roles: _(ue),
	hide_collections: e.fallback(e.optional(e.boolean()), void 0),
	email_subscriptions: e.fallback(e.optional(e.boolean()), void 0),
	feature_approval: e.fallback(e.optional(ye), void 0),
	fqn: e.string(),
	ap_id: e.fallback(e.nullable(e.string()), null),
	background_image: e.fallback(e.nullable(e.string()), null),
	relationship: e.fallback(e.optional(h), void 0),
	is_moderator: e.fallback(e.optional(e.boolean()), void 0),
	is_admin: e.fallback(e.optional(e.boolean()), void 0),
	privileges: e.fallback(e.optional(e.array(e.string())), void 0),
	is_suggested: e.fallback(e.optional(e.boolean()), void 0),
	hide_favorites: e.fallback(e.boolean(), !0),
	hide_followers: e.fallback(e.optional(e.boolean()), void 0),
	hide_follows: e.fallback(e.optional(e.boolean()), void 0),
	hide_followers_count: e.fallback(e.optional(e.boolean()), void 0),
	hide_follows_count: e.fallback(e.optional(e.boolean()), void 0),
	accepts_chat_messages: e.fallback(e.nullable(e.boolean()), null),
	favicon: e.fallback(e.optional(e.string()), void 0),
	birthday: e.fallback(e.optional(e.pipe(e.string(), e.isoDate())), void 0),
	deactivated: e.fallback(e.optional(e.boolean()), void 0),
	location: e.fallback(e.optional(e.string()), void 0),
	local: e.fallback(e.optional(e.boolean()), !1),
	permit_followback: e.fallback(e.optional(e.boolean()), void 0),
	avatar_description: e.fallback(e.string(), ""),
	custom_css: e.fallback(e.string(), ""),
	enable_rss: e.fallback(e.boolean(), !1),
	header_description: e.fallback(e.string(), ""),
	verified: e.fallback(e.optional(e.boolean()), void 0),
	domain: e.fallback(e.string(), ""),
	pronouns: e.fallback(e.array(e.string()), []),
	mention_policy: e.fallback(e.picklist([
		"none",
		"only_known",
		"only_contacts"
	]), "none"),
	subscribers_count: e.fallback(e.number(), 0),
	identity_proofs: _(e.object({
		name: e.fallback(e.string(), ""),
		value: e.fallback(e.string(), ""),
		verified_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString())
	})),
	payment_options: _(ge),
	is_cat: e.fallback(e.boolean(), !1),
	speak_as_cat: e.fallback(e.boolean(), !1),
	__meta: v({
		pleroma: e.optional(e.any(), void 0),
		source: e.optional(e.any(), void 0)
	}),
	avatar_default: e.fallback(e.boolean(), !1),
	header_default: e.fallback(e.boolean(), !1)
}), xe = e.object({
	...be.entries,
	moved: e.fallback(e.nullable(e.lazy(() => xe)), null)
}), y = e.pipe(e.any(), _e, xe), Se = e.pipe(e.any(), _e, e.object({
	...xe.entries,
	source: e.fallback(e.nullable(v({
		attribution_domains: e.fallback(e.optional(e.nullable(e.array(e.string()))), null),
		note: e.fallback(e.optional(e.string()), ""),
		fields: e.fallback(e.optional(_(ve)), []),
		privacy: e.fallback(e.optional(e.picklist([
			"public",
			"unlisted",
			"private",
			"direct"
		])), "public"),
		sensitive: e.fallback(e.optional(e.boolean()), !1),
		language: e.fallback(e.optional(e.nullable(e.string())), null),
		follow_requests_count: e.fallback(e.optional(e.pipe(e.number(), e.integer(), e.minValue(0))), 0),
		hide_collections: e.fallback(e.optional(e.boolean()), void 0),
		discoverable: e.fallback(e.optional(e.boolean()), void 0),
		indexable: e.fallback(e.nullable(e.boolean()), null),
		quote_policy: e.fallback(e.nullable(e.picklist([
			"public",
			"followers",
			"nobody"
		])), null),
		show_role: e.fallback(e.optional(e.nullable(e.boolean())), void 0),
		no_rich_text: e.fallback(e.optional(e.nullable(e.boolean())), void 0),
		actor_type: e.fallback(e.optional(e.string()), void 0),
		show_birthday: e.fallback(e.optional(e.boolean()), void 0),
		also_known_as_uris: e.fallback(e.optional(e.array(e.string())), void 0),
		status_content_type: e.fallback(e.optional(e.string()), void 0),
		web_include_boosts: e.fallback(e.optional(e.boolean()), void 0),
		web_layout: e.fallback(e.optional(e.picklist(["microblog", "gallery"])), void 0),
		web_visibility: e.fallback(e.optional(e.picklist([
			"public",
			"unlisted",
			"none"
		])), void 0)
	})), null),
	role: e.fallback(e.nullable(ue), null),
	settings_store: e.fallback(e.optional(e.record(e.string(), e.any())), void 0),
	chat_token: e.fallback(e.optional(e.string()), void 0),
	allow_following_move: e.fallback(e.optional(e.boolean()), void 0),
	unread_conversation_count: e.fallback(e.optional(e.number()), void 0),
	unread_notifications_count: e.fallback(e.optional(e.number()), void 0),
	notification_settings: e.fallback(e.optional(e.object({
		block_from_strangers: e.fallback(e.boolean(), !1),
		hide_notification_contents: e.fallback(e.boolean(), !1)
	})), void 0)
})), Ce = e.pipe(e.any(), _e, e.object({
	...xe.entries,
	block_expires_at: e.fallback(e.nullable(g), null)
})), we = e.pipe(e.any(), _e, e.object({
	...xe.entries,
	mute_expires_at: e.fallback(e.nullable(g), null)
})), Te = e.object({
	id: e.string(),
	text: e.fallback(e.string(), ""),
	hint: e.fallback(e.string(), ""),
	translations: e.optional(e.record(e.string(), e.object({
		text: e.fallback(e.string(), ""),
		hint: e.fallback(e.string(), "")
	})), void 0)
}), Ee = e.pipe(e.any(), e.transform((e) => ({
	...e,
	hint: e.hint || e.subtext
})), Te), De = /^([0-9.]*) \(not true; really snac\/([\w.]*)\)/, Oe = /^WordPress\/[\w+.-]*, EMA\/([\w+.-]*)/, ke = (e) => ({
	...Object.fromEntries(e.pleroma?.metadata?.features?.map((e) => {
		let t = `${e}.pleroma.pl-api`;
		return (t.startsWith("pleroma:") || t.startsWith("pleroma_")) && (t = t.slice(8)), t.startsWith("akkoma:") && (t = t.slice(7)), t.startsWith("pl:") && (t = t.slice(3)), [t, 1];
	}) || []),
	...Object.fromEntries(e.fedibird_capabilities?.map((e) => [`${e}.fedibird.pl-api`, 1]) || []),
	...e.api_versions
}), Ae = (t) => {
	let { approval_required: n, configuration: r, contact_account: i, description: a, description_limit: o, email: s, max_media_attachments: c, max_toot_chars: l, poll_limits: u, pleroma: d, registrations: f, short_description: ee, thumbnail: te, upload_limit: p, uri: ne, urls: re, ...ie } = e.parse(Ve, t), ae = ne;
	try {
		ae = new URL(ne).host;
	} catch {}
	return {
		...ie,
		account_domain: ie.account_domain || ne,
		configuration: {
			...r,
			media_attachments: {
				...r.media_attachments,
				image_size_limit: p ?? r.media_attachments.image_size_limit,
				video_size_limit: p ?? r.media_attachments.video_size_limit
			},
			polls: {
				...r.polls,
				max_characters_per_option: u.max_option_chars ?? r.polls.max_characters_per_option,
				max_expiration: u.max_expiration ?? r.polls.max_expiration,
				max_options: u.max_options ?? r.polls.max_options,
				min_expiration: u.min_expiration ?? r.polls.min_expiration
			},
			statuses: {
				...r.statuses,
				max_characters: l ?? r.statuses.max_characters,
				max_media_attachments: c ?? r.statuses.max_media_attachments
			},
			urls: { streaming: re.streaming_api },
			vapid: { public_key: d.vapid_public_key }
		},
		contact: {
			account: i,
			email: s
		},
		description: ee || a,
		domain: ae,
		pleroma: {
			...d,
			metadata: {
				...d.metadata,
				description_limit: o
			}
		},
		registrations: {
			approval_required: n,
			enabled: f
		},
		thumbnail: { url: te }
	};
}, je = [
	["takahe", "Takahe"],
	["neodb", "NeoDB"],
	["egregoros", "Egregoros"]
], Me = (e) => {
	if ((/* @__PURE__ */ new RegExp(/[0-9.]+rc[0-9]+/g)).test(e)) return e.split("rc").join("-rc");
	for (let [t, n] of je) if (e.startsWith(`${t}/`)) return `0.0.0 (compatible; ${n} ${e.slice(t.length + 1)})`;
	let t = Oe.exec(e);
	if (t) return `0.0.0 (compatible; WordPress ${t[1]})`;
	let n = De.exec(e);
	return n ? `${n[1]} (compatible; snac ${n[2]})` : e;
}, Ne = v({
	accounts: e.fallback(e.nullable(e.object({
		allow_custom_css: e.boolean(),
		max_display_name_length: e.fallback(e.optional(e.number()), void 0),
		max_note_length: e.fallback(e.optional(e.number()), void 0),
		max_avatar_description_length: e.fallback(e.optional(e.number()), void 0),
		max_header_description_length: e.fallback(e.optional(e.number()), void 0),
		max_featured_tags: e.fallback(e.optional(e.number()), void 0),
		max_pinned_statuses: e.fallback(e.optional(e.number()), void 0),
		max_profile_fields: e.fallback(e.optional(e.number()), void 0),
		profile_field_name_limit: e.fallback(e.optional(e.number()), void 0),
		profile_field_value_limit: e.fallback(e.optional(e.number()), void 0)
	})), null),
	chats: v({ max_characters: e.fallback(e.number(), 5e3) }),
	groups: v({
		max_characters_description: e.fallback(e.number(), 160),
		max_characters_name: e.fallback(e.number(), 50)
	}),
	media_attachments: v({
		image_matrix_limit: e.fallback(e.optional(e.number()), void 0),
		image_size_limit: e.fallback(e.optional(e.number()), void 0),
		supported_mime_types: e.fallback(e.optional(e.array(pe)), void 0),
		video_duration_limit: e.fallback(e.optional(e.number()), void 0),
		video_frame_rate_limit: e.fallback(e.optional(e.number()), void 0),
		video_matrix_limit: e.fallback(e.optional(e.number()), void 0),
		video_size_limit: e.fallback(e.optional(e.number()), void 0)
	}),
	polls: v({
		max_characters_per_option: e.fallback(e.number(), 25),
		max_expiration: e.fallback(e.number(), 2629746),
		max_options: e.fallback(e.number(), 4),
		min_expiration: e.fallback(e.number(), 300)
	}),
	reactions: v({ max_reactions: e.fallback(e.number(), 0) }),
	statuses: v({
		characters_reserved_per_url: e.fallback(e.optional(e.number()), void 0),
		max_characters: e.fallback(e.number(), 500),
		max_media_attachments: e.fallback(e.number(), 4)
	}),
	translation: v({ enabled: e.fallback(e.boolean(), !1) }),
	timelines_access: v({
		...e.entriesFromList(["hashtag_feeds", "trending_link_feeds"], v(e.entriesFromList(["local", "remote"], e.fallback(e.picklist([
			"public",
			"authenticated",
			"disabled"
		]), "public")))),
		live_feeds: v(e.entriesFromList([
			"local",
			"bubble",
			"remote",
			"wrenched"
		], e.fallback(e.picklist([
			"public",
			"authenticated",
			"disabled",
			"restricted"
		]), "public")))
	}),
	urls: v({
		streaming: e.fallback(e.optional(e.pipe(e.string(), e.url())), void 0),
		status: e.fallback(e.optional(e.pipe(e.string(), e.url())), void 0),
		about: e.fallback(e.nullable(e.string()), null),
		privacy_policy: e.fallback(e.nullable(e.string()), null),
		terms_of_service: e.fallback(e.nullable(e.string()), null)
	}),
	vapid: v({ public_key: e.fallback(e.string(), "") }),
	limited_federation: e.optional(e.boolean(), void 0),
	gif_search: v({
		enabled: e.fallback(e.boolean(), !1),
		provider: e.fallback(e.nullable(e.string()), null)
	})
}), Pe = v({
	contact_account: e.fallback(e.optional(y), void 0),
	email: e.fallback(e.pipe(e.string(), e.email()), "")
}), Fe = v({
	metadata: v({
		account_activation_required: e.fallback(e.boolean(), !1),
		birthday_min_age: e.fallback(e.number(), 0),
		birthday_required: e.fallback(e.boolean(), !1),
		description_limit: e.fallback(e.number(), 1500),
		federation: v({
			enabled: e.fallback(e.boolean(), !0),
			mrf_policies: e.fallback(e.optional(e.array(e.string())), void 0),
			mrf_simple: v(e.entriesFromList([
				"accept",
				"avatar_removal",
				"banner_removal",
				"federated_timeline_removal",
				"followers_only",
				"media_nsfw",
				"media_removal",
				"reject",
				"reject_deletes",
				"report_removal"
			], e.fallback(e.array(e.string()), []))),
			mrf_simple_info: v(e.entriesFromList([
				"accept",
				"avatar_removal",
				"banner_removal",
				"federated_timeline_removal",
				"followers_only",
				"media_nsfw",
				"media_removal",
				"reject",
				"reject_deletes",
				"report_removal"
			], e.fallback(e.array(e.tuple([e.string(), e.string()])), [])))
		}),
		fields_limits: v({
			max_fields: e.fallback(e.pipe(e.number(), e.integer(), e.minValue(0)), 4),
			name_length: e.fallback(e.pipe(e.number(), e.integer(), e.minValue(0)), 255),
			value_length: e.fallback(e.pipe(e.number(), e.integer(), e.minValue(0)), 2047)
		}),
		markup: v({
			allow_headings: e.fallback(e.boolean(), !1),
			allow_inline_images: e.fallback(e.boolean(), !1)
		}),
		migration_cooldown_period: e.fallback(e.optional(e.number()), void 0),
		multitenancy: v({
			domains: e.optional(e.array(e.object({
				domain: e.pipe(e.unknown(), e.transform(String)),
				id: e.string(),
				public: e.fallback(e.boolean(), !1)
			}))),
			enabled: e.fallback(e.boolean(), !1)
		}),
		post_formats: e.fallback(e.array(e.string()), ["text/plain"]),
		restrict_unauthenticated: v({
			activities: v({
				local: e.fallback(e.boolean(), !1),
				remote: e.fallback(e.boolean(), !1)
			}),
			profiles: v({
				local: e.fallback(e.boolean(), !1),
				remote: e.fallback(e.boolean(), !1)
			}),
			timelines: v({
				bubble: e.fallback(e.boolean(), !1),
				federated: e.fallback(e.boolean(), !1),
				local: e.fallback(e.boolean(), !1),
				wrenched: e.fallback(e.boolean(), !1)
			})
		}),
		translation: v({
			allow_remote: e.fallback(e.boolean(), !0),
			allow_unauthenticated: e.fallback(e.boolean(), !1),
			source_languages: e.fallback(e.optional(e.array(e.string())), void 0),
			target_languages: e.fallback(e.optional(e.array(e.string())), void 0)
		})
	}),
	oauth_consumer_strategies: e.fallback(e.array(e.string()), []),
	stats: v({ mau: e.fallback(e.optional(e.number()), void 0) }),
	vapid_public_key: e.fallback(e.string(), "")
}), Ie = v({
	max_expiration: e.fallback(e.optional(e.number()), void 0),
	max_option_chars: e.fallback(e.optional(e.number()), void 0),
	max_options: e.fallback(e.optional(e.number()), void 0),
	min_expiration: e.fallback(e.optional(e.number()), void 0)
}), Le = v({
	approval_required: e.fallback(e.boolean(), !1),
	enabled: e.fallback(e.boolean(), !1),
	message: e.fallback(e.optional(e.string()), void 0),
	min_age: e.fallback(e.nullable(e.number()), null),
	reason_required: e.fallback(e.nullable(e.boolean()), null),
	url: e.fallback(e.nullable(e.pipe(e.string(), e.url())), null)
}), Re = v({
	domain_count: e.fallback(e.optional(e.number()), void 0),
	status_count: e.fallback(e.optional(e.number()), void 0),
	user_count: e.fallback(e.optional(e.number()), void 0)
}), ze = v({ url: e.fallback(e.string(), "") }), Be = v({ users: v({ active_month: e.fallback(e.number(), 0) }) }), Ve = v({
	account_domain: e.fallback(e.string(), ""),
	approval_required: e.fallback(e.boolean(), !1),
	configuration: Ne,
	contact_account: e.fallback(e.optional(y), void 0),
	description: e.fallback(e.string(), ""),
	description_limit: e.fallback(e.number(), 1500),
	email: e.fallback(e.pipe(e.string(), e.email()), ""),
	feature_quote: e.fallback(e.boolean(), !1),
	languages: e.fallback(e.array(e.string()), []),
	max_media_attachments: e.fallback(e.optional(e.number()), void 0),
	max_toot_chars: e.fallback(e.optional(e.number()), void 0),
	pleroma: Fe,
	poll_limits: Ie,
	registrations: e.fallback(e.boolean(), !1),
	rules: _(Ee),
	short_description: e.fallback(e.string(), ""),
	stats: Re,
	thumbnail: e.fallback(e.string(), ""),
	title: e.fallback(e.string(), ""),
	upload_limit: e.fallback(e.optional(e.number()), void 0),
	uri: e.fallback(e.string(), ""),
	urls: v({ streaming_api: e.fallback(e.optional(e.pipe(e.string(), e.url())), void 0) }),
	usage: Be,
	version: e.fallback(e.string(), "0.0.0")
}), He = e.pipe(e.any(), e.transform((e) => {
	e.source_url === "https://github.com/fedify-dev/hollo" && (e.version = `0.0.0 (compatible; Hollo ${e.version})`), typeof e.configuration?.accounts?.allow_custom_css == "boolean" && (e.version = `0.0.0 (compatible; GoToSocial ${e.version})`);
	let t = ke(e);
	if (e.pleroma ||= { metadata: { post_formats: e.configuration?.statuses?.supported_mime_types || (t["kmyblue_markdown.fedibird.pl-api"] ? ["text/plain", "text/markdown"] : e.version?.includes("Sharkey") ? ["text/x.misskeymarkdown"] : []) } }, e.pleroma?.metadata?.restrict_unauthenticated?.timelines) {
		let t = e.pleroma.metadata.restrict_unauthenticated.timelines, n = e.pleroma.metadata.features || [];
		e.configuration ||= {}, e.configuration.timelines_access = {
			...e.configuration.timelines_access,
			live_feeds: {
				bubble: t.bubble ? "authenticated" : n.includes("bubble_timeline") ? "public" : "disabled",
				local: t.local ? "authenticated" : "public",
				remote: t.federated ? "authenticated" : "public",
				wrenched: t.wrenched ? "authenticated" : n.includes("pleroma:wrenched_timeline") ? "public" : "disabled"
			}
		};
	}
	return e.domain ? {
		account_domain: e.domain,
		...e,
		api_versions: t
	} : {
		...Ae(e),
		api_versions: t
	};
}), v({
	account_domain: e.fallback(e.string(), ""),
	api_versions: e.fallback(e.record(e.string(), e.number()), {}),
	configuration: Ne,
	contact: Pe,
	description: e.fallback(e.string(), ""),
	domain: e.fallback(e.string(), ""),
	feature_quote: e.fallback(e.boolean(), !1),
	icons: _(e.object({
		size: e.pipe(e.string(), e.regex(/^[0-9]+x[0-9]+$/)),
		src: e.string()
	})),
	languages: e.fallback(e.array(e.string()), []),
	pleroma: Fe,
	registrations: Le,
	rules: _(Ee),
	stats: Re,
	thumbnail: ze,
	title: e.fallback(e.string(), ""),
	usage: Be,
	version: e.pipe(e.fallback(e.string(), "0.0.0"), e.transform(Me)),
	blockchains: e.fallback(e.optional(_(e.object({
		chain_id: e.fallback(e.nullable(e.string()), null),
		chain_metadata: v({
			is_forwarding_required: e.fallback(e.boolean(), !1),
			description: e.fallback(e.string(), ""),
			payment_amount_min: e.number()
		}),
		features: v({ subscriptions: e.fallback(e.boolean(), !1) })
	}))), void 0)
})), Ue = /* @__PURE__ */ f(((e, t) => {
	t.exports = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...e) => console.error("SEMVER", ...e) : () => {};
})), We = /* @__PURE__ */ f(((e, t) => {
	var n = "2.0.0", r = 256;
	t.exports = {
		MAX_LENGTH: r,
		MAX_SAFE_COMPONENT_LENGTH: 16,
		MAX_SAFE_BUILD_LENGTH: r - 6,
		MAX_SAFE_INTEGER: 2 ** 53 - 1 || 9007199254740991,
		RELEASE_TYPES: [
			"major",
			"premajor",
			"minor",
			"preminor",
			"patch",
			"prepatch",
			"prerelease"
		],
		SEMVER_SPEC_VERSION: n,
		FLAG_INCLUDE_PRERELEASE: 1,
		FLAG_LOOSE: 2
	};
})), Ge = /* @__PURE__ */ f(((e, t) => {
	var { MAX_SAFE_COMPONENT_LENGTH: n, MAX_SAFE_BUILD_LENGTH: r, MAX_LENGTH: i } = We(), a = Ue();
	e = t.exports = {};
	var o = e.re = [], s = e.safeRe = [], c = e.src = [], l = e.safeSrc = [], u = e.t = {}, d = 0, f = "[a-zA-Z0-9-]", ee = [
		["\\s", 1],
		["\\d", i],
		[f, r]
	], te = (e) => {
		for (let [t, n] of ee) e = e.split(`${t}*`).join(`${t}{0,${n}}`).split(`${t}+`).join(`${t}{1,${n}}`);
		return e;
	}, p = (e, t, n) => {
		let r = te(t), i = d++;
		a(e, i, t), u[e] = i, c[i] = t, l[i] = r, o[i] = new RegExp(t, n ? "g" : void 0), s[i] = new RegExp(r, n ? "g" : void 0);
	};
	p("NUMERICIDENTIFIER", "0|[1-9]\\d*"), p("NUMERICIDENTIFIERLOOSE", "\\d+"), p("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${f}*`), p("MAINVERSION", `(${c[u.NUMERICIDENTIFIER]})\\.(${c[u.NUMERICIDENTIFIER]})\\.(${c[u.NUMERICIDENTIFIER]})`), p("MAINVERSIONLOOSE", `(${c[u.NUMERICIDENTIFIERLOOSE]})\\.(${c[u.NUMERICIDENTIFIERLOOSE]})\\.(${c[u.NUMERICIDENTIFIERLOOSE]})`), p("PRERELEASEIDENTIFIER", `(?:${c[u.NONNUMERICIDENTIFIER]}|${c[u.NUMERICIDENTIFIER]})`), p("PRERELEASEIDENTIFIERLOOSE", `(?:${c[u.NONNUMERICIDENTIFIER]}|${c[u.NUMERICIDENTIFIERLOOSE]})`), p("PRERELEASE", `(?:-(${c[u.PRERELEASEIDENTIFIER]}(?:\\.${c[u.PRERELEASEIDENTIFIER]})*))`), p("PRERELEASELOOSE", `(?:-?(${c[u.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${c[u.PRERELEASEIDENTIFIERLOOSE]})*))`), p("BUILDIDENTIFIER", `${f}+`), p("BUILD", `(?:\\+(${c[u.BUILDIDENTIFIER]}(?:\\.${c[u.BUILDIDENTIFIER]})*))`), p("FULLPLAIN", `v?${c[u.MAINVERSION]}${c[u.PRERELEASE]}?${c[u.BUILD]}?`), p("FULL", `^${c[u.FULLPLAIN]}$`), p("LOOSEPLAIN", `[v=\\s]*${c[u.MAINVERSIONLOOSE]}${c[u.PRERELEASELOOSE]}?${c[u.BUILD]}?`), p("LOOSE", `^${c[u.LOOSEPLAIN]}$`), p("GTLT", "((?:<|>)?=?)"), p("XRANGEIDENTIFIERLOOSE", `${c[u.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), p("XRANGEIDENTIFIER", `${c[u.NUMERICIDENTIFIER]}|x|X|\\*`), p("XRANGEPLAIN", `[v=\\s]*(${c[u.XRANGEIDENTIFIER]})(?:\\.(${c[u.XRANGEIDENTIFIER]})(?:\\.(${c[u.XRANGEIDENTIFIER]})(?:${c[u.PRERELEASE]})?${c[u.BUILD]}?)?)?`), p("XRANGEPLAINLOOSE", `[v=\\s]*(${c[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${c[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${c[u.XRANGEIDENTIFIERLOOSE]})(?:${c[u.PRERELEASELOOSE]})?${c[u.BUILD]}?)?)?`), p("XRANGE", `^${c[u.GTLT]}\\s*${c[u.XRANGEPLAIN]}$`), p("XRANGELOOSE", `^${c[u.GTLT]}\\s*${c[u.XRANGEPLAINLOOSE]}$`), p("COERCEPLAIN", `(^|[^\\d])(\\d{1,${n}})(?:\\.(\\d{1,${n}}))?(?:\\.(\\d{1,${n}}))?`), p("COERCE", `${c[u.COERCEPLAIN]}(?:$|[^\\d])`), p("COERCEFULL", c[u.COERCEPLAIN] + `(?:${c[u.PRERELEASE]})?(?:${c[u.BUILD]})?(?:$|[^\\d])`), p("COERCERTL", c[u.COERCE], !0), p("COERCERTLFULL", c[u.COERCEFULL], !0), p("LONETILDE", "(?:~>?)"), p("TILDETRIM", `(\\s*)${c[u.LONETILDE]}\\s+`, !0), e.tildeTrimReplace = "$1~", p("TILDE", `^${c[u.LONETILDE]}${c[u.XRANGEPLAIN]}$`), p("TILDELOOSE", `^${c[u.LONETILDE]}${c[u.XRANGEPLAINLOOSE]}$`), p("LONECARET", "(?:\\^)"), p("CARETTRIM", `(\\s*)${c[u.LONECARET]}\\s+`, !0), e.caretTrimReplace = "$1^", p("CARET", `^${c[u.LONECARET]}${c[u.XRANGEPLAIN]}$`), p("CARETLOOSE", `^${c[u.LONECARET]}${c[u.XRANGEPLAINLOOSE]}$`), p("COMPARATORLOOSE", `^${c[u.GTLT]}\\s*(${c[u.LOOSEPLAIN]})$|^$`), p("COMPARATOR", `^${c[u.GTLT]}\\s*(${c[u.FULLPLAIN]})$|^$`), p("COMPARATORTRIM", `(\\s*)${c[u.GTLT]}\\s*(${c[u.LOOSEPLAIN]}|${c[u.XRANGEPLAIN]})`, !0), e.comparatorTrimReplace = "$1$2$3", p("HYPHENRANGE", `^\\s*(${c[u.XRANGEPLAIN]})\\s+-\\s+(${c[u.XRANGEPLAIN]})\\s*$`), p("HYPHENRANGELOOSE", `^\\s*(${c[u.XRANGEPLAINLOOSE]})\\s+-\\s+(${c[u.XRANGEPLAINLOOSE]})\\s*$`), p("STAR", "(<|>)?=?\\s*\\*"), p("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), p("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})), Ke = /* @__PURE__ */ f(((e, t) => {
	var n = Object.freeze({ loose: !0 }), r = Object.freeze({});
	t.exports = (e) => e ? typeof e == "object" ? e : n : r;
})), qe = /* @__PURE__ */ f(((e, t) => {
	var n = /^[0-9]+$/, r = (e, t) => {
		if (typeof e == "number" && typeof t == "number") return e === t ? 0 : e < t ? -1 : 1;
		let r = n.test(e), i = n.test(t);
		return r && i && (e = +e, t = +t), e === t ? 0 : r && !i ? -1 : i && !r ? 1 : e < t ? -1 : 1;
	};
	t.exports = {
		compareIdentifiers: r,
		rcompareIdentifiers: (e, t) => r(t, e)
	};
})), Je = /* @__PURE__ */ f(((e, t) => {
	var n = Ue(), { MAX_LENGTH: r, MAX_SAFE_INTEGER: i } = We(), { safeRe: a, t: o } = Ge(), s = Ke(), { compareIdentifiers: c } = qe(), l = (e, t) => {
		let n = t.split(".");
		if (n.length > e.length) return !1;
		for (let t = 0; t < n.length; t++) if (c(e[t], n[t]) !== 0) return !1;
		return !0;
	};
	t.exports = class e {
		constructor(t, c) {
			if (c = s(c), t instanceof e) {
				if (t.loose === !!c.loose && t.includePrerelease === !!c.includePrerelease) return t;
				t = t.version;
			} else if (typeof t != "string") throw TypeError(`Invalid version. Must be a string. Got type "${typeof t}".`);
			if (t.length > r) throw TypeError(`version is longer than ${r} characters`);
			n("SemVer", t, c), this.options = c, this.loose = !!c.loose, this.includePrerelease = !!c.includePrerelease;
			let l = t.trim().match(c.loose ? a[o.LOOSE] : a[o.FULL]);
			if (!l) throw TypeError(`Invalid Version: ${t}`);
			if (this.raw = t, this.major = +l[1], this.minor = +l[2], this.patch = +l[3], this.major > i || this.major < 0) throw TypeError("Invalid major version");
			if (this.minor > i || this.minor < 0) throw TypeError("Invalid minor version");
			if (this.patch > i || this.patch < 0) throw TypeError("Invalid patch version");
			l[4] ? this.prerelease = l[4].split(".").map((e) => {
				if (/^[0-9]+$/.test(e)) {
					let t = +e;
					if (t >= 0 && t < i) return t;
				}
				return e;
			}) : this.prerelease = [], this.build = l[5] ? l[5].split(".") : [], this.format();
		}
		format() {
			return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
		}
		toString() {
			return this.version;
		}
		compare(t) {
			if (n("SemVer.compare", this.version, this.options, t), !(t instanceof e)) {
				if (typeof t == "string" && t === this.version) return 0;
				t = new e(t, this.options);
			}
			return t.version === this.version ? 0 : this.compareMain(t) || this.comparePre(t);
		}
		compareMain(t) {
			return t instanceof e || (t = new e(t, this.options)), this.major < t.major ? -1 : this.major > t.major ? 1 : this.minor < t.minor ? -1 : this.minor > t.minor ? 1 : this.patch < t.patch ? -1 : +(this.patch > t.patch);
		}
		comparePre(t) {
			if (t instanceof e || (t = new e(t, this.options)), this.prerelease.length && !t.prerelease.length) return -1;
			if (!this.prerelease.length && t.prerelease.length) return 1;
			if (!this.prerelease.length && !t.prerelease.length) return 0;
			let r = 0;
			do {
				let e = this.prerelease[r], i = t.prerelease[r];
				if (n("prerelease compare", r, e, i), e === void 0 && i === void 0) return 0;
				if (i === void 0) return 1;
				if (e === void 0) return -1;
				if (e === i) continue;
				return c(e, i);
			} while (++r);
		}
		compareBuild(t) {
			t instanceof e || (t = new e(t, this.options));
			let r = 0;
			do {
				let e = this.build[r], i = t.build[r];
				if (n("build compare", r, e, i), e === void 0 && i === void 0) return 0;
				if (i === void 0) return 1;
				if (e === void 0) return -1;
				if (e === i) continue;
				return c(e, i);
			} while (++r);
		}
		inc(e, t, n) {
			if (e.startsWith("pre")) {
				if (!t && n === !1) throw Error("invalid increment argument: identifier is empty");
				if (t) {
					let e = `-${t}`.match(this.options.loose ? a[o.PRERELEASELOOSE] : a[o.PRERELEASE]);
					if (!e || e[1] !== t) throw Error(`invalid identifier: ${t}`);
				}
			}
			switch (e) {
				case "premajor":
					this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", t, n);
					break;
				case "preminor":
					this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", t, n);
					break;
				case "prepatch":
					this.prerelease.length = 0, this.inc("patch", t, n), this.inc("pre", t, n);
					break;
				case "prerelease":
					this.prerelease.length === 0 && this.inc("patch", t, n), this.inc("pre", t, n);
					break;
				case "release":
					if (this.prerelease.length === 0) throw Error(`version ${this.raw} is not a prerelease`);
					this.prerelease.length = 0;
					break;
				case "major":
					(this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
					break;
				case "minor":
					(this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
					break;
				case "patch":
					this.prerelease.length === 0 && this.patch++, this.prerelease = [];
					break;
				case "pre": {
					let e = +!!Number(n);
					if (this.prerelease.length === 0) this.prerelease = [e];
					else {
						let r = this.prerelease.length;
						for (; --r >= 0;) typeof this.prerelease[r] == "number" && (this.prerelease[r]++, r = -2);
						if (r === -1) {
							if (t === this.prerelease.join(".") && n === !1) throw Error("invalid increment argument: identifier already exists");
							this.prerelease.push(e);
						}
					}
					if (t) {
						let r = [t, e];
						if (n === !1 && (r = [t]), l(this.prerelease, t)) {
							let e = this.prerelease[t.split(".").length];
							isNaN(e) && (this.prerelease = r);
						} else this.prerelease = r;
					}
					break;
				}
				default: throw Error(`invalid increment argument: ${e}`);
			}
			return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
		}
	};
})), Ye = /* @__PURE__ */ f(((e, t) => {
	var n = Je();
	t.exports = (e, t, r = !1) => {
		if (e instanceof n) return e;
		try {
			return new n(e, t);
		} catch (e) {
			if (!r) return null;
			throw e;
		}
	};
})), Xe = /* @__PURE__ */ f(((e, t) => {
	var n = Je(), r = Ye(), { safeRe: i, t: a } = Ge();
	t.exports = (e, t) => {
		if (e instanceof n) return e;
		if (typeof e == "number" && (e = String(e)), typeof e != "string") return null;
		t ||= {};
		let o = null;
		if (!t.rtl) o = e.match(t.includePrerelease ? i[a.COERCEFULL] : i[a.COERCE]);
		else {
			let n = t.includePrerelease ? i[a.COERCERTLFULL] : i[a.COERCERTL], r;
			for (; (r = n.exec(e)) && (!o || o.index + o[0].length !== e.length);) (!o || r.index + r[0].length !== o.index + o[0].length) && (o = r), n.lastIndex = r.index + r[1].length + r[2].length;
			n.lastIndex = -1;
		}
		if (o === null) return null;
		let s = o[2];
		return r(`${s}.${o[3] || "0"}.${o[4] || "0"}${t.includePrerelease && o[5] ? `-${o[5]}` : ""}${t.includePrerelease && o[6] ? `+${o[6]}` : ""}`, t);
	};
})), Ze = /* @__PURE__ */ f(((e, t) => {
	var n = Je();
	t.exports = (e, t, r) => new n(e, r).compare(new n(t, r));
})), Qe = /* @__PURE__ */ f(((e, t) => {
	var n = Ze();
	t.exports = (e, t, r) => n(e, t, r) > 0;
})), $e = /* @__PURE__ */ f(((e, t) => {
	var n = Ze();
	t.exports = (e, t, r) => n(e, t, r) >= 0;
})), et = /* @__PURE__ */ te(Xe(), 1), tt = /* @__PURE__ */ te(Qe(), 1), b = /* @__PURE__ */ te($e(), 1), nt = /* @__PURE__ */ te(Ye(), 1), x = (e) => e.some(Boolean), S = "Ditto", rt = "Egregoros", C = "Firefish", w = "Friendica", T = "GoToSocial", E = "Hollo", D = "Iceshrimp", O = "Iceshrimp.NET", k = "Mastodon", A = "Mitra", j = "NeoDB", M = "Pixelfed", N = "Pleroma", P = "Sharkey", F = "snac", it = "Takahe", I = "Toki", at = "WordPress", L = "Akkoma", ot = "glitch", st = "hometown", ct = "unreleased", lt = (e) => {
	let t = ut(e.version || ""), n = !!e.pleroma.metadata.federation.enabled;
	return {
		version: t,
		accountAvatarDescription: x([
			t.software === "Akkoma" && (0, b.default)(t.version, "3.19.0"),
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"),
			t.software === O,
			t.software === "Pleroma" && (0, b.default)(t.version, "2.8.0"),
			e.api_versions.chuckya >= 1,
			e.api_versions.mastodon >= 11
		]),
		accountBackups: x([t.software === L, t.software === N]),
		accountByUsername: x([
			t.software === L,
			t.software === A,
			t.software === N
		]),
		accountCreation: !0,
		accountDiscoverability: x([
			t.software === w,
			t.software === T,
			t.software === E,
			t.software === k,
			t.software === A,
			t.software === P,
			e.api_versions["profile_directory.pleroma.pl-api"] >= 1
		]),
		accountEnableRss: t.software === T,
		accountEndorsements: x([t.software === "Pleroma" && (0, b.default)(t.version, "2.5.0"), e.api_versions.mastodon >= 6]),
		accountIsCat: e.api_versions["is_cat.pleroma.pl-api"] >= 1,
		accountLocation: x([e.api_versions["account_location.pleroma.pl-api"] >= 1]),
		accountLookup: x([
			t.software === L,
			t.software === S,
			t.software === C,
			t.software === T,
			t.software === E,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === A,
			t.software === j,
			t.software === "Pleroma" && (0, b.default)(t.version, "2.5.0"),
			t.software === P,
			t.software === F,
			t.software === "Takahe" && (0, b.default)(t.version, "0.6.1"),
			t.software === I,
			t.software === at
		]),
		accountMentionPolicy: x([t.software === A]),
		accountMoving: x([t.software === L, t.software === "Pleroma" && (0, b.default)(t.version, "2.5.0")]),
		accountNotifies: x([
			t.software === L,
			t.software === T,
			t.software === k,
			t.software === "Pleroma" && (0, b.default)(t.version, "2.5.0")
		]),
		accountNotifiesControl: e.api_versions["notifies_control.pleroma.pl-api"] >= 1,
		accountWebIncludeBoosts: t.software === "GoToSocial" && (0, b.default)(t.version, "0.21.0"),
		accountWebLayout: x([t.software === "GoToSocial" && (0, b.default)(t.version, "0.19.0")]),
		accountWebVisibility: x([t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0")]),
		addressableLists: x([t.software === L, t.software === N]),
		adminCanonicalEmailBlocks: t.software === "Mastodon" && (0, b.default)(t.version, "3.5.0"),
		adminCustomEmojis: t.software === T,
		adminCustomEmojiCategories: t.software === T,
		adminDeleteStatus: x([
			t.software === L,
			t.software === O,
			t.software === A,
			t.software === N
		]),
		adminDomainBlocks: x([
			t.software === L,
			t.software === T,
			t.software === k,
			t.software === N
		]),
		adminDomainKeysExpire: t.software === T,
		adminDomainLimits: t.software === T,
		adminDomainPermissionSubscriptions: t.software === "GoToSocial" && (0, b.default)(t.version, "0.18.0"),
		adminEmailDomainBlocks: t.software === "Mastodon" && (0, b.default)(t.version, "4.1.0"),
		adminEmailTest: t.software === T,
		adminHeaderFilters: t.software === "GoToSocial" && (0, b.default)(t.version, "0.16.0"),
		adminInstances: t.software === T,
		adminIpBlocks: t.software === "Mastodon" && (0, b.default)(t.version, "4.0.0"),
		adminMediaModeration: t.software === T,
		adminRelaySubscriptions: t.software === T,
		adminReportForwarding: t.software === O,
		adminRules: x([t.software === T, t.software === "Pleroma" && (0, b.default)(t.version, "2.7.0")]),
		adminRulesPriority: x([t.software === "Pleroma" && (0, b.default)(t.version, "2.7.0")]),
		announcements: x([
			t.software === L,
			t.software === C,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === j,
			t.software === N,
			t.software === P,
			t.software === F,
			t.software === "Takahe" && (0, b.default)(t.version, "0.7.0")
		]),
		announcementsReactions: t.software === k,
		antennas: e.api_versions["kmyblue_antenna.fedibird.pl-api"] >= 1,
		birthdays: t.software === N,
		bites: x([
			t.software === O,
			t.software === I,
			e.api_versions["bites.pleroma.pl-api"] >= 1
		]),
		biteStatuses: t.software === O,
		blockersVisible: !x([t.software === "Pleroma", t.software === "Akkoma"]) || e.api_versions["blockers_visible.pleroma.pl-api"] >= 1,
		blocksDuration: e.api_versions["block_expiration.pleroma.pl-api"] >= 1,
		bookmarkFolderEmojis: e.api_versions["bookmark_folders.pleroma.pl-api"] >= 1,
		bookmarkFolders: x([e.api_versions["bookmark_folders.pleroma.pl-api"] >= 1, e.api_versions["kmyblue_bookmark_category.fedibird.pl-api"] >= 1]),
		bookmarkFoldersMultiple: e.api_versions["kmyblue_bookmark_category.fedibird.pl-api"] >= 1,
		bookmarks: x([
			t.software === L,
			t.software === S,
			t.software === C,
			t.software === T,
			t.software === E,
			t.software === D,
			t.software === O,
			t.software === w,
			t.software === k,
			t.software === "Mitra" && (0, b.default)(t.version, "3.3.0"),
			t.software === j,
			t.software === M,
			t.software === N,
			t.software === P,
			t.software === "Takahe" && (0, b.default)(t.version, "0.9.0"),
			t.software === I
		]),
		bots: x([
			t.software === L,
			t.software === T,
			t.software === E,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === "Mitra" && (0, b.default)(t.version, "3.22.0"),
			t.software === M,
			t.software === N,
			t.software === F
		]),
		bubbleDomainList: e.api_versions.chuckya >= 1,
		bubbleTimeline: x([e.api_versions["bubble_timeline.pleroma.pl-api"] >= 1, t.software === O]),
		bubbleTimelineStreaming: t.software === O,
		changeEmail: x([
			t.software === L,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.16.0"),
			t.software === N
		]),
		changePassword: x([
			t.software === L,
			t.software === T,
			t.software === O,
			t.software === A,
			t.software === M,
			t.software === N
		]),
		chats: e.api_versions["chat_messages.pleroma.pl-api"] >= 1,
		chatsDelete: x([e.api_versions["chat_delete.pleroma.pl-api"] >= 1]),
		circles: e.api_versions["kmyblue_circle_history.fedibird.pl-api"] >= 1,
		collections: e.api_versions.mastodon >= 10,
		composeAllowHeadings: x([t.software !== "Pleroma" && t.software !== "Akkoma", e.pleroma.metadata.markup.allow_headings]),
		composeAllowInlineImages: e.pleroma.metadata.markup.allow_inline_images,
		conversations: x([
			t.software === L,
			t.software === C,
			t.software === w,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"),
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === j,
			t.software === M,
			t.software === N,
			t.software === P,
			t.software === it
		]),
		conversationsByRecipients: x([t.software === L, t.software === N]),
		createStatusConversationScope: t.software === A,
		createStatusExpiration: x([t.software === L, t.software === N]),
		createStatusExplicitAddressing: x([t.software === S, e.api_versions["explicit_addressing.pleroma.pl-api"] >= 1]),
		createStatusReplyToConversation: x([t.software === L, t.software === N]),
		createStatusListScope: x([t.software === L, t.software === N]),
		createStatusLocalScope: x([
			t.software === L,
			t.software === O,
			t.software === N
		]),
		createStatusMutualsOnlyScope: t.software === T,
		createStatusSubscribersScope: t.software === A,
		createStatusPreview: x([
			t.software === L,
			t.software === N,
			t.software === A
		]),
		customEmojiReacts: x([
			e.api_versions["custom_emoji_reactions.pleroma.pl-api"] >= 1,
			t.software === "Ditto" && (0, tt.default)(t.version, "1.2.0"),
			t.software === E,
			t.software === "Mitra" && (0, b.default)(t.version, "3.4.0")
		]),
		deleteAccount: x([
			t.software === L,
			t.software === T,
			t.software === N
		]),
		deleteAccountWithoutPassword: t.software === "Mitra" && (0, b.default)(t.version, "2.14.0"),
		deleteMedia: e.api_versions.mastodon >= 4,
		disableMfaWithCode: t.software === O,
		domains: x([e.pleroma.metadata.multitenancy.enabled]),
		drive: t.software === O,
		editProfile: x([
			t.software === L,
			t.software === C,
			t.software === w,
			t.software === T,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === A,
			t.software === j,
			t.software === M,
			t.software === N,
			t.software === "Takahe" && (0, b.default)(t.version, "0.7.0"),
			t.software === I
		]),
		editStatuses: x([
			t.software === C,
			t.software === "Friendica" && (0, b.default)(t.version, "2022.12.0"),
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.18.0"),
			t.software === E,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === A,
			t.software === j,
			t.software === P,
			t.software === "Takahe" && (0, b.default)(t.version, "0.8.0"),
			e.api_versions["editing.pleroma.pl-api"] >= 1
		]),
		embeds: t.software === k,
		emojiReacts: x([
			t.software === L,
			t.software === C,
			t.software === E,
			t.software === "Mitra" && (0, b.default)(t.version, "2.21.0"),
			t.software === N,
			e ? e.configuration.reactions.max_reactions > 0 : !1
		]),
		emojiReactsList: x([
			t.software === L,
			t.software === O,
			t.software === N,
			e.api_versions["emoji_reaction.fedibird.pl-api"] >= 1
		]),
		events: e.api_versions["events.pleroma.pl-api"] >= 1,
		exportBlocks: t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"),
		exportFollowers: x([t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"), t.software === "Mitra" && (0, b.default)(t.version, "1.27.0")]),
		exportFollows: x([t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"), t.software === "Mitra" && (0, b.default)(t.version, "1.27.0")]),
		exportLists: t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"),
		exportMutes: t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"),
		exposableReactions: x([
			t.software === C,
			t.software === w,
			t.software === T,
			t.software === E,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === "Mitra" && (0, b.default)(t.version, "4.5.0"),
			t.software === j,
			t.software === P,
			t.software === "Takahe" && (0, b.default)(t.version, "0.6.1"),
			t.software === I,
			e.api_versions["exposable_reactions.pleroma.pl-api"] >= 1
		]),
		familiarFollowers: x([
			t.software === S,
			t.software === E,
			t.software === k,
			t.software === j,
			t.software === M,
			t.software === "Pleroma" && (0, b.default)(t.version, "2.7.0"),
			t.software === it
		]),
		featuredTags: x([
			t.software === E,
			t.software === k,
			t.software === j,
			t.software === "Takahe" && (0, b.default)(t.version, "0.12.0")
		]),
		federating: n,
		filters: x([
			t.software === L,
			t.software === T,
			t.software === N,
			t.software === P
		]),
		filtersV2: x([
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.16.0"),
			t.software === O,
			t.software === k
		]),
		filtersV2BlurAction: x([t.software === "GoToSocial" && (0, b.default)(t.version, "0.20.0"), t.software === "Mastodon" && (0, b.default)(t.version, "4.4.0")]),
		focalPoint: x([t.software === T, t.software === k]),
		followedHashtagsList: x([
			t.software === L,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"),
			t.software === E,
			t.software === "Mastodon" && (0, b.default)(t.compatVersion, "4.1.0"),
			t.software === j,
			t.software === M,
			t.software === "Pleroma" && (0, b.default)(t.version, "2.9.0"),
			t.software === "Takahe" && (0, b.default)(t.version, "0.9.0")
		]),
		followHashtags: x([
			t.software === L,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"),
			t.software === E,
			t.software === "Mastodon" && (0, b.default)(t.compatVersion, "4.0.0"),
			t.software === j,
			t.software === M,
			t.software === "Pleroma" && (0, b.default)(t.version, "2.9.0"),
			t.software === "Takahe" && (0, b.default)(t.version, "0.9.0")
		]),
		followRequests: x([
			t.software === L,
			t.software === C,
			t.software === T,
			t.software === E,
			t.software === k,
			t.software === A,
			t.software === N,
			t.software === "snac" && (0, b.default)(t.version, "2.78.0"),
			t.software === I
		]),
		frontendConfigurations: x([
			t.software === L,
			t.software === S,
			t.software === "Mitra" && (0, b.default)(t.version, "1.20.0"),
			t.software === N
		]),
		getAccounts: x([t.software === O, t.software === "Mastodon" && (0, b.default)(t.version, "4.3.0")]),
		getStatuses: x([
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.22.0"),
			t.software === O,
			t.software === "Mastodon" && (0, b.default)(t.version, "4.3.0"),
			t.software === "Mitra" && (0, tt.default)(t.version, "5.7.1")
		]),
		grantTypePassword: !x([
			t.software === T,
			t.software === D,
			t.software === "Mastodon" && (0, b.default)(t.version, "4.4.0"),
			t.software === P
		]),
		groupedNotifications: x([
			e.api_versions.mastodon >= 2,
			t.software === "Hollo" && (0, b.default)(t.version, "0.7.0"),
			e.api_versions["mastodon_api_grouped_notifications.pleroma.pl-api"] >= 1
		]),
		gifPicker: e.configuration.gif_search.enabled,
		groups: x([t.software === M, e.api_versions["groups.pleroma.pl-api"] >= 1]),
		groupsSlugs: e.api_versions["groups.pleroma.pl-api"] >= 1,
		hideNetwork: x([
			t.software === L,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.15.0"),
			t.software === N
		]),
		iceshrimpAdmin: t.software === O,
		importArchives: e.api_versions["import_archives.pleroma.pl-api"] >= 1,
		importBlocks: x([
			t.software === L,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"),
			t.software === O,
			t.software === N
		]),
		importFollowers: x([t.software === "Mitra" && (0, b.default)(t.version, "2.18.0")]),
		importFollows: x([
			t.software === L,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"),
			t.software === O,
			t.software === "Mitra" && (0, b.default)(t.version, "1.10.0"),
			t.software === N
		]),
		importMutes: x([
			t.software === L,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.19.0"),
			t.software === O,
			t.software === N
		]),
		importOverwrite: t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"),
		instanceTimeline: x([
			t.software === L,
			t.software === O,
			t.software === "Pleroma" && (0, b.default)(t.version, "2.7.0")
		]),
		instanceV2: x([
			t.software === C,
			t.software === T,
			t.software === "Mastodon" && (0, b.default)(t.compatVersion, "4.0.0"),
			t.software === "Mitra" && (0, b.default)(t.version, "2.18.0"),
			t.software === "Pleroma" && (0, b.default)(t.version, "2.7.0")
		]),
		interactionRequests: t.software === "GoToSocial" && (0, b.default)(t.version, "0.17.0"),
		languageDetection: e.api_versions["language_detection.pleroma.pl-api"] >= 1,
		lazyTranslations: e.api_versions["translations.pl.pl-api"] >= 1,
		lists: x([
			t.software === L,
			t.software === C,
			t.software === w,
			t.software === T,
			t.software === E,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === A,
			t.software === j,
			t.software === N,
			t.software === P,
			t.software === F,
			t.software === "Takahe" && (0, b.default)(t.version, "0.12.0")
		]),
		listsExclusive: x([
			t.software === T,
			t.software === E,
			t.software === O,
			t.software === "Mastodon" && (0, b.default)(t.version, "4.2.0"),
			t.software === j,
			t.software === "Takahe" && (0, b.default)(t.version, "0.12.0")
		]),
		listsFavourites: e.api_versions["favourite_list.fedibird.pl-api"] >= 1,
		listsNotifications: e.api_versions["kmyblue_list_notification.fedibird.pl-api"] >= 1,
		listsRepliesPolicy: x([
			t.software === "Friendica" && (0, b.default)(t.version, "2024.12.0"),
			t.software === T,
			t.software === E,
			t.software === "Mastodon" && (0, b.default)(t.version, "3.3.0"),
			t.software === j,
			t.software === "Takahe" && (0, b.default)(t.version, "0.12.0")
		]),
		loadActivities: t.software === "Mitra" && (0, b.default)(t.version, "2.16.0"),
		loadConversation: t.software === "Mitra" && (0, b.default)(t.version, "2.25.0"),
		localOnlyStatuses: n && x([t.software === "GoToSocial", t.software === "Mastodon" && t.build === "hometown"]),
		logInWithUsername: x([
			t.software === L,
			t.software === O,
			t.software === A,
			t.software === N,
			t.software === I
		]),
		manageAccountAliases: x([t.software === L, t.software === N]),
		manageMfa: x([
			t.software === L,
			t.software === O,
			t.software === N,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.19.0")
		]),
		manageMfaBackupCodes: x([t.software === L, t.software === N]),
		manageMfaRequiresPassword: x([t.software === L, t.software === N]),
		mastodonAdmin: x([
			t.software === S,
			t.software === T,
			t.software === k,
			e.api_versions["mastodon_admin_api.pleroma.pl-api"] >= 1
		]),
		mastodonAdminResolveReportWithComment: t.software === T,
		mastodonAdminMetrics: t.software === "Mastodon" && (0, b.default)(t.version, "3.5.0"),
		mastodonAdminUnresolvedReports: x([t.software === "GoToSocial" && (0, b.default)(t.version, "0.22.0"), e.api_versions["mastodon_admin_api.pleroma.pl-api"] >= 1]),
		mastodonAdminV2: x([
			t.software === T,
			t.software === "Mastodon" && (0, b.default)(t.version, "3.5.0"),
			e.api_versions["mastodon_admin_api.pleroma.pl-api"] >= 1
		]),
		mediaV2: x([
			t.software === L,
			t.software === C,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === A,
			t.software === j,
			t.software === N,
			t.software === it,
			t.software === I,
			t.software === at
		]),
		multiLanguage: e.api_versions["multi_language.pleroma.pl-api"] >= 1,
		mutedThreads: t.software === O,
		muteStrangers: x([t.software === L, t.software === N]),
		mutes: x([
			t.software === L,
			t.software === C,
			t.software === w,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.16.0"),
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === A,
			t.software === j,
			t.software === M,
			t.software === N,
			t.software === P,
			t.software === it
		]),
		mutesDuration: x([
			t.software === L,
			t.software === C,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.16.0"),
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === j,
			t.software === N,
			t.software === it
		]),
		notes: x([
			t.software === L,
			t.software === T,
			t.software === O,
			t.software === k,
			t.software === "Pleroma" && (0, b.default)(t.version, "2.5.0")
		]),
		notificationsDismissMultiple: x([t.software === L, t.software === N]),
		notificationsExcludeTypes: t.software !== A,
		notificationsExcludeVisibilities: x([t.software === L, t.software === N]),
		notificationsGetUnreadCount: e.api_versions.mastodon >= 1,
		notificationsIncludeTypes: x([
			t.software === L,
			t.software === C,
			t.software === T,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === j,
			t.software === "Pleroma" && (0, b.default)(t.version, "2.5.0"),
			t.software === "Takahe" && (0, b.default)(t.version, "0.6.2")
		]),
		notificationsPolicy: e.api_versions.mastodon >= 1,
		notificationsRequestsAcceptMultiple: e.api_versions.mastodon >= 1,
		outgoingFollowRequests: x([
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.20.0"),
			t.software === O,
			t.software === "Mitra" && (0, b.default)(t.version, "4.19.0"),
			e.api_versions["outgoing_follow_requests.pleroma.pl-api"] >= 1
		]),
		pleromaAdminAccounts: x([t.software === L, t.software === N]),
		pleromaAdminAnnouncements: x([t.software === L, t.software === N]),
		pleromaAdminConfig: x([t.software === L, t.software === N]),
		pleromaAdminInvites: x([t.software === L, t.software === N]),
		pleromaAdminModerationLog: x([t.software === L, t.software === N]),
		pleromaAdminRelays: x([t.software === L, t.software === N]),
		pleromaAdminStatuses: x([t.software === L, t.software === N]),
		pleromaAdminStatusesRedact: e.api_versions["admin_statuses_redact.pleroma.pl-api"] >= 1,
		pleromaRemoteFollow: x([t.software === L, t.software === N]),
		polls: x([
			t.software === C,
			t.software === T,
			t.software === E,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === "Mitra" && (0, b.default)(t.version, "3.15.0"),
			t.software === j,
			t.software === P,
			t.software === "snac" && (0, b.default)(t.version, "2.90.0"),
			t.software === "Takahe" && (0, b.default)(t.version, "0.8.0"),
			e.api_versions["polls.pleroma.pl-api"] >= 1
		]),
		postLanguages: x([
			t.software === L,
			t.software === T,
			t.software === E,
			t.software === k,
			t.software === "Mitra" && (0, b.default)(t.version, "3.23.0"),
			t.software === "Pleroma" && (0, b.default)(t.version, "2.9.0"),
			t.software === P
		]),
		preferredFrontends: t.software === L,
		privacyScopes: !0,
		profileDirectory: x([
			t.software === w,
			t.software === k,
			t.software === A,
			e.api_versions["profile_directory.pleroma.pl-api"] >= 1
		]),
		profileFields: x([
			t.software === L,
			t.software === S,
			t.software === T,
			t.software === E,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === A,
			t.software === j,
			t.software === N,
			t.software === P,
			t.software === F,
			t.software === "Takahe" && (0, b.default)(t.version, "0.7.0")
		]),
		publicFavourites: x([t.software === L, t.software === N]),
		publicTimeline: x([
			t.software === L,
			t.software === S,
			t.software === C,
			t.software === w,
			t.software === T,
			t.software === E,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === A,
			t.software === j,
			t.software === N,
			t.software === P,
			t.software === F,
			t.software === it,
			t.software === I,
			t.software === at
		]),
		quotePosts: x([
			t.software === O,
			t.software === "Friendica" && (0, b.default)(t.version, "2023.3.0"),
			t.software === P,
			e.api_versions.mastodon >= 7,
			e.api_versions["quote_posting.pleroma.pl-api"] >= 1,
			e.feature_quote === !0
		]),
		quoteApprovalPolicies: e.api_versions.mastodon >= 7,
		reblogVisibility: x([
			t.software === L,
			t.software === O,
			t.software === k,
			t.software === N
		]),
		remoteInteractions: x([t.software === L, t.software === "Pleroma" && (0, b.default)(t.version, "2.5.0")]),
		removeFromFollowers: x([
			t.software === L,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.23.0"),
			t.software === O,
			t.software === k,
			t.software === "Mitra" && (0, b.default)(t.version, "2.17.0"),
			t.software === "Pleroma" && (0, b.default)(t.version, "2.5.0")
		]),
		reportForwarding: t.software !== O,
		resetPassword: x([t.software === L, t.software === N]),
		richText: x([
			t.software === L,
			t.software === T,
			t.software === "Mastodon" && t.build === "glitch",
			t.software === N,
			t.software === A,
			e.pleroma.metadata.post_formats.filter((e) => e !== "text/plain").length > 0
		]),
		rssFeeds: x([
			t.software === L,
			t.software === T,
			t.software === "Iceshrimp.NET" && (0, b.default)(t.version, "2026.1.0"),
			t.software === k,
			t.software === N
		]),
		rssFeedSubscriptions: e.api_versions["rss_feed_subscriptions.pleroma.pl-api"] >= 1,
		scheduledReblogs: x([e.api_versions["net.iceshrimp.scheduled_boosts"] >= 1]),
		scheduledStatuses: x([
			t.software === L,
			t.software === C,
			t.software === w,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.18.0"),
			t.software === k,
			t.software === N,
			e.api_versions["net.iceshrimp.scheduled_boosts"] >= 1
		]),
		scheduledStatusesBackwards: x([t.software === "GoToSocial" && (0, b.default)(t.version, "0.18.0"), e.api_versions["backwards_schedule_at.pleroma.pl-api"] >= 1]),
		scrobbles: t.software === N,
		searchFromAccount: x([
			t.software === L,
			t.software === S,
			t.software === T,
			t.software === D,
			t.software === O,
			t.software === k,
			t.software === N
		]),
		sessions: x([
			t.software === L,
			t.software === "GoToSocial" && (0, b.default)(t.version, "0.18.2"),
			t.software === O,
			t.software === "Mitra" && (0, tt.default)(t.version, "4.13.1"),
			t.software === N
		]),
		shoutbox: e.api_versions["shout.pleroma.pl-api"] >= 1,
		spoilers: t.software !== A,
		statusDislikes: t.software === "Friendica" && (0, b.default)(t.version, "2023.3.0"),
		statusLocation: e.api_versions["status_location.pleroma.pl-api"] >= 1,
		stories: t.software === M,
		subscriptions: t.software === A,
		suggestions: x([
			t.software === w,
			t.software === D,
			t.software === k,
			t.software === M,
			e.api_versions["v2_suggestions.pleroma.pl-api"] >= 1
		]),
		suggestionsDismiss: x([t.software === k]),
		suggestionsV2: x([
			t.software === w,
			t.software === D,
			t.software === k,
			t.software === P,
			e.api_versions["v2_suggestions.pleroma.pl-api"] >= 1
		]),
		translations: x([
			e.api_versions["translation.pleroma.pl-api"] >= 1,
			e.api_versions["machine_translation.akkoma.pl-api"] >= 1,
			e.configuration.translation.enabled
		]),
		trendingLinks: x([t.software === "Mastodon" && (0, b.default)(t.compatVersion, "3.5.0"), t.software === j]),
		trendingStatuses: x([
			t.software === S,
			t.software === C,
			t.software === "Friendica" && (0, b.default)(t.version, "2022.12.0"),
			t.software === D,
			t.software === k,
			t.software === j,
			t.software === M,
			t.software === P
		]),
		trendingStatusesRange: t.software === M,
		trends: x([
			t.software === S,
			t.software === C,
			t.software === "Friendica" && (0, b.default)(t.version, "2022.12.0"),
			t.software === D,
			t.software === k,
			t.software === j,
			t.software === M,
			t.software === P,
			t.software === "Takahe" && (0, b.default)(t.version, "0.12.0")
		]),
		unrestrictedLists: x([
			t.software === L,
			t.software === N,
			t.software === F
		]),
		wrenchedTimeline: e.api_versions["wrenched_timeline.pleroma.pl-api"] >= 1
	};
}, ut = (e) => {
	let t = /^([\w+.-]*)(?: \(compatible; ([\w.]*) (.*)\))?$/.exec(e.replace("/", " ")), n = t && (t[3] || t[1]), r = t ? (0, nt.default)(n) || (0, et.default)(n, { loose: !0 }) : null, i = t ? (0, nt.default)(t[1]) || (0, et.default)(t[1]) : null;
	return t && r && i ? {
		build: r.build[0]?.split("-")[0],
		compatVersion: i.version,
		software: t[2] || "Mastodon",
		version: r.version.split("-")[0]
	} : {
		build: null,
		compatVersion: "0.0.0",
		software: null,
		version: "0.0.0"
	};
}, dt = (e) => /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e), ft = (e, t) => t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e, pt = (e, t, n) => {
	let i = t && !dt(e) ? ft(t, e) : e;
	if (n && Object.entries(n).length) {
		let { url: e, query: t } = r.parseUrl(i);
		return `${e}?${r.stringify({
			...t,
			...n
		}, { arrayFormat: "bracket" })}`;
	}
	return i;
}, mt = class extends Error {
	response;
	constructor(e, t) {
		super(t || `Request failed with status ${e.status}`), this.name = "PlApiError", this.response = e;
	}
	get status() {
		return this.response.status;
	}
	get json() {
		return this.response.json;
	}
}, ht = (e) => {
	let n = e.headers?.get("link"), r = n && new t(n) || null;
	return {
		next: r?.refs.find((e) => e.rel.toLocaleLowerCase() === "next")?.uri || null,
		prev: r?.refs.find((e) => e.rel.toLocaleLowerCase() === "prev")?.uri || null
	};
}, gt = (e) => "id" in e && "retry" in e, _t = (e) => {
	let t = e.headers.get("mastodon-async-refresh");
	if (!t) return null;
	let n = {};
	return t.split(/,\s*/).forEach((e) => {
		let [t, r] = e.split("=", 2), i;
		t && ["id", "retry"].includes(t) && r && (i = r.startsWith("\"") ? r.slice(1, -1) : parseInt(r, 10), n[t] = i);
	}), gt(n) ? n : null;
}, vt = (e) => {
	let t = new Headers();
	for (let n of e.trim().split(/[\r\n]+/)) if (n.indexOf(":") !== -1) try {
		let e = n.split(": "), r = e.shift(), i = e.join(": ");
		if (!r) continue;
		t.append(r, i);
	} catch {}
	return t;
};
function yt(e, { body: t, method: r = t ? "POST" : "GET", params: i, onUploadProgress: a, signal: o, contentType: s, formData: c, idempotencyKey: l } = {}) {
	e = e.toString();
	let u = pt(e, this.baseURL, i), d = new Headers();
	return e.startsWith("/api/iceshrimp/") && this.iceshrimpAccessToken ? d.set("Authorization", `Bearer ${this.iceshrimpAccessToken}`) : this.accessToken ? d.set("Authorization", `Bearer ${this.accessToken}`) : this.customAuthorizationToken && d.set("Authorization", this.customAuthorizationToken), (!c && t || s) && d.set("Content-Type", s || "application/json"), l && d.set("Idempotency-Key", l), t = t && c ? n(t, { indices: !0 }) : JSON.stringify(t), a ? new Promise((e, n) => {
		let i = new XMLHttpRequest();
		i.upload.addEventListener("progress", a), i.addEventListener("loadend", () => {
			let t = i.response, r;
			if (i.getResponseHeader("content-type")?.match(/(text|application)\/json/)) try {
				r = JSON.parse(t);
			} catch {}
			i.status >= 400 ? n(new mt({
				status: i.status,
				statusText: i.statusText,
				url: i.responseURL,
				data: t,
				json: r,
				headers: vt(i.getAllResponseHeaders()),
				ok: i.status >= 200 && i.status < 300,
				redirected: !1,
				type: "default"
			})) : e({
				status: i.status,
				data: t,
				json: r
			});
		}), i.open(r, u, !0), d.forEach((e, t) => i.setRequestHeader(t, e)), i.responseType = "text", i.send(t);
	}) : fetch(u, {
		method: r,
		headers: d,
		body: t,
		signal: o
	}).then(async (e) => {
		let t = await e.text(), n;
		if (e.headers.get("content-type")?.match(/(text|application)\/json/)) try {
			n = JSON.parse(t);
		} catch {}
		let { headers: r, ok: i, redirected: a, status: o, statusText: s, type: c, url: l } = e, u = {
			headers: r,
			ok: i,
			redirected: a,
			status: o,
			statusText: s,
			type: c,
			url: l,
			data: t,
			json: n
		};
		if (!i) throw new mt(u);
		return u;
	});
}
//#endregion
//#region lib/responses.ts
var R = class {
	items;
	previous;
	next;
	total;
	partial;
	constructor(e, t = {}) {
		this.items = e, this.previous = t.previous ?? null, this.next = t.next ?? null, this.total = t.total, this.partial = t.partial ?? !1;
	}
}, bt = class {
	baseURL;
	#e;
	#t;
	#n;
	#r = e.parse(He, {});
	request = yt.bind(this);
	features = lt(this.#r);
	socket;
	shoutSocket;
	constructor(e, t, n = {}) {
		this.baseURL = e, this.#e = t, this.#n = n.customAuthorizationToken, n.instance && this.setInstance(n.instance);
	}
	paginatedGet = async (t, n, r, i = !0) => {
		let a = i ? _(r) : r, o = (t) => {
			let { prev: n, next: r } = ht(t);
			return new R(e.parse(a, t.json), {
				previous: s(n),
				next: s(r),
				partial: t.status === 206
			});
		}, s = (e) => e ? () => this.request(e).then(o) : null;
		return o(await this.request(t, n));
	};
	setInstance = (e) => {
		this.#r = e, this.features = lt(this.#r);
	};
	getIceshrimpAccessToken = async () => {};
	setIceshrimpAccessToken(e) {
		this.#t = e;
	}
	get accessToken() {
		return this.#e;
	}
	set accessToken(e) {
		this.#e !== e && (this.socket?.close(), this.#e = e, this.getIceshrimpAccessToken());
	}
	get iceshrimpAccessToken() {
		return this.#t;
	}
	get customAuthorizationToken() {
		return this.#n;
	}
	set customAuthorizationToken(e) {
		this.#n = e;
	}
	get instanceInformation() {
		return this.#r;
	}
}, xt = e.object({
	text: e.string(),
	state: e.picklist([
		"approved",
		"rejected",
		"pending"
	])
}), St = e.object({
	id: e.string(),
	action: e.picklist([
		"none",
		"disable",
		"mark_statuses_as_sensitive",
		"delete_statuses",
		"sensitive",
		"silence",
		"suspend"
	]),
	text: e.fallback(e.string(), ""),
	status_ids: e.fallback(e.array(e.string()), []),
	target_account: y,
	appeal: e.fallback(e.nullable(xt), null),
	created_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString())
}), Ct = e.object({
	ip: e.pipe(e.string(), e.ip()),
	used_at: g
}), z = e.pipe(e.any(), e.transform((t) => "displayName" in t ? {
	id: t.id,
	account: null,
	username: t.username,
	domain: t.username.split("@")[1] || null,
	actor_type: t.isBot ? "Service" : "Person",
	display_name: t.displayName
} : t.account ? t : {
	id: t.id,
	account: null,
	username: t.nickname,
	domain: t.nickname.split("@")[1] || null,
	created_at: t.created_at,
	email: t.email,
	invite_request: t.registration_reason,
	role: t.roles?.is_admin ? e.parse(ue, { name: "Admin" }) : t.roles?.moderator ? e.parse(ue, { name: "Moderator " }) : null,
	confirmed: t.is_confirmed,
	approved: t.is_approved,
	disabled: !t.is_active,
	actor_type: t.actor_type,
	display_name: t.display_name,
	suggested: t.is_suggested
}), e.object({
	id: e.string(),
	username: e.string(),
	domain: e.fallback(e.nullable(e.string()), null),
	created_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString()),
	email: e.fallback(e.nullable(e.string()), null),
	ip: e.fallback(e.nullable(e.pipe(e.string(), e.ip())), null),
	ips: _(Ct),
	locale: e.fallback(e.nullable(e.string()), null),
	invite_request: e.fallback(e.nullable(e.string()), null),
	role: e.fallback(e.nullable(ue), null),
	confirmed: e.fallback(e.boolean(), !1),
	approved: e.fallback(e.boolean(), !1),
	disabled: e.fallback(e.boolean(), !1),
	silenced: e.fallback(e.boolean(), !1),
	suspended: e.fallback(e.boolean(), !1),
	sensitized: e.fallback(e.boolean(), !1),
	account: e.fallback(e.nullable(y), null),
	created_by_application_id: e.fallback(e.optional(e.string()), void 0),
	invited_by_account_id: e.fallback(e.optional(e.string()), void 0),
	actor_type: e.fallback(e.nullable(e.string()), null),
	display_name: e.fallback(e.nullable(e.string()), null),
	suggested: e.fallback(e.nullable(e.boolean()), null)
})), wt = e.object({ action_id: e.fallback(e.string(), "") }), Tt = e.object({
	name: e.fallback(e.string(), ""),
	count: e.fallback(e.pipe(e.number(), e.integer(), e.minValue(0)), 0),
	me: e.fallback(e.boolean(), !1),
	url: e.fallback(e.nullable(e.string()), null),
	static_url: e.fallback(e.nullable(e.string()), null),
	announcement_id: e.fallback(e.string(), "")
}), Et = e.pipe(e.object({
	id: e.string(),
	username: e.fallback(e.string(), ""),
	url: e.fallback(e.pipe(e.string(), e.url()), ""),
	acct: e.string()
}), e.transform((e) => (e.username ||= e.acct.split("@")[0], e))), Dt = e.array(e.object({
	day: e.pipe(e.unknown(), e.transform(Number)),
	accounts: e.pipe(e.unknown(), e.transform(Number)),
	uses: e.pipe(e.unknown(), e.transform(Number))
})), B = e.object({
	name: e.pipe(e.string(), e.transform((e) => e.startsWith("#") ? e.slice(1) : e), e.minLength(1)),
	url: e.fallback(e.pipe(e.string(), e.url()), ""),
	history: e.fallback(e.nullable(Dt), null),
	following: e.fallback(e.optional(e.boolean()), void 0),
	total: e.fallback(e.nullable(e.number()), null)
}), Ot = e.object({
	id: e.string(),
	content: e.fallback(e.string(), ""),
	starts_at: e.fallback(e.nullable(g), null),
	ends_at: e.fallback(e.nullable(g), null),
	all_day: e.fallback(e.boolean(), !1),
	read: e.fallback(e.boolean(), !1),
	published_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString()),
	reactions: _(Tt),
	statuses: e.pipe(e.any(), e.transform((e) => Array.isArray(e) ? Object.fromEntries(e.map((e) => [e.url, e.account?.acct]) || []) : e), e.record(e.string(), e.string())),
	mentions: _(Et),
	tags: _(B),
	emojis: _(m),
	updated_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString())
}), kt = e.pipe(e.any(), e.transform((e) => ({
	...e,
	...p(e.pleroma, ["raw_content"])
})), e.object({
	...Ot.entries,
	raw_content: e.fallback(e.string(), "")
})), At = e.object({
	id: e.string(),
	canonical_email_hash: e.string()
}), jt = e.object({
	period: g,
	frequency: e.picklist(["day", "month"]),
	data: e.array(e.object({
		date: g,
		rate: e.number(),
		value: e.pipe(e.unknown(), e.transform(Number))
	}))
}), Mt = e.object({
	category: e.fallback(e.nullable(e.string()), null),
	content_type: e.fallback(e.nullable(e.string()), null),
	disabled: e.fallback(e.boolean(), !1),
	domain: e.fallback(e.nullable(e.string()), null),
	id: e.string(),
	shortcode: e.string(),
	static_url: e.fallback(e.string(), ""),
	total_file_size: e.fallback(e.nullable(e.number()), null),
	updated_at: e.fallback(e.optional(g), void 0),
	uri: e.fallback(e.string(), ""),
	url: e.string(),
	visible_in_picker: e.fallback(e.boolean(), !0)
}), Nt = e.object({
	id: e.fallback(e.string(), ""),
	name: e.fallback(e.string(), "")
}), Pt = e.object({
	key: e.string(),
	data: e.array(e.object({
		key: e.string(),
		human_key: e.string(),
		value: e.string(),
		unit: e.fallback(e.optional(e.string()), void 0),
		human_value: e.fallback(e.optional(e.string()), void 0)
	}))
}), Ft = e.object({
	domain: e.fallback(e.string(), ""),
	id: e.pipe(e.unknown(), e.transform(String)),
	public: e.fallback(e.boolean(), !1),
	resolves: e.fallback(e.boolean(), !1),
	last_checked_at: e.fallback(e.nullable(g), null)
}), It = e.pipe(e.any(), e.transform((e) => ({
	id: e.host,
	domain: e.host,
	is_imported: e.isImported,
	...e
})), e.object({
	id: e.string(),
	domain: e.string(),
	created_at: e.fallback(e.nullable(g), null),
	is_imported: e.fallback(e.nullable(e.boolean()), null)
})), Lt = e.pipe(e.any(), e.transform((e) => ({
	id: e.host,
	domain: e.host,
	is_imported: e.isImported,
	public_comment: e.reason,
	...e
})), e.object({
	id: e.string(),
	domain: e.string(),
	digest: e.fallback(e.optional(e.string()), void 0),
	created_at: e.fallback(e.nullable(g), null),
	severity: e.fallback(e.picklist([
		"silence",
		"suspend",
		"noop"
	]), "suspend"),
	reject_media: e.fallback(e.optional(e.boolean()), void 0),
	reject_reports: e.fallback(e.optional(e.boolean()), void 0),
	private_comment: e.fallback(e.nullable(e.string()), null),
	public_comment: e.fallback(e.nullable(e.string()), null),
	obfuscate: e.fallback(e.boolean(), !1)
})), Rt = e.picklist(["no_action", "mute"]), zt = e.picklist([
	"no_action",
	"manual_approval",
	"reject_non_mutual",
	"reject_all"
]), Bt = e.picklist([
	"no_action",
	"mark_sensitive",
	"reject"
]), Vt = e.picklist([
	"no_action",
	"filter_warn",
	"filter_hide"
]), Ht = e.object({
	id: e.fallback(e.string(), ""),
	domain: e.fallback(e.string(), ""),
	created_at: e.fallback(e.optional(g), void 0),
	created_by: e.fallback(e.optional(e.string()), void 0),
	accounts_policy: e.fallback(Rt, "no_action"),
	follows_policy: e.fallback(zt, "no_action"),
	media_policy: e.fallback(Bt, "no_action"),
	statuses_policy: e.fallback(Vt, "no_action"),
	content_warning: e.fallback(e.optional(e.string()), void 0),
	public_comment: e.fallback(e.optional(e.string()), void 0),
	private_comment: e.fallback(e.optional(e.string()), void 0)
}), V = e.object({
	id: e.fallback(e.string(), ""),
	domain: e.fallback(e.string(), ""),
	created_at: e.fallback(e.optional(g), void 0),
	created_by: e.fallback(e.optional(e.string()), void 0),
	obfuscate: e.fallback(e.optional(e.boolean()), void 0),
	permission_type: e.fallback(e.optional(e.picklist(["block", "allow"])), void 0),
	private_comment: e.fallback(e.optional(e.string()), void 0),
	public_comment: e.fallback(e.optional(e.string()), void 0),
	comment: e.fallback(e.optional(e.string()), void 0),
	severity: e.fallback(e.optional(e.string()), void 0),
	silenced_at: e.fallback(e.optional(g), void 0),
	suspended_at: e.fallback(e.optional(g), void 0),
	subscription_id: e.fallback(e.optional(e.string()), void 0)
}), Ut = e.object({
	id: e.fallback(e.string(), ""),
	priority: e.fallback(e.number(), 0),
	title: e.fallback(e.optional(e.string()), void 0),
	permission_type: e.fallback(e.picklist(["block", "allow"]), "block"),
	as_draft: e.fallback(e.boolean(), !0),
	adopt_orphans: e.fallback(e.boolean(), !1),
	remove_retracted: e.fallback(e.boolean(), !0),
	uri: e.fallback(e.string(), ""),
	content_type: e.fallback(e.string(), ""),
	fetch_username: e.fallback(e.optional(e.string()), void 0),
	fetch_password: e.fallback(e.optional(e.string()), void 0),
	created_at: e.fallback(e.optional(g), void 0),
	created_by: e.fallback(e.optional(e.string()), void 0),
	fetched_at: e.fallback(e.optional(g), void 0),
	successfully_fetched_at: e.fallback(e.optional(g), void 0),
	count: e.fallback(e.number(), 0),
	error: e.fallback(e.optional(e.string()), void 0)
}), Wt = e.object({
	id: e.string(),
	domain: e.string(),
	created_at: g,
	history: e.array(e.object({
		day: e.pipe(e.unknown(), e.transform(String)),
		accounts: e.pipe(e.unknown(), e.transform(String)),
		uses: e.pipe(e.unknown(), e.transform(String))
	}))
}), Gt = e.object({
	id: e.fallback(e.string(), ""),
	header: e.fallback(e.string(), ""),
	regex: e.fallback(e.string(), ""),
	created_at: e.fallback(e.optional(g), void 0),
	created_by: e.fallback(e.optional(e.string()), void 0)
}), Kt = e.object({
	error: e.fallback(e.string(), ""),
	time: e.fallback(e.optional(g), void 0)
}), qt = e.object({
	id: e.fallback(e.string(), ""),
	domain: e.fallback(e.string(), ""),
	first_seen: e.fallback(e.optional(g), void 0),
	latest_successful_delivery: e.fallback(e.optional(g), void 0),
	software: e.fallback(e.optional(e.string()), void 0),
	delivery_errors: _(Kt)
}), Jt = e.object({
	id: e.fallback(e.nullable(e.number()), null),
	token: e.string(),
	used: e.fallback(e.boolean(), !1),
	expires_at: e.fallback(e.nullable(g), null),
	uses: e.fallback(e.number(), 0),
	max_use: e.fallback(e.nullable(e.number()), null),
	invite_type: e.fallback(e.string(), "one_time")
}), Yt = e.object({
	id: e.string(),
	ip: e.pipe(e.string(), e.ip()),
	severity: e.picklist([
		"sign_up_requires_approval",
		"sign_up_block",
		"no_access"
	]),
	comment: e.fallback(e.string(), ""),
	created_at: g,
	expires_at: e.fallback(e.nullable(g), null)
}), Xt = e.object({
	key: e.string(),
	unit: e.fallback(e.nullable(e.string()), null),
	total: e.pipe(e.unknown(), e.transform(Number)),
	human_value: e.fallback(e.optional(e.string()), void 0),
	previous_total: e.fallback(e.optional(e.pipe(e.unknown(), e.transform(Number))), void 0),
	data: e.array(e.object({
		date: de,
		value: e.pipe(e.unknown(), e.transform(Number))
	}))
}), Zt = e.object({
	id: e.pipe(e.unknown(), e.transform(String)),
	data: e.fallback(e.record(e.string(), e.any()), {}),
	time: e.fallback(e.number(), 0),
	message: e.fallback(e.string(), "")
}), Qt = e.object({
	configs: e.array(e.object({
		value: e.any(),
		group: e.string(),
		key: e.string()
	})),
	need_reboot: e.boolean()
}), $t = e.looseObject({
	key: e.optional(e.string()),
	type: e.union([e.string(), e.array(e.union([e.string(), e.array(e.string())]))]),
	description: e.optional(e.string()),
	label: e.optional(e.string()),
	suggestions: e.optional(e.array(e.any())),
	children: e.optional(e.lazy(() => e.array($t))),
	group: e.optional(e.union([e.string(), e.array(e.string())]))
}), en = e.object({
	group: e.optional(e.string()),
	key: e.optional(e.string()),
	type: e.union([e.string(), e.array(e.string())]),
	description: e.optional(e.string()),
	label: e.optional(e.string()),
	children: e.array($t),
	tab: e.optional(e.string()),
	related_policy: e.optional(e.string())
}), tn = e.object({
	id: e.fallback(e.string(), ""),
	keyword: e.fallback(e.string(), ""),
	whole_word: e.fallback(e.boolean(), !1),
	exclude: e.fallback(e.boolean(), !1)
}), H = e.pipe(e.any(), e.transform((e) => {
	if (!e.id) return {
		id: e.actor,
		relay_actor_uri: e.actor,
		...e
	};
	if (e.status) return {
		approved: e.status === "accepted",
		rejected: e.status === "rejected",
		relay_actor_uri: e.actor,
		...e
	};
}), e.object({
	id: e.fallback(e.string(), ""),
	relay_actor_uri: e.fallback(e.string(), ""),
	account_id: e.fallback(e.optional(e.string()), void 0),
	approved: e.fallback(e.boolean(), !1),
	created_at: e.fallback(e.optional(g), void 0),
	public: e.fallback(e.boolean(), !1),
	unlisted: e.fallback(e.boolean(), !1),
	match_by_default: e.fallback(e.boolean(), !1),
	ignore_sensitive: e.fallback(e.boolean(), !1),
	ignore_media: e.fallback(e.boolean(), !1),
	ignore_replies: e.fallback(e.boolean(), !1),
	matchers: _(tn),
	followed_back: e.fallback(e.boolean(), !1),
	rejected: e.fallback(e.boolean(), !1)
})), nn = e.object({
	name: e.string(),
	url: e.fallback(e.optional(e.string()), void 0)
}), rn = e.object({
	id: e.string(),
	account_id: e.fallback(e.nullable(e.string()), null),
	state: e.picklist(["pending", "accepted"]),
	created_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString())
}), U = e.object({
	id: e.string(),
	account_id: e.string(),
	uri: e.fallback(e.optional(e.string()), void 0),
	url: e.fallback(e.nullable(e.string()), null),
	name: e.string(),
	description: e.fallback(e.string(), ""),
	language: e.fallback(e.nullable(e.string()), null),
	local: e.fallback(e.boolean(), !1),
	sensitive: e.fallback(e.boolean(), !1),
	discoverable: e.fallback(e.boolean(), !1),
	tag: e.fallback(e.nullable(nn), null),
	item_count: e.fallback(e.number(), 0),
	items: _(rn),
	created_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString()),
	updated_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString())
}), an = e.object({
	accounts: _(y),
	collection: U
}), on = e.object({
	count: e.fallback(e.nullable(e.number()), null),
	me: e.fallback(e.boolean(), !1),
	name: fe,
	url: e.fallback(e.undefined(), void 0),
	static_url: e.fallback(e.undefined(), void 0),
	accounts: _(y),
	account_ids: e.fallback(_(e.string()), [])
}), sn = e.object({
	...on.entries,
	name: e.string(),
	url: e.pipe(e.string(), e.url()),
	static_url: e.pipe(e.string(), e.url())
}), cn = e.pipe(e.any(), e.transform((e) => e ? {
	url: e.url,
	static_url: e.url,
	account_ids: e.accounts?.map((e) => e?.id),
	...e
} : null), e.union([on, sn])), ln = e.object({
	id: e.string(),
	keyword: e.string(),
	whole_word: e.boolean()
}), un = e.object({
	id: e.string(),
	status_id: e.string()
}), dn = e.object({
	id: e.string(),
	title: e.string(),
	context: e.array(e.picklist([
		"home",
		"notifications",
		"public",
		"thread",
		"account"
	])),
	expires_at: e.fallback(e.nullable(g), null),
	filter_action: e.fallback(e.picklist([
		"warn",
		"hide",
		"blur"
	]), "warn"),
	keywords: _(ln),
	statuses: _(un)
}), fn = e.pipe(e.any(), e.transform((e) => e.phrase ? {
	...e,
	title: e.phrase,
	keywords: [{
		id: "1",
		keyword: e.phrase,
		whole_word: e.whole_word
	}],
	filter_action: e.irreversible ? "hide" : "warn"
} : e), dn), pn = e.omit(dn, ["keywords", "statuses"]), mn = e.object({
	filter: pn,
	keyword_matches: e.fallback(e.nullable(e.string()), null),
	status_matches: e.fallback(e.nullable(e.string()), null)
}), hn = /* @__PURE__ */ function(e) {
	return e.OWNER = "owner", e.ADMIN = "admin", e.MODERATOR = "moderator", e.USER = "user", e;
}(hn || {}), gn = e.pipe(e.any(), e.transform((e) => e.account ? e : {
	id: e.id,
	account: e,
	role: {
		founder: "owner",
		admin: "admin",
		moderator: "moderator"
	}[e.role] || "user"
}), e.object({
	id: e.string(),
	account: y,
	role: e.enum(hn)
})), _n = e.object({
	id: e.string(),
	member: e.fallback(e.boolean(), !1),
	role: e.fallback(e.optional(e.enum(hn)), void 0),
	requested: e.fallback(e.boolean(), !1)
}), W = e.pipe(e.any(), e.transform((e) => {
	let t = se(e);
	return e?.config && (e = {
		display_name: e.name,
		members_count: e.member_count,
		note: e.short_description,
		relationship: e.self ? {
			...e.self,
			member: e.self.is_member,
			role: {
				founder: "owner",
				admin: "admin",
				moderator: "moderator"
			}[e.self.role] || "user",
			id: e.id
		} : null,
		...e
	}), {
		domain: t,
		...e,
		avatar: e.avatar || e.avatar_static,
		header: e.header || e.header_static,
		avatar_default: oe(e.avatar || e.avatar_static || ""),
		header_default: ie(e.header || e.header_static || "")
	};
}), e.object({
	avatar: e.fallback(e.string(), ""),
	avatar_static: e.fallback(e.string(), ""),
	created_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString()),
	display_name: e.fallback(e.string(), ""),
	domain: e.fallback(e.string(), ""),
	emojis: _(m),
	header: e.fallback(e.string(), ""),
	header_static: e.fallback(e.string(), ""),
	id: e.pipe(e.unknown(), e.transform(String)),
	locked: e.fallback(e.boolean(), !1),
	membership_required: e.fallback(e.boolean(), !1),
	members_count: e.fallback(e.number(), 0),
	owner: e.fallback(e.nullable(e.object({ id: e.string() })), null),
	note: e.fallback(e.pipe(e.string(), e.transform((e) => e === "<p></p>" ? "" : e)), ""),
	relationship: e.fallback(e.nullable(_n), null),
	statuses_visibility: e.fallback(e.string(), "public"),
	uri: e.fallback(e.string(), ""),
	url: e.fallback(e.string(), ""),
	avatar_description: e.fallback(e.string(), ""),
	header_description: e.fallback(e.string(), ""),
	avatar_default: e.fallback(e.boolean(), !1),
	header_default: e.fallback(e.boolean(), !1)
})), vn = e.picklist([
	"public",
	"followers",
	"following",
	"mutuals",
	"mentioned",
	"author",
	"me"
]), yn = e.optional(e.pipe(e.any(), e.transform((e) => (e.always && (e.automatic_approval = e.always), e.with_approval && (e.manual_approval = e.with_approval), e)), e.object({
	automatic_approval: e.fallback(e.array(vn), ["public", "me"]),
	manual_approval: e.fallback(e.array(vn), [])
})), {}), bn = v({
	can_favourite: yn,
	can_reblog: yn,
	can_reply: yn
}), xn = v({
	public: bn,
	unlisted: bn,
	private: bn,
	direct: bn
}), Sn = e.pipe(e.string(), e.check((e) => i(e).result, "invalid blurhash")), Cn = e.object({
	id: e.string(),
	type: e.string(),
	url: e.fallback(e.pipe(e.string(), e.url()), ""),
	preview_url: e.fallback(e.pipe(e.string(), e.url()), ""),
	remote_url: e.fallback(e.nullable(e.pipe(e.string(), e.url())), null),
	description: e.fallback(e.string(), ""),
	blurhash: e.fallback(e.nullable(Sn), null),
	mime_type: e.fallback(e.nullable(pe), null)
}), wn = e.object({
	width: e.number(),
	height: e.number(),
	size: e.fallback(e.nullable(e.pipe(e.string(), e.regex(/\d+x\d+$/))), null),
	aspect: e.fallback(e.nullable(e.number()), null)
}), Tn = e.object({
	...Cn.entries,
	type: e.literal("image"),
	meta: e.fallback(e.object({
		original: e.fallback(e.optional(wn), void 0),
		small: e.fallback(e.optional(wn), void 0),
		focus: e.fallback(e.optional(e.object({
			x: e.pipe(e.number(), e.minValue(-1), e.maxValue(1)),
			y: e.pipe(e.number(), e.minValue(-1), e.maxValue(1))
		})), void 0)
	}), {})
}), En = e.object({
	...Cn.entries,
	type: e.literal("video"),
	meta: e.fallback(e.object({
		duration: e.fallback(e.optional(e.number()), void 0),
		original: e.fallback(e.optional(e.object({
			...wn.entries,
			frame_rate: e.fallback(e.nullable(e.pipe(e.string(), e.regex(/\d+\/\d+$/))), null),
			duration: e.fallback(e.nullable(e.pipe(e.number(), e.minValue(0))), null)
		})), void 0),
		small: e.fallback(e.optional(wn), void 0)
	}), {})
}), Dn = e.object({
	...Cn.entries,
	type: e.literal("gifv"),
	meta: e.fallback(e.object({
		duration: e.fallback(e.optional(e.number()), void 0),
		original: e.fallback(e.optional(wn), void 0),
		focus: e.fallback(e.optional(e.object({
			x: e.pipe(e.number(), e.minValue(-1), e.maxValue(1)),
			y: e.pipe(e.number(), e.minValue(-1), e.maxValue(1))
		})), void 0)
	}), {})
}), On = e.object({
	...Cn.entries,
	type: e.literal("audio"),
	meta: e.fallback(e.object({
		duration: e.fallback(e.optional(e.number()), void 0),
		colors: e.fallback(e.optional(e.object({
			background: e.fallback(e.optional(e.string()), void 0),
			foreground: e.fallback(e.optional(e.string()), void 0),
			accent: e.fallback(e.optional(e.string()), void 0),
			duration: e.fallback(e.optional(e.number()), void 0)
		})), void 0),
		original: e.fallback(e.optional(e.object({
			duration: e.fallback(e.optional(e.number()), void 0),
			bitrate: e.fallback(e.optional(e.pipe(e.number(), e.minValue(0))), void 0)
		})), void 0)
	}), {})
}), kn = e.object({
	...Cn.entries,
	type: e.literal("unknown")
}), G = e.pipe(e.any(), e.transform((e) => e ? {
	mime_type: e.pleroma?.mime_type,
	preview_url: e.url,
	...e
} : null), e.variant("type", [
	Tn,
	En,
	Dn,
	On,
	kn
])), An = e.object({
	title: e.fallback(e.string(), ""),
	votes_count: e.fallback(e.number(), 0),
	title_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null)
}), jn = e.object({
	emojis: _(m),
	expired: e.fallback(e.boolean(), !1),
	expires_at: e.fallback(e.nullable(g), null),
	id: e.string(),
	multiple: e.fallback(e.boolean(), !1),
	options: e.pipe(e.array(An), e.minLength(1)),
	voters_count: e.fallback(e.number(), 0),
	votes_count: e.fallback(e.number(), 0),
	own_votes: e.fallback(e.nullable(e.pipe(e.array(e.number()), e.minLength(1))), null),
	voted: e.fallback(e.boolean(), !1),
	non_anonymous: e.fallback(e.boolean(), !1)
}), Mn = e.object({
	name: e.string(),
	url: e.pipe(e.string(), e.url()),
	account: e.fallback(e.nullable(y), null)
}), Nn = e.object({
	author_name: e.fallback(e.string(), ""),
	author_url: e.fallback(e.pipe(e.string(), e.url()), ""),
	authors: _(Mn),
	blurhash: e.fallback(e.nullable(e.string()), null),
	description: e.fallback(e.string(), ""),
	embed_url: e.fallback(e.pipe(e.string(), e.url()), ""),
	height: e.fallback(e.number(), 0),
	html: e.fallback(e.string(), ""),
	image: e.fallback(e.nullable(e.string()), null),
	image_description: e.fallback(e.string(), ""),
	provider_name: e.fallback(e.string(), ""),
	provider_url: e.fallback(e.pipe(e.string(), e.url()), ""),
	title: e.fallback(e.string(), ""),
	type: e.fallback(e.picklist([
		"link",
		"photo",
		"video",
		"rich"
	]), "link"),
	url: e.pipe(e.string(), e.url()),
	width: e.fallback(e.number(), 0)
}), Pn = e.picklist([
	"pending",
	"accepted",
	"rejected",
	"revoked",
	"deleted",
	"unauthorized",
	"blocked_account",
	"blocked_domain",
	"muted_account"
]), Fn = e.object({
	state: e.fallback(Pn, "accepted"),
	quoted_status: e.fallback(e.nullable(e.lazy(() => K)), null)
}), In = e.object({
	state: e.fallback(Pn, "accepted"),
	quoted_status_id: e.fallback(e.nullable(e.string()), null)
}), Ln = e.object({
	automatic: e.array(e.picklist([
		"public",
		"followers",
		"following",
		"unsupported_policy"
	])),
	manual: e.array(e.picklist([
		"public",
		"followers",
		"following",
		"unsupported_policy"
	])),
	current_user: e.picklist([
		"automatic",
		"manual",
		"denied",
		"unknown"
	])
}), Rn = e.object({
	id: e.string(),
	url: e.string(),
	title: e.fallback(e.nullable(e.string()), null),
	description: e.fallback(e.nullable(e.string()), null),
	image_url: e.fallback(e.nullable(e.string()), null)
}), zn = e.object({
	id: e.string(),
	options: e.array(e.object({ title: e.string() }))
}), Bn = e.object({
	id: e.string(),
	description: e.fallback(e.string(), "")
}), Vn = e.pipe(e.any(), e.transform((e) => e?.text ? {
	content: e.text,
	detected_source_language: e.detected_language
} : e), e.object({
	id: e.fallback(e.nullable(e.string()), null),
	content: e.fallback(e.string(), ""),
	spoiler_text: e.fallback(e.string(), ""),
	language: e.fallback(e.string(), ""),
	poll: e.fallback(e.optional(zn), void 0),
	media_attachments: _(Bn),
	detected_source_language: e.string(),
	provider: e.fallback(e.nullable(e.string()), null)
})), Hn = e.object({
	name: e.fallback(e.string(), ""),
	url: e.fallback(e.pipe(e.string(), e.url()), ""),
	latitude: e.fallback(e.nullable(e.number()), null),
	longitude: e.fallback(e.nullable(e.number()), null),
	street: e.fallback(e.string(), ""),
	postal_code: e.fallback(e.string(), ""),
	locality: e.fallback(e.string(), ""),
	region: e.fallback(e.string(), ""),
	country: e.fallback(e.string(), "")
}), Un = e.object({
	name: e.fallback(e.string(), ""),
	start_time: e.fallback(e.nullable(g), null),
	end_time: e.fallback(e.nullable(g), null),
	join_mode: e.fallback(e.nullable(e.picklist([
		"free",
		"restricted",
		"invite",
		"external"
	])), null),
	participants_count: e.fallback(e.number(), 0),
	participation_request_count: e.fallback(e.number(), 0),
	location: e.fallback(e.nullable(Hn), null),
	join_state: e.fallback(e.nullable(e.picklist([
		"pending",
		"reject",
		"accept"
	])), null)
}), Wn = e.object({
	id: e.string(),
	uri: e.fallback(e.pipe(e.string(), e.url()), ""),
	created_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString()),
	account: e.pipe(e.unknown(), e.transform((e) => {
		let t = window?.__PL_API_FALLBACK_ACCOUNT;
		return t && Object.keys(e).length === 0 ? t : e;
	}), y),
	content: e.fallback(e.pipe(e.string(), e.transform((e) => e === "<p></p>" ? "" : e)), ""),
	visibility: e.fallback(e.string(), "public"),
	sensitive: e.pipe(e.unknown(), e.transform(Boolean)),
	spoiler_text: e.fallback(e.string(), ""),
	media_attachments: _(G),
	application: e.fallback(e.nullable(e.object({
		name: e.string(),
		website: e.fallback(e.nullable(e.pipe(e.string(), e.url())), null)
	})), null),
	mentions: _(Et),
	tags: _(B),
	emojis: _(m),
	reblogs_count: e.fallback(e.number(), 0),
	favourites_count: e.fallback(e.number(), 0),
	replies_count: e.fallback(e.number(), 0),
	url: e.fallback(e.pipe(e.string(), e.url()), ""),
	in_reply_to_id: e.fallback(e.nullable(e.string()), null),
	in_reply_to_account_id: e.fallback(e.nullable(e.string()), null),
	poll: e.fallback(e.nullable(jn), null),
	card: e.fallback(e.nullable(Nn), null),
	language: e.fallback(e.nullable(e.string()), null),
	text: e.fallback(e.nullable(e.string()), null),
	edited_at: e.fallback(e.nullable(g), null),
	favourited: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
	reblogged: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
	muted: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
	bookmarked: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
	pinned: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
	filtered: _(mn),
	approval_status: e.fallback(e.nullable(e.picklist([
		"pending",
		"approval",
		"rejected"
	])), null),
	group: e.fallback(e.nullable(W), null),
	scheduled_at: e.fallback(e.null(), null),
	quote_approval: e.fallback(e.nullable(Ln), null),
	tagged_collections: _(U),
	quote_id: e.fallback(e.nullable(e.string()), null),
	local: e.fallback(e.optional(e.boolean()), void 0),
	conversation_id: e.fallback(e.optional(e.string()), void 0),
	direct_conversation_id: e.fallback(e.optional(e.string()), void 0),
	in_reply_to_account_acct: e.fallback(e.optional(e.string()), void 0),
	expires_at: e.fallback(e.optional(g), void 0),
	thread_muted: e.fallback(e.optional(e.boolean()), void 0),
	emoji_reactions: _(cn),
	parent_visible: e.fallback(e.optional(e.boolean()), void 0),
	pinned_at: e.fallback(e.nullable(g), null),
	quote_visible: e.fallback(e.optional(e.boolean()), void 0),
	quote_url: e.fallback(e.optional(e.string()), void 0),
	quotes_count: e.fallback(e.number(), 0),
	bookmark_folder: e.fallback(e.nullable(e.string()), null),
	list_id: e.fallback(e.nullable(e.number()), null),
	event: e.fallback(e.nullable(Un), null),
	translation: e.fallback(e.union([e.nullable(Vn), e.literal(!1)]), null),
	rss_feed: e.fallback(e.nullable(Rn), null),
	content_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null),
	text_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null),
	spoiler_text_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null),
	dislikes_count: e.fallback(e.number(), 0),
	disliked: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
	local_only: e.fallback(e.optional(e.boolean()), void 0),
	interaction_policy: bn,
	content_type: e.fallback(e.nullable(e.string()), null),
	location: e.fallback(e.nullable(Hn), null)
}), Gn = (e) => {
	if (!e) return null;
	let t = null, n = e.quote ?? e.pleroma?.quote, r = n?.id ?? e.quote_id ?? e.pleroma?.quote_id;
	return n?.state ? (t = n, r = n.quoted_status?.id || n.quoted_status_id) : n ? t = {
		state: "accepted",
		quoted_status: n
	} : r && (t = {
		state: "accepted",
		quoted_status_id: r
	}), e = {
		emoji_reactions: e.reactions,
		...p(e.pleroma || {}, [
			"local",
			"conversation_id",
			"direct_conversation_id",
			"in_reply_to_account_acct",
			"expires_at",
			"thread_muted",
			"emoji_reactions",
			"parent_visible",
			"pinned_at",
			"quote_url",
			"quote_visible",
			"quotes_count",
			"bookmark_folder",
			"list_id",
			"event",
			"translation",
			"rss_feed",
			"location"
		]),
		...p(e.friendica || {}, ["dislikes_count", "disliked"]),
		...e,
		quote: t,
		quote_id: r
	}, !e.interaction_policy && e.comments_disabled === !0 && (e.interaction_policy = { can_reply: { always: ["author"] } }), e;
}, K = e.pipe(e.any(), e.transform(Gn), e.object({
	...Wn.entries,
	reblog: e.fallback(e.nullable(e.lazy(() => K)), null),
	quote: e.fallback(e.nullable(e.lazy(() => e.union([Fn, In]))), null)
})), Kn = e.pipe(e.any(), e.transform(Gn), e.object({
	...e.omit(Wn, ["account"]).entries,
	account: e.fallback(e.nullable(y), null),
	reblog: e.fallback(e.nullable(e.lazy(() => K)), null),
	quote: e.fallback(e.nullable(e.lazy(() => e.union([Fn, In]))), null)
})), qn = e.partial(e.object({
	...Wn.entries,
	reblog: e.fallback(e.nullable(e.lazy(() => K)), null),
	quote: e.fallback(e.nullable(e.lazy(() => e.union([Fn, In]))), null)
})), q = e.pipe(e.any(), e.transform((e) => (e.statuses = e.statuses?.map((t) => ({
	...t,
	account: (e.actor ? e.account : e.target_account)?.account || t.account
})), e.createdAt ? {
	id: e.id,
	action_taken: e.resolved,
	comment: e.comment,
	forwarded: e.forwarded,
	created_at: e.createdAt,
	account: e.reporter,
	target_account: e.targetUser,
	assigned_account: e.assignee,
	statuses: e.notes,
	rules: e.rules
} : e.actor ? {
	action_taken: e.state !== "open",
	comment: e.content,
	updated_at: e.created_at,
	account: e.actor,
	target_account: e.account,
	...p(e, [
		"id",
		"assigned_account",
		"created_at",
		"rules",
		"statuses"
	])
} : e)), e.object({
	id: e.string(),
	action_taken: e.fallback(e.optional(e.boolean()), void 0),
	action_taken_at: e.fallback(e.nullable(g), null),
	category: e.fallback(e.optional(e.string()), void 0),
	comment: e.fallback(e.optional(e.string()), void 0),
	forwarded: e.fallback(e.optional(e.boolean()), void 0),
	created_at: e.fallback(e.optional(g), void 0),
	updated_at: e.fallback(e.optional(g), void 0),
	account: z,
	target_account: z,
	assigned_account: e.fallback(e.nullable(z), null),
	action_taken_by_account: e.fallback(e.nullable(z), null),
	statuses: _(Kn),
	rules: _(Ee)
})), Jn = e.object({
	id: e.string(),
	text: e.fallback(e.string(), ""),
	hint: e.fallback(e.string(), ""),
	priority: e.fallback(e.nullable(e.number()), null),
	created_at: e.fallback(e.optional(g), void 0),
	updated_at: e.fallback(e.optional(g), void 0)
}), Yn = e.object({
	...B.entries,
	id: e.string(),
	trendable: e.boolean(),
	usable: e.boolean(),
	requires_review: e.boolean()
}), J = e.pipe(e.any(), e.transform((e) => e ? {
	...e.pleroma,
	...e
} : null), e.object({
	id: e.pipe(e.unknown(), e.transform(String)),
	title: e.string(),
	replies_policy: e.fallback(e.optional(e.picklist([
		"none",
		"list",
		"followed"
	])), void 0),
	exclusive: e.fallback(e.optional(e.boolean()), void 0),
	antennas: _(e.lazy(() => Y)),
	notify: e.fallback(e.optional(e.boolean()), void 0),
	favourite: e.fallback(e.optional(e.boolean()), void 0),
	emoji: e.fallback(e.nullable(e.string()), null),
	emoji_url: e.fallback(e.nullable(e.string()), null)
})), Xn = e.object({
	id: e.string(),
	title: e.string(),
	with_media_only: e.boolean(),
	ignore_reblog: e.boolean(),
	stl: e.boolean(),
	ltl: e.boolean(),
	insert_feeds: e.boolean(),
	accounts_count: e.number(),
	domains_count: e.number(),
	tags_count: e.number(),
	keywords_count: e.number(),
	favourite: e.boolean()
}), Y = e.object({
	...Xn.entries,
	list: e.fallback(e.nullable(e.lazy(() => J)), null)
}), Zn = e.pipe(e.any(), e.transform((e) => ({
	redirect_uris: [e.redirect_uri],
	...e
})), e.object({
	name: e.fallback(e.string(), ""),
	website: e.fallback(e.optional(e.string()), void 0),
	redirect_uris: _(e.string()),
	id: e.fallback(e.optional(e.string()), void 0),
	redirect_uri: e.fallback(e.optional(e.string()), void 0),
	vapid_key: e.fallback(e.optional(e.string()), void 0)
})), Qn = e.pipe(Zn.pipe[0], Zn.pipe[1], e.object({
	...Zn.pipe[2].entries,
	client_id: e.string(),
	client_secret: e.string(),
	client_secret_expires_at: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null)
})), $n = e.object({ async_refresh: e.object({
	id: e.string(),
	status: e.picklist(["running", "finished"]),
	result_count: e.nullable(e.number())
}) }), er = e.object({
	issuer: e.string(),
	service_documentation: e.string(),
	authorization_endpoint: e.string(),
	token_endpoint: e.string(),
	app_registration_endpoint: e.string(),
	revocation_endpoint: e.string(),
	userinfo_endpoint: e.string(),
	scopes_supported: e.array(e.string()),
	response_types_supported: e.array(e.string()),
	response_modes_supported: e.array(e.string()),
	code_challenge_methods_supported: e.array(e.string()),
	grant_types_supported: e.array(e.string()),
	token_endpoint_auth_methods_supported: e.array(e.string())
}), tr = e.object({
	id: e.pipe(e.unknown(), e.transform(String)),
	content_type: pe,
	file_size: e.fallback(e.number(), 0),
	inserted_at: g,
	processed: e.fallback(e.boolean(), !1),
	url: e.fallback(e.string(), "")
}), nr = e.pipe(e.any(), e.transform((e) => ({
	name: e.title,
	...e
})), e.object({
	id: e.pipe(e.unknown(), e.transform(String)),
	name: e.fallback(e.string(), ""),
	emoji: e.fallback(e.nullable(e.string()), null),
	emoji_url: e.fallback(e.nullable(e.string()), null)
})), rr = e.object({
	id: e.string(),
	content: e.fallback(e.string(), ""),
	chat_id: e.string(),
	account_id: e.string(),
	created_at: g,
	emojis: _(m),
	attachment: e.fallback(e.nullable(G), null),
	unread: e.boolean(),
	card: e.fallback(e.nullable(Nn), null)
}), ir = e.object({
	id: e.string(),
	account: y,
	unread: e.pipe(e.number(), e.integer()),
	last_message: e.fallback(e.nullable(rr), null),
	updated_at: g
}), ar = e.object({
	id: e.string(),
	title: e.string()
}), or = e.object({
	ancestors: _(K),
	descendants: _(K),
	references: e.fallback(_(K), [])
}), sr = e.object({
	id: e.string(),
	unread: e.fallback(e.boolean(), !1),
	accounts: _(y),
	last_status: e.fallback(e.nullable(K), null)
}), cr = e.object({
	category: e.string(),
	servers_count: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null)
}), lr = e.object({
	locale: e.string(),
	language: e.string(),
	servers_count: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null)
}), ur = e.object({
	domain: e.string(),
	version: e.string(),
	description: e.string(),
	languages: e.array(e.string()),
	region: e.string(),
	categories: e.array(e.string()),
	proxied_thumbnail: e.fallback(e.nullable(e.pipe(e.string(), e.url())), null),
	blurhash: e.fallback(e.nullable(e.string()), null),
	total_users: e.pipe(e.unknown(), e.transform(Number)),
	last_week_users: e.pipe(e.unknown(), e.transform(Number)),
	approval_required: e.boolean(),
	language: e.string(),
	category: e.string()
}), dr = e.object({
	period: e.pipe(e.string(), e.isoDate()),
	server_count: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null),
	user_count: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null),
	active_user_count: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null)
}), fr = e.object({
	domain: e.string(),
	digest: e.string(),
	severity: e.picklist(["silence", "suspend"]),
	comment: e.fallback(e.optional(e.string()), void 0)
}), pr = e.pipe(e.any(), e.transform((e) => ({
	...e,
	thumbnail_url: e.thumbnailUrl,
	content_type: e.contentType,
	is_avatar: e.isAvatar,
	is_banner: e.isBanner
})), e.object({
	id: e.string(),
	url: e.string(),
	thumbnail_url: e.string(),
	filename: e.string(),
	content_type: e.string(),
	sensitive: e.boolean(),
	description: e.fallback(e.nullable(e.string()), null),
	is_avatar: e.boolean(),
	is_banner: e.boolean()
})), mr = e.object({
	id: e.fallback(e.nullable(e.string()), null),
	name: e.fallback(e.nullable(e.string()), null),
	parent_id: e.fallback(e.nullable(e.string()), null)
}), hr = e.object({
	id: e.fallback(e.nullable(e.string()), null),
	name: e.fallback(e.nullable(e.string()), null),
	parent_id: e.fallback(e.nullable(e.string()), null),
	files: _(pr),
	path: _(mr)
}), gr = e.pipe(e.any(), e.transform((e) => ({
	...e,
	parent_id: e.parentId,
	path: e.path?.map((e) => ({
		...e,
		parent_id: e.parentId
	}))
})), e.object({
	...hr.entries,
	folders: _(e.lazy(() => gr))
})), _r = e.pipe(e.any(), e.transform((e) => ({
	file_count: e.fileCount,
	used_size: e.usedSize,
	...e
})), e.object({
	file_count: e.fallback(e.number(), 0),
	used_size: e.fallback(e.number(), 0)
})), vr = e.object({
	updated_at: g,
	content: e.string()
}), yr = e.object({
	id: e.string(),
	accounts: _(y)
}), br = e.object({
	id: e.string(),
	name: e.string(),
	url: e.fallback(e.optional(e.string()), void 0),
	statuses_count: e.number(),
	last_status_at: e.fallback(e.nullable(e.number()), null)
}), xr = e.object({
	id: e.string(),
	description: e.fallback(e.nullable(e.string()), null),
	url: e.pipe(e.string(), e.url())
}), Sr = e.object({
	results: _(xr),
	provider: e.fallback(e.nullable(e.string()), null)
}), Cr = e.object({
	id: e.string(),
	type: e.picklist([
		"domain_block",
		"user_domain_block",
		"account_suspension"
	]),
	purged: e.string(),
	relationships_count: e.fallback(e.optional(e.number()), void 0),
	created_at: g
}), wr = e.object({
	id: e.string(),
	action_taken: e.fallback(e.optional(e.boolean()), void 0),
	action_taken_at: e.fallback(e.nullable(g), null),
	category: e.fallback(e.optional(e.string()), void 0),
	comment: e.fallback(e.optional(e.string()), void 0),
	forwarded: e.fallback(e.optional(e.boolean()), void 0),
	created_at: e.fallback(e.optional(g), void 0),
	status_ids: e.fallback(e.nullable(e.string()), null),
	rule_ids: e.fallback(e.nullable(e.string()), null),
	target_account: e.fallback(e.nullable(y), null)
}), Tr = e.object({
	id: e.string(),
	acct: e.string(),
	url: e.pipe(e.string(), e.url()),
	avatar: e.pipe(e.string(), e.url()),
	avatar_static: e.pipe(e.string(), e.url()),
	locked: e.boolean(),
	bot: e.boolean()
}), X = e.object({
	group_key: e.string(),
	notifications_count: e.pipe(e.number(), e.integer()),
	most_recent_notification_id: e.pipe(e.unknown(), e.transform(String), e.string()),
	page_min_id: e.fallback(e.optional(e.string()), void 0),
	page_max_id: e.fallback(e.optional(e.string()), void 0),
	latest_page_notification_at: e.fallback(e.optional(g), void 0),
	sample_account_ids: e.array(e.string()),
	is_muted: e.fallback(e.optional(e.boolean()), void 0),
	is_seen: e.fallback(e.optional(e.boolean()), void 0)
}), Er = e.object({
	...X.entries,
	type: e.picklist([
		"follow",
		"follow_request",
		"follow_request_accepted",
		"admin.sign_up",
		"bite"
	])
}), Dr = e.object({
	...X.entries,
	type: e.literal("mention"),
	subtype: e.fallback(e.nullable(e.picklist(["reply"])), null),
	status_id: e.string()
}), Or = e.object({
	...X.entries,
	type: e.picklist([
		"status",
		"reblog",
		"favourite",
		"poll",
		"update",
		"event_reminder",
		"quote",
		"quoted_update"
	]),
	status_id: e.string()
}), kr = e.object({
	...X.entries,
	type: e.literal("admin.report"),
	report: wr
}), Ar = e.object({
	...X.entries,
	type: e.literal("severed_relationships"),
	relationship_severance_event: Cr
}), jr = e.object({
	...X.entries,
	type: e.literal("moderation_warning"),
	moderation_warning: St
}), Mr = e.object({
	...X.entries,
	type: e.literal("move"),
	target_id: e.string()
}), Nr = e.object({
	...X.entries,
	type: e.literal("emoji_reaction"),
	emoji: e.string(),
	emoji_url: e.fallback(e.nullable(e.string()), null),
	status_id: e.string()
}), Pr = e.object({
	...X.entries,
	type: e.literal("chat_mention"),
	chat_message: rr
}), Fr = e.object({
	...X.entries,
	type: e.picklist(["participation_accepted", "participation_request"]),
	status_id: e.string(),
	participation_message: e.fallback(e.nullable(e.string()), null)
}), Ir = e.object({
	...X.entries,
	type: e.literal("subscribed_reaction"),
	emoji: e.fallback(e.nullable(e.string()), null),
	emoji_url: e.fallback(e.nullable(e.string()), null),
	status_id: e.string()
}), Lr = e.object({
	...X.entries,
	type: e.picklist(["added_to_collection", "collection_update"]),
	collection: U
}), Rr = e.pipe(e.any(), e.transform((e) => ({
	group_key: `ungrouped-${e.id}`,
	...p(e.pleroma || {}, ["is_muted", "is_seen"]),
	...e,
	type: e.type === "pleroma:report" ? "admin.report" : e.type === "reaction" ? "emoji_reaction" : e.type?.replace(/^pleroma:/, "")
})), e.variant("type", [
	Er,
	Dr,
	Or,
	kr,
	Ar,
	jr,
	Mr,
	Nr,
	Pr,
	Fr,
	Ir,
	Lr
])), zr = e.object({
	accounts: _(y),
	partial_accounts: e.fallback(e.optional(e.array(Tr)), void 0),
	statuses: _(K),
	notification_groups: _(Rr)
}), Br = e.object({
	accepted_at: e.fallback(e.nullable(g), null),
	account: y,
	created_at: g,
	id: e.string(),
	rejected_at: e.fallback(e.nullable(g), null),
	reply: e.fallback(e.nullable(K), null),
	status: e.fallback(e.nullable(K), null),
	type: e.picklist([
		"favourite",
		"reply",
		"reblog"
	]),
	uri: e.fallback(e.nullable(e.string()), null)
}), Vr = e.object({ url: e.string() }), Z = e.object({
	id: e.string(),
	uuid: e.string(),
	url: e.string(),
	api_url: e.string(),
	category: e.picklist([
		"book",
		"movie",
		"tv",
		"music",
		"game",
		"podcast",
		"performance",
		"collection"
	]),
	parent_uuid: e.nullable(e.string()),
	display_title: e.string(),
	external_resources: e.nullable(_(Vr)),
	title: e.string(),
	description: e.string(),
	localized_title: _(e.object({
		lang: e.string(),
		text: e.string()
	})),
	localized_description: _(e.object({
		lang: e.string(),
		text: e.string()
	})),
	conver_image_url: e.nullable(e.string()),
	rating: e.nullable(e.number()),
	rating_count: e.nullable(e.number()),
	rating_distribution: e.nullable(e.array(e.number())),
	tags: e.nullable(e.array(e.string()))
}), Hr = e.object({
	...Z.entries,
	type: e.literal("Edition"),
	subtitle: e.nullable(e.string()),
	orig_title: e.nullable(e.string()),
	author: e.array(e.string()),
	translator: e.array(e.string()),
	language: e.array(e.string()),
	pub_house: e.nullable(e.string()),
	pub_year: e.nullable(e.number()),
	pub_month: e.nullable(e.number()),
	binding: e.nullable(e.string()),
	price: e.nullable(e.string()),
	pages: e.nullable(e.union([e.string(), e.number()])),
	series: e.nullable(e.string()),
	imprint: e.nullable(e.string()),
	isbn: e.nullable(e.string())
}), Ur = e.object({
	...Z.entries,
	type: e.literal("TVShow"),
	season_count: e.nullable(e.number()),
	orig_title: e.nullable(e.string()),
	director: e.array(e.string()),
	playwright: e.array(e.string()),
	actor: e.array(e.string()),
	genre: e.array(e.string()),
	language: e.array(e.string()),
	area: e.array(e.string()),
	year: e.nullable(e.number()),
	site: e.nullable(e.string()),
	episode_count: e.nullable(e.number()),
	season_uuids: e.array(e.string()),
	imdb: e.nullable(e.string())
}), Wr = e.object({
	...Z.entries,
	type: e.literal("TVSeason"),
	season_number: e.nullable(e.number()),
	orig_title: e.nullable(e.string()),
	director: e.array(e.string()),
	playwright: e.array(e.string()),
	actor: e.array(e.string()),
	genre: e.array(e.string()),
	language: e.array(e.string()),
	area: e.array(e.string()),
	year: e.nullable(e.number()),
	site: e.nullable(e.string()),
	episode_count: e.nullable(e.number()),
	episode_uuids: e.array(e.string()),
	imdb: e.nullable(e.string())
}), Gr = e.object({
	...Z.entries,
	type: e.literal("Movie"),
	orig_title: e.nullable(e.string()),
	director: e.array(e.string()),
	playwright: e.array(e.string()),
	actor: e.array(e.string()),
	genre: e.array(e.string()),
	language: e.array(e.string()),
	area: e.array(e.string()),
	year: e.nullable(e.number()),
	site: e.nullable(e.string()),
	duration: e.nullable(e.string()),
	imdb: e.nullable(e.string())
}), Kr = e.object({
	...Z.entries,
	type: e.literal("MusicAlbum"),
	genre: e.array(e.string()),
	artist: e.array(e.string()),
	company: e.array(e.string()),
	duration: e.nullable(e.number()),
	release_date: e.nullable(e.string()),
	track_list: e.nullable(e.string()),
	barcode: e.nullable(e.string())
}), qr = e.object({
	...Z.entries,
	type: e.literal("Podcast"),
	genre: e.array(e.string()),
	host: e.array(e.string()),
	language: e.array(e.string()),
	official_site: e.nullable(e.string())
}), Jr = e.object({
	...Z.entries,
	type: e.literal("Game"),
	genre: e.array(e.string()),
	developer: e.array(e.string()),
	publisher: e.array(e.string()),
	platform: e.array(e.string()),
	release_type: e.nullable(e.string()),
	release_date: e.nullable(e.string()),
	official_site: e.nullable(e.string())
}), Yr = e.object({
	...Z.entries,
	type: e.literal("Performance"),
	orig_title: e.nullable(e.string()),
	genre: e.array(e.string()),
	language: e.array(e.string()),
	opening_date: e.nullable(e.string()),
	closing_date: e.nullable(e.string()),
	director: e.array(e.string()),
	playwright: e.array(e.string()),
	orig_creator: e.array(e.string()),
	composer: e.array(e.string()),
	choreographer: e.array(e.string()),
	performer: e.array(e.string()),
	actor: e.array(e.string()),
	crew: e.array(e.string()),
	official_site: e.nullable(e.string())
}), Xr = e.object({
	...Z.entries,
	type: e.literal("PodcastEpisode"),
	guid: e.nullable(e.string()),
	pub_date: e.nullable(e.string()),
	media_url: e.nullable(e.string()),
	link: e.nullable(e.string()),
	duration: e.nullable(e.number())
}), Zr = e.object({
	...Z.entries,
	type: e.literal("PerformanceProduction"),
	orig_title: e.nullable(e.string()),
	language: e.array(e.string()),
	opening_date: e.nullable(e.string()),
	closing_date: e.nullable(e.string()),
	director: e.array(e.string()),
	playwright: e.array(e.string()),
	orig_creator: e.array(e.string()),
	composer: e.array(e.string()),
	choreographer: e.array(e.string()),
	performer: e.array(e.string()),
	actor: e.array(e.string()),
	crew: e.array(e.string()),
	official_site: e.nullable(e.string())
}), Qr = e.object({
	...Z.entries,
	type: e.literal("PerformanceProduction"),
	episode_number: e.nullable(e.number())
}), $r = e.pipe(e.any(), e.variant("type", [
	Hr,
	Ur,
	Wr,
	Gr,
	Kr,
	qr,
	Jr,
	Yr,
	Xr,
	Zr,
	Qr
])), ei = e.object({
	url: e.fallback(e.pipe(e.string(), e.url()), ""),
	description: e.fallback(e.string(), ""),
	country: e.fallback(e.string(), ""),
	locality: e.fallback(e.string(), ""),
	region: e.fallback(e.string(), ""),
	postal_code: e.fallback(e.string(), ""),
	street: e.fallback(e.string(), ""),
	origin_id: e.fallback(e.string(), ""),
	origin_provider: e.fallback(e.string(), ""),
	type: e.fallback(e.string(), ""),
	timezone: e.fallback(e.string(), ""),
	geom: e.fallback(e.nullable(e.object({
		coordinates: e.fallback(e.nullable(e.tuple([e.number(), e.number()])), null),
		srid: e.fallback(e.string(), "")
	})), null)
}), ti = e.pipe(e.any(), e.transform((e) => e ? {
	unread_count: e.pleroma?.unread_count,
	...e
} : null), e.object({
	last_read_id: e.string(),
	version: e.pipe(e.number(), e.integer()),
	updated_at: g,
	unread_count: e.fallback(e.optional(e.pipe(e.number(), e.integer())), void 0)
})), ni = e.record(e.string(), ti), Q = e.object({
	account: y,
	created_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString()),
	id: e.string(),
	group_key: e.string(),
	type: e.string(),
	is_muted: e.fallback(e.optional(e.boolean()), void 0),
	is_seen: e.fallback(e.optional(e.boolean()), void 0)
}), ri = e.object({
	...Q.entries,
	type: e.picklist([
		"follow",
		"follow_request",
		"follow_request_accepted",
		"admin.sign_up"
	])
}), ii = e.object({
	...Q.entries,
	type: e.literal("mention"),
	subtype: e.fallback(e.nullable(e.picklist(["reply"])), null),
	status: K
}), ai = e.object({
	...Q.entries,
	type: e.picklist([
		"status",
		"reblog",
		"favourite",
		"poll",
		"update",
		"quote",
		"quoted_update",
		"event_reminder"
	]),
	status: K
}), oi = e.object({
	...Q.entries,
	type: e.literal("admin.report"),
	report: wr
}), si = e.object({
	...Q.entries,
	type: e.literal("severed_relationships"),
	event: Cr
}), ci = e.object({
	...Q.entries,
	type: e.literal("moderation_warning"),
	moderation_warning: St
}), li = e.object({
	...Q.entries,
	type: e.literal("move"),
	target: y
}), ui = e.object({
	...Q.entries,
	type: e.literal("emoji_reaction"),
	emoji: e.string(),
	emoji_url: e.fallback(e.nullable(e.string()), null),
	status: K
}), di = e.object({
	...Q.entries,
	type: e.literal("chat_mention"),
	chat_message: rr
}), fi = e.object({
	...Q.entries,
	type: e.picklist(["participation_accepted", "participation_request"]),
	status: K,
	participation_message: e.fallback(e.nullable(e.string()), null)
}), pi = e.object({
	...Q.entries,
	type: e.literal("bite"),
	status: e.fallback(e.nullable(K), null)
}), mi = e.object({
	...Q.entries,
	type: e.literal("subscribed_reaction"),
	status: K,
	emoji: e.fallback(e.nullable(e.string()), null),
	emoji_url: e.fallback(e.nullable(e.string()), null)
}), hi = e.object({
	...Q.entries,
	type: e.picklist(["added_to_collection", "collection_update"]),
	collection: U
}), gi = e.pipe(e.any(), e.transform((e) => ({
	group_key: `ungrouped-${e.id}`,
	...p(e.pleroma || {}, ["is_muted", "is_seen"]),
	...e,
	type: e.type === "pleroma:report" ? "admin.report" : e.type === "reaction" ? "emoji_reaction" : e.type?.replace(/^pleroma:/, "")
})), e.variant("type", [
	ri,
	ii,
	ai,
	oi,
	si,
	ci,
	li,
	ui,
	di,
	fi,
	pi,
	mi,
	hi
])), _i = e.picklist([
	"accept",
	"filter",
	"drop"
]), vi = e.object({
	for_not_following: _i,
	for_not_followers: _i,
	for_new_accounts: _i,
	for_private_mentions: _i,
	for_limited_accounts: _i,
	summary: e.object({
		pending_requests_count: e.pipe(e.number(), e.integer()),
		pending_notifications_count: e.pipe(e.number(), e.integer())
	})
}), yi = e.object({
	id: e.string(),
	created_at: g,
	updated_at: g,
	account: y,
	notifications_count: e.pipe(e.unknown(), e.transform(String)),
	last_status: e.fallback(e.optional(K), void 0)
}), bi = e.pipe(e.any(), e.transform((e) => e ? e.createdAt ? {
	name: e.id,
	...e,
	app_name: e.app,
	created_at: e.createdAt,
	last_used: e.lastActive,
	is_current: e.current,
	linked_session: e.linkedSession
} : e.client_name ? {
	...e,
	app_name: e.client_name
} : e.application ? {
	...e,
	app_name: e.application.name,
	app_website: e.application.website,
	scopes: e.scope.split(" ")
} : {
	...e,
	valid_until: e?.valid_until?.padEnd(27, "Z")
} : null), e.object({
	app_name: e.string(),
	app_website: e.fallback(e.string(), ""),
	id: e.pipe(e.unknown(), e.transform(String)),
	created_at: e.fallback(e.nullable(g), null),
	valid_until: e.fallback(e.nullable(g), null),
	last_used: e.fallback(e.nullable(g), null),
	scopes: e.fallback(e.array(e.string()), []),
	is_current: e.fallback(e.nullable(e.boolean()), null),
	is_active: e.fallback(e.nullable(e.boolean()), null),
	linked_session: e.fallback(e.nullable(e.lazy(() => bi)), null)
})), xi = e.object({
	updated_at: g,
	content: e.string()
}), Si = e.object({
	url: e.string(),
	api_url: e.string(),
	visibility: e.pipe(e.number(), e.minValue(0), e.maxValue(2)),
	post_id: e.nullable(e.number()),
	item: $r,
	created_time: g,
	title: e.string(),
	body: e.string(),
	html_content: e.string()
}), Ci = e.object({
	id: e.string(),
	scheduled_at: g,
	params: e.object({
		text: e.fallback(e.nullable(e.string()), null),
		poll: e.fallback(e.nullable(e.object({
			options: e.array(e.string()),
			expires_in: e.pipe(e.unknown(), e.transform(String)),
			multiple: e.fallback(e.optional(e.boolean()), void 0),
			hide_totals: e.fallback(e.optional(e.boolean()), void 0)
		})), null),
		media_ids: e.fallback(e.nullable(e.string()), null),
		sensitive: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Boolean))), null),
		spoiler_text: e.fallback(e.nullable(e.string()), null),
		visibility: e.fallback(e.string(), "public"),
		in_reply_to_id: e.fallback(e.nullable(e.string()), null),
		language: e.fallback(e.nullable(e.string()), null),
		application_id: e.fallback(e.nullable(e.pipe(e.number(), e.integer())), null),
		scheduled_at: e.fallback(e.nullable(g), null),
		idempotency: e.fallback(e.nullable(e.string()), null),
		with_rate_limit: e.fallback(e.boolean(), !1),
		expires_in: e.fallback(e.nullable(e.number()), null)
	}),
	media_attachments: _(G)
}), wi = e.pipe(e.any(), e.transform((e) => e ? {
	external_link: e.externalLink,
	...e
} : null), e.object({
	id: e.pipe(e.unknown(), e.transform(String)),
	account: y,
	created_at: g,
	title: e.string(),
	artist: e.fallback(e.string(), ""),
	album: e.fallback(e.string(), ""),
	external_link: e.fallback(e.nullable(e.string()), null),
	length: e.fallback(e.nullable(e.number()), null)
})), Ti = e.object({
	accounts: _(y),
	statuses: _(K),
	hashtags: _(B),
	groups: _(W)
}), Ei = e.object({
	id: e.number(),
	text: e.string(),
	author: y
}), Di = e.object({
	content: e.fallback(e.string(), ""),
	spoiler_text: e.fallback(e.string(), ""),
	sensitive: e.pipe(e.unknown(), e.transform(Boolean)),
	created_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString()),
	account: y,
	poll: e.fallback(e.nullable(e.object({ options: e.array(e.object({ title: e.string() })) })), null),
	media_attachments: _(G),
	emojis: _(m)
}), Oi = e.object({
	id: e.string(),
	text: e.fallback(e.string(), ""),
	spoiler_text: e.fallback(e.string(), ""),
	content_type: e.fallback(e.string(), "text/plain"),
	location: e.fallback(e.nullable(ei), null),
	text_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null),
	spoiler_text_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null)
}), ki = e.pipe(e.any(), e.transform((e) => ({
	account_id: e.pid,
	story_id: e.sid,
	...e
})), e.object({
	account_id: e.string(),
	avatar: e.string(),
	local: e.boolean(),
	username: e.string(),
	latest: e.object({
		id: e.pipe(e.unknown(), e.transform(String)),
		type: e.string(),
		preview_url: e.string()
	}),
	url: e.string(),
	seen: e.boolean(),
	story_id: e.pipe(e.unknown(), e.transform(String))
})), Ai = e.pipe(e.any(), e.transform((e) => ({
	id: e.media_id,
	url: e.media_url,
	type: e.media_type
})), e.object({
	id: e.string(),
	url: e.string(),
	type: e.picklist(["photo", "video"])
})), ji = e.object({
	id: e.string(),
	type: e.string(),
	duration: e.number(),
	src: e.string(),
	created_at: g,
	expires_at: g,
	view_count: e.fallback(e.nullable(e.number()), null),
	seen: e.boolean(),
	progress: e.number(),
	can_reply: e.boolean(),
	can_react: e.boolean(),
	question: e.optional(e.string(), void 0),
	options: e.optional(e.array(e.string()), void 0),
	voted: e.optional(e.boolean(), void 0),
	voted_index: e.optional(e.number(), void 0)
}), Mi = e.object({
	account: y,
	nodes: _(ji)
}), Ni = e.object({
	state: e.picklist([
		"unfollow",
		"follow_pending",
		"follow_accept",
		"follow_reject"
	]),
	follower: e.object({
		id: e.string(),
		follower_count: e.fallback(e.nullable(e.number()), null),
		following_count: e.fallback(e.nullable(e.number()), null)
	}),
	following: e.object({
		id: e.string(),
		follower_count: e.fallback(e.nullable(e.number()), null),
		following_count: e.fallback(e.nullable(e.number()), null)
	})
}), $ = e.object({ stream: e.fallback(e.array(e.string()), []) }), Pi = e.object({
	...$.entries,
	event: e.picklist(["update", "status.update"]),
	payload: e.pipe(e.any(), e.transform((e) => JSON.parse(e)), K)
}), Fi = e.object({
	...$.entries,
	event: e.picklist(["delete", "announcement.delete"]),
	payload: e.string()
}), Ii = e.object({
	...$.entries,
	event: e.literal("notification"),
	payload: e.pipe(e.any(), e.transform((e) => JSON.parse(e)), gi)
}), Li = e.object({
	...$.entries,
	event: e.literal("filters_changed")
}), Ri = e.object({
	...$.entries,
	event: e.literal("conversation"),
	payload: e.pipe(e.any(), e.transform((e) => JSON.parse(e)), sr)
}), zi = e.object({
	...$.entries,
	event: e.literal("announcement"),
	payload: e.pipe(e.any(), e.transform((e) => JSON.parse(e)), Ot)
}), Bi = e.object({
	...$.entries,
	event: e.literal("announcement.reaction"),
	payload: e.pipe(e.any(), e.transform((e) => JSON.parse(e)), Tt)
}), Vi = e.object({
	...$.entries,
	event: e.literal("chat_update"),
	payload: e.pipe(e.any(), e.transform((e) => JSON.parse(e)), ir)
}), Hi = e.object({
	...$.entries,
	event: e.literal("follow_relationships_update"),
	payload: e.pipe(e.any(), e.transform((e) => JSON.parse(e)), Ni)
}), Ui = e.object({
	...$.entries,
	event: e.literal("respond"),
	payload: e.pipe(e.any(), e.transform((e) => JSON.parse(e)), e.object({
		type: e.string(),
		result: e.picklist([
			"success",
			"ignored",
			"error"
		])
	}))
}), Wi = e.object({
	...$.entries,
	event: e.literal("marker"),
	payload: e.pipe(e.any(), e.transform((e) => JSON.parse(e)), ni)
}), Gi = e.object({
	...$.entries,
	event: e.literal("notifications_merged")
}), Ki = e.object({
	...$.entries,
	event: e.literal("emoji_reaction"),
	payload: e.pipe(e.any(), e.transform((e) => JSON.parse(e)), cn)
}), qi = e.pipe(e.any(), e.transform((e) => ({
	...e,
	event: e.event?.replace(/^pleroma:/, "")
})), e.variant("event", [
	Pi,
	Fi,
	Ii,
	Li,
	Ri,
	zi,
	Bi,
	Vi,
	Hi,
	Ui,
	Wi,
	Gi,
	Ki
])), Ji = e.object({
	id: e.number(),
	expires_at: e.fallback(g, () => (/* @__PURE__ */ new Date()).toISOString())
}), Yi = e.object({
	id: e.string(),
	sender_id: e.string(),
	recipient_id: e.string(),
	chain_id: e.string(),
	payment_address: e.string(),
	amount: e.number(),
	status: e.picklist([
		"open",
		"paid",
		"forwarded",
		"timeout",
		"cancelled",
		"underpaid",
		"completed",
		"failed"
	]),
	created_at: g,
	expires_at: g
}), Xi = e.variant("type", [e.object({
	type: e.literal("monero"),
	chain_id: e.string(),
	price: e.nullable(e.number()),
	payout_address: e.string()
})]), Zi = e.pipe(e.any(), e.transform((e) => {
	if (!e) return null;
	if (e?.acct) return {
		source: "staff",
		sources: ["featured"],
		account: e
	};
	if (!e.sources) switch (e.sources = [], e.source) {
		case "staff":
			e.sources.push("staff");
			break;
		case "global":
			e.sources.push("most_interactions");
			break;
	}
	return e;
}), e.object({
	source: e.fallback(e.nullable(e.string()), null),
	sources: e.fallback(e.array(e.string()), []),
	account: y
})), Qi = e.object({
	effective_date: de,
	effective: e.boolean(),
	content: e.string(),
	succeeded_by: e.fallback(e.nullable(de), null)
}), $i = e.object({
	access_token: e.string(),
	token_type: e.string(),
	scope: e.string(),
	created_at: e.fallback(e.optional(e.number()), void 0),
	id: e.fallback(e.optional(e.pipe(e.unknown(), e.transform(String))), void 0),
	refresh_token: e.fallback(e.optional(e.string()), void 0),
	expires_in: e.fallback(e.optional(e.number()), void 0),
	me: e.fallback(e.optional(e.string()), void 0)
}), ea = e.pipe(e.any(), e.transform((e) => ({
	...e,
	id: e.url
})), e.object({
	id: e.fallback(e.string(), ""),
	url: e.fallback(e.pipe(e.string(), e.url()), ""),
	title: e.fallback(e.string(), ""),
	description: e.fallback(e.string(), ""),
	type: e.fallback(e.picklist([
		"link",
		"photo",
		"video",
		"rich"
	]), "link"),
	author_name: e.fallback(e.string(), ""),
	author_url: e.fallback(e.string(), ""),
	provider_name: e.fallback(e.string(), ""),
	provider_url: e.fallback(e.string(), ""),
	html: e.fallback(e.string(), ""),
	width: e.fallback(e.nullable(e.number()), null),
	height: e.fallback(e.nullable(e.number()), null),
	image: e.fallback(e.nullable(e.string()), null),
	image_description: e.fallback(e.nullable(e.string()), null),
	embed_url: e.fallback(e.string(), ""),
	blurhash: e.fallback(e.nullable(Sn), null),
	history: e.fallback(e.nullable(Dt), null)
})), ta = e.object({
	iss: e.string(),
	sub: e.string(),
	name: e.string(),
	preferred_username: e.string(),
	profile: e.string(),
	picture: e.fallback(e.string(), "")
}), na = e.object({
	id: e.pipe(e.unknown(), e.transform(String)),
	endpoint: e.string(),
	standard: e.fallback(e.boolean(), !1),
	alerts: e.record(e.string(), e.boolean()),
	server_key: e.string()
}), ra = (t) => ({
	getAccount: async (n, r) => {
		let i = await t.request(`/api/v1/accounts/${n}`, { params: r });
		return e.parse(y, i.json);
	},
	getAccounts: async (n) => {
		let r = await t.request("/api/v1/accounts", { params: { id: n } });
		return e.parse(_(y), r.json);
	},
	getAccountStatuses: (e, n) => t.paginatedGet(`/api/v1/accounts/${e}/statuses`, { params: n }, K),
	getAccountFollowers: (e, n) => t.paginatedGet(`/api/v1/accounts/${e}/followers`, { params: n }, y),
	getAccountFollowing: (e, n) => t.paginatedGet(`/api/v1/accounts/${e}/following`, { params: n }, y),
	getAccountSubscribers: (e, n) => t.paginatedGet(`/api/v1/accounts/${e}/subscribers`, { params: n }, y),
	getAccountFeaturedTags: async (n) => {
		let r = await t.request(`/api/v1/accounts/${n}/featured_tags`);
		return e.parse(_(br), r.json);
	},
	getAccountLists: async (n) => {
		let r = await t.request(`/api/v1/accounts/${n}/lists`);
		return e.parse(_(J), r.json);
	},
	getAccountAntennas: async (n) => {
		let r = await t.request(`/api/v1/accounts/${n}/antennas`);
		return e.parse(_(Y), r.json);
	},
	getAccountExcludeAntennas: async (n) => {
		let r = await t.request(`/api/v1/accounts/${n}/exclude_antennas`);
		return e.parse(_(ar), r.json);
	},
	getAccountCircles: async (n) => {
		let r = await t.request(`/api/v1/accounts/${n}/circles`);
		return e.parse(_(Y), r.json);
	},
	followAccount: async (n, r) => {
		let i = await t.request(`/api/v1/accounts/${n}/follow`, {
			method: "POST",
			body: r
		});
		return e.parse(h, i.json);
	},
	unfollowAccount: async (n) => {
		let r = await t.request(`/api/v1/accounts/${n}/unfollow`, { method: "POST" });
		return e.parse(h, r.json);
	},
	removeAccountFromFollowers: async (n) => {
		let r = await t.request(`/api/v1/accounts/${n}/remove_from_followers`, { method: "POST" });
		return e.parse(h, r.json);
	},
	pinAccount: async (n) => {
		let r = await t.request(`/api/v1/accounts/${n}/pin`, { method: "POST" });
		return e.parse(h, r.json);
	},
	unpinAccount: async (n) => {
		let r = await t.request(`/api/v1/accounts/${n}/unpin`, { method: "POST" });
		return e.parse(h, r.json);
	},
	updateAccountNote: async (n, r) => {
		let i = await t.request(`/api/v1/accounts/${n}/note`, {
			method: "POST",
			body: { comment: r }
		});
		return e.parse(h, i.json);
	},
	getRelationships: async (n, r) => {
		let i = await t.request("/api/v1/accounts/relationships", { params: {
			...r,
			id: n
		} });
		return e.parse(_(h), i.json);
	},
	getFamiliarFollowers: async (n) => {
		let r;
		return r = t.features.version.software === "Pixelfed" ? (await Promise.allSettled(n.map(async (e) => ({
			id: e,
			accounts: (await t.request(`/api/v1.1/accounts/mutuals/${e}`)).json
		})))).map((e, t) => e.status === "fulfilled" ? e.value : {
			id: n[t],
			accounts: []
		}) : (await t.request("/api/v1/accounts/familiar_followers", { params: { id: n } })).json, e.parse(_(yr), r);
	},
	searchAccounts: async (n, r, i) => {
		let a = await t.request("/api/v1/accounts/search", {
			...i,
			params: {
				...r,
				q: n
			}
		});
		return e.parse(_(y), a.json);
	},
	lookupAccount: async (n, r) => {
		let i = await t.request("/api/v1/accounts/lookup", {
			...r,
			params: { acct: n }
		});
		return e.parse(y, i.json);
	},
	reportAccount: async (n, r) => {
		let i = await t.request("/api/v1/reports", {
			method: "POST",
			body: {
				...r,
				account_id: n
			}
		});
		return e.parse(wr, i.json);
	},
	getAccountEndorsements: (e, n) => t.paginatedGet(`/api/v1/${t.features.version.software === "Pleroma" ? "pleroma/" : ""}accounts/${e}/endorsements`, { params: n }, y),
	getBirthdays: async (n, r) => {
		let i = await t.request("/api/v1/pleroma/birthdays", { params: {
			day: n,
			month: r
		} });
		return e.parse(_(y), i.json);
	},
	getAccountFavourites: (e, n) => t.paginatedGet(`/api/v1/pleroma/accounts/${e}/favourites`, { params: n }, K),
	remoteInteraction: async (n, r) => {
		let i = await t.request("/api/v1/pleroma/remote_interaction", {
			method: "POST",
			body: {
				ap_id: n,
				profile: r
			}
		});
		if (i.json?.error) throw i.json.error;
		return e.parse(e.object({ url: e.string() }), i.json);
	},
	biteAccount: async (e) => {
		let n;
		switch (t.features.version.software) {
			case O:
				n = await t.request("/api/v1/bite", {
					method: "POST",
					body: e
				});
				break;
			default:
				n = await t.request("/api/v1/bite", {
					method: "POST",
					params: { id: e }
				});
				break;
		}
		return n.json;
	},
	getScrobbles: (e, n) => t.paginatedGet(`/api/v1/pleroma/accounts/${e}/scrobbles`, { params: n }, wi),
	createScrobble: async (n) => {
		n.external_link && (n.externalLink = n.external_link);
		let r = await t.request("/api/v1/pleroma/scrobble", { body: n });
		return e.parse(wi, r.json);
	},
	loadActivities: async (e) => (await t.request(`/api/v1/accounts/${e}/load_activities`, { method: "POST" })).json,
	subscribeByEmail: async (e, n) => (await t.request(`/api/v1/accounts/${e}/email_subscriptions`, {
		method: "POST",
		body: { email: n }
	})).json
}), ia = async (t, n) => {
	let r = await t.request("/api/v1/pleroma/admin/users", { params: n });
	return new R(e.parse(_(z), r.json?.users), {
		previous: n.page && n.page > 1 ? () => ia(t, {
			...n,
			page: n.page - 1
		}) : null,
		next: r.json?.count > n.page_size * ((n.page || 1) - 1) + r.json?.users?.length ? () => ia(t, {
			...n,
			page: (n.page ?? 1) + 1
		}) : null,
		partial: r.status === 206,
		total: r.json?.count
	});
}, aa = async (t, n) => {
	let r = await t.request("/api/v1/pleroma/admin/reports", { params: n });
	return new R(e.parse(_(q), r.json?.reports), {
		previous: n.page && n.page > 1 ? () => aa(t, {
			...n,
			page: n.page - 1
		}) : null,
		next: r.json?.total > n.page_size * ((n.page || 1) - 1) + r.json?.reports?.length ? () => aa(t, {
			...n,
			page: (n.page ?? 1) + 1
		}) : null,
		partial: r.status === 206,
		total: r.json?.total
	});
}, oa = async (t, n = "/api/v1/pleroma/admin/statuses", r) => {
	let i = await t.request(n, { params: r });
	return new R(e.parse(_(K), i.json.activities).toReversed(), {
		previous: r.page && r.page > 1 ? () => oa(t, n, {
			...r,
			page: r.page - 1
		}) : null,
		next: i.json?.total > (r.page_size ?? 20) * ((r.page || 1) - 1) + i.json?.activities?.length ? () => oa(t, n, {
			...r,
			page: (r.page ?? 1) + 1
		}) : null,
		partial: i.status === 206
	});
}, sa = (e, t, n) => {
	for (let r of [
		":media_removal",
		":report_removal",
		":federated_timeline_removal",
		":reject"
	]) {
		let i = e.value.find(({ tuple: e }) => e[0] === r);
		i ? i.tuple[1] = i.tuple[1].filter(({ tuple: e }) => e[0] !== t) : (i = { tuple: [r, []] }, e.value.push(i)), (n.reject_media && r === ":media_removal" || n.reject_reports && r === ":report_removal" || n.severity === "silence" && r === ":federated_timeline_removal" || n.severity === "suspend" && r === ":reject") && i.tuple[1].push({ tuple: [t, n.public_comment || ""] });
	}
}, ca = (t) => {
	let n = {
		accounts: {
			getAccounts: (e) => t.features.mastodonAdminV2 ? t.paginatedGet("/api/v2/admin/accounts", { params: e }, z) : ia(t, e ? {
				query: e.username,
				name: e.display_name,
				email: e.email,
				filters: [
					e.origin === "local" && "local",
					e.origin === "remote" && "external",
					e.status === "active" && "active",
					e.status === "pending" && "need_approval",
					e.status === "disabled" && "deactivated",
					e.permissions === "staff" && "is_admin",
					e.permissions === "staff" && "is_moderator"
				].filter((e) => e).join(","),
				page_size: 100
			} : { page_size: 100 }),
			getAccount: async (n) => {
				let r;
				return r = t.features.mastodonAdmin ? await t.request(`/api/v1/admin/accounts/${n}`) : await t.request(`/api/v1/pleroma/admin/users/${n}`), e.parse(z, r.json);
			},
			approveAccount: async (r) => {
				let i;
				if (t.features.mastodonAdmin) i = await t.request(`/api/v1/admin/accounts/${r}/approve`, { method: "POST" });
				else {
					let e = await n.accounts.getAccount(r);
					i = await t.request("/api/v1/pleroma/admin/users/approve", {
						method: "PATCH",
						body: { nicknames: [e.username] }
					}), i.json = i.json?.users?.[0];
				}
				return e.parse(z, i.json);
			},
			rejectAccount: async (r) => {
				let i;
				if (t.features.mastodonAdmin) i = await t.request(`/api/v1/admin/accounts/${r}/reject`, { method: "POST" });
				else {
					let e = await n.accounts.getAccount(r);
					i = await t.request("/api/v1/pleroma/admin/users", {
						method: "DELETE",
						body: { nicknames: [e.username] }
					});
				}
				return e.safeParse(z, i.json).output || {};
			},
			createAccount: async (n) => {
				let r = await t.request("/api/v1/pleroma/admin/users", {
					method: "POST",
					body: { users: [n] }
				});
				return e.parse(e.object({
					nickname: e.string(),
					email: e.string()
				}), r.json[0]?.data);
			},
			deleteAccount: async (r) => {
				let i;
				if (t.features.mastodonAdmin || t.features.version.software === "Mitra") i = await t.request(`/api/v1/admin/accounts/${r}`, { method: "DELETE" });
				else if (t.features.iceshrimpAdmin) await t.getIceshrimpAccessToken(), i = await t.request(`/api/iceshrimp/moderation/users/${r}/purge`, { method: "POST" });
				else {
					let e = await n.accounts.getAccount(r);
					i = await t.request("/api/v1/pleroma/admin/users", {
						method: "DELETE",
						body: { nicknames: [e.username] }
					});
				}
				return e.safeParse(z, i.json).output || {};
			},
			performAccountAction: async (e, r, i) => {
				let a;
				if (t.features.mastodonAdmin) a = await t.request(`/api/v1/admin/accounts/${e}/action`, { body: {
					...i,
					type: r
				} });
				else if (t.features.iceshrimpAdmin) switch (r) {
					case "disable":
					case "suspend":
						await t.getIceshrimpAccessToken(), a = await t.request(`/api/iceshrimp/moderation/users/${e}/suspend`, { method: "POST" });
						break;
					default:
						a = { json: {} };
						break;
				}
				else {
					let o = await n.accounts.getAccount(e);
					switch (r) {
						case "disable":
						case "suspend":
							a = await t.request("/api/v1/pleroma/admin/users/deactivate", { body: { nicknames: [o.username] } });
							break;
						default:
							a = { json: {} };
							break;
					}
					i?.report_id && await n.reports.resolveReport(i.report_id);
				}
				return a.json;
			},
			enableAccount: async (r) => {
				let i;
				if (t.features.mastodonAdmin) i = await t.request(`/api/v1/admin/accounts/${r}/enable`, { method: "POST" });
				else if (t.features.iceshrimpAdmin) await t.getIceshrimpAccessToken(), i = await t.request(`/api/iceshrimp/moderation/users/${r}/unsuspend`, { method: "POST" });
				else {
					let e = await n.accounts.getAccount(r);
					i = await t.request("/api/v1/pleroma/admin/users/activate", {
						method: "PATCH",
						body: { nicknames: [e.username] }
					}), i.json = i.json?.users?.[0];
				}
				return e.parse(z, i.json);
			},
			unsilenceAccount: async (n) => {
				let r = await t.request(`/api/v1/admin/accounts/${n}/unsilence`, { method: "POST" });
				return e.parse(z, r.json);
			},
			unsuspendAccount: async (r) => {
				let i;
				if (t.features.mastodonAdmin) i = await t.request(`/api/v1/admin/accounts/${r}/unsuspend`, { method: "POST" });
				else if (t.features.iceshrimpAdmin) await t.getIceshrimpAccessToken(), i = await t.request(`/api/iceshrimp/moderation/users/${r}/unsuspend`, { method: "POST" });
				else {
					let { account: e } = await n.accounts.getAccount(r);
					i = await t.request("/api/v1/pleroma/admin/users/activate", {
						method: "PATCH",
						body: { nicknames: [e.acct] }
					}), i.json = i.json?.users?.[0];
				}
				return e.parse(z, i.json);
			},
			unsensitiveAccount: async (n) => {
				let r = await t.request(`/api/v1/admin/accounts/${n}/unsensitive`, { method: "POST" });
				return e.parse(z, r.json);
			},
			promoteToAdmin: async (e) => {
				let { account: r } = await n.accounts.getAccount(e);
				return await t.request("/api/v1/pleroma/admin/users/permission_group/moderator", {
					method: "DELETE",
					body: { nicknames: [r.acct] }
				}), (await t.request("/api/v1/pleroma/admin/users/permission_group/admin", {
					method: "POST",
					body: { nicknames: [r.acct] }
				})).json;
			},
			promoteToModerator: async (e) => {
				let { account: r } = await n.accounts.getAccount(e);
				return await t.request("/api/v1/pleroma/admin/users/permission_group/admin", {
					method: "DELETE",
					body: { nicknames: [r.acct] }
				}), (await t.request("/api/v1/pleroma/admin/users/permission_group/moderator", {
					method: "POST",
					body: { nicknames: [r.acct] }
				})).json;
			},
			demoteToUser: async (e) => {
				let { account: r } = await n.accounts.getAccount(e);
				return await t.request("/api/v1/pleroma/admin/users/permission_group/moderator", {
					method: "DELETE",
					body: { nicknames: [r.acct] }
				}), (await t.request("/api/v1/pleroma/admin/users/permission_group/admin", {
					method: "DELETE",
					body: { nicknames: [r.acct] }
				})).json;
			},
			suggestUser: async (e) => {
				let { account: r } = await n.accounts.getAccount(e);
				return (await t.request("/api/v1/pleroma/admin/users/suggest", {
					method: "PATCH",
					body: { nicknames: [r.acct] }
				})).json;
			},
			unsuggestUser: async (e) => {
				let { account: r } = await n.accounts.getAccount(e);
				return (await t.request("/api/v1/pleroma/admin/users/unsuggest", {
					method: "PATCH",
					body: { nicknames: [r.acct] }
				})).json;
			},
			tagUser: async (e, r) => {
				let { account: i } = await n.accounts.getAccount(e);
				return (await t.request("/api/v1/pleroma/admin/users/tag", {
					method: "PUT",
					body: {
						nicknames: [i.acct],
						tags: r
					}
				})).json;
			},
			untagUser: async (e, r) => {
				let { account: i } = await n.accounts.getAccount(e);
				return (await t.request("/api/v1/pleroma/admin/users/tag", {
					method: "DELETE",
					body: {
						nicknames: [i.acct],
						tags: r
					}
				})).json;
			},
			updateCredentials: async (e, r) => {
				let { account: i } = await n.accounts.getAccount(e);
				return await t.request(`/api/v1/pleroma/admin/users/${i.acct}/credentials`, {
					method: "PATCH",
					body: r
				}), n.accounts.getAccount(e);
			},
			disableMfa: async (e) => {
				let r;
				if (t.features.iceshrimpAdmin) await t.getIceshrimpAccessToken(), r = await t.request(`/api/iceshrimp/admin/users/${e}/reset-2fa`, { method: "POST" });
				else {
					let { account: i } = await n.accounts.getAccount(e);
					r = await t.request("/api/v1/pleroma/admin/users/disable_mfa", {
						method: "PUT",
						body: { nickname: i.acct }
					});
				}
				return r.json;
			},
			resetPassword: async (e, r) => {
				let i;
				if (t.features.iceshrimpAdmin) await t.getIceshrimpAccessToken(), i = await t.request(`/api/iceshrimp/admin/users/${e}/reset-password`, {
					method: "POST",
					body: { password: r }
				});
				else {
					let { account: a } = await n.accounts.getAccount(e);
					i = await t.request(`/api/v1/pleroma/admin/users/${a.acct}/credentials`, {
						method: "PATCH",
						body: { password: r }
					});
				}
				return i.json;
			},
			getAccountStatuses: (e, n) => oa(t, `/api/v1/pleroma/admin/users/${e}/statuses`, {
				page_size: n?.limit || 20,
				page: 1,
				local_only: n?.local_only,
				with_reblogs: n?.with_reblogs,
				godmode: n?.with_private
			})
		},
		domainBlocks: {
			getDomainBlocks: async (e) => {
				if (t.features.version.software === "Pleroma" || t.features.version.software === "Akkoma") {
					let { configs: e } = await n.config.getPleromaConfig(), t = e.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || void 0, r = [];
					if (t) {
						let e = t.value.find(({ tuple: e }) => e[0] === ":media_removal")?.tuple[1] || [], n = t.value.find(({ tuple: e }) => e[0] === ":report_removal")?.tuple[1] || [], i = t.value.find(({ tuple: e }) => e[0] === ":federated_timeline_removal")?.tuple[1] || [], a = t.value.find(({ tuple: e }) => e[0] === ":reject")?.tuple[1] || [], o = new Set([
							...e,
							...n,
							...i,
							...a
						].map((e) => e.tuple[0]).filter((e) => e)), s = new TextEncoder();
						for (let t of o) r.push({
							id: t,
							domain: t,
							digest: new Uint8Array(await window.crypto.subtle.digest("SHA-256", s.encode(t))).toHex(),
							created_at: null,
							severity: a.some(({ tuple: e }) => e[0] === t) ? "suspend" : i.some(({ tuple: e }) => e[0] === t) ? "silence" : "noop",
							reject_media: e.some(({ tuple: e }) => e[0] === t),
							reject_reports: n.some(({ tuple: e }) => e[0] === t),
							private_comment: null,
							public_comment: [
								...a,
								...i,
								...e,
								...n
							].find(({ tuple: e }) => e[0] === t)?.tuple[1] || null,
							obfuscate: !1
						});
					}
					return new R(r);
				}
				let r;
				return t.features.version.software === "Iceshrimp.NET" ? (await t.getIceshrimpAccessToken(), r = "/api/iceshrimp/admin/instances/blocked") : r = "/api/v1/admin/domain_blocks", t.paginatedGet(r, { params: e }, Lt);
			},
			getDomainBlock: async (r) => {
				if (t.features.version.software === "Pleroma" || t.features.version.software === "Akkoma") return (await n.domainBlocks.getDomainBlocks()).items.find((e) => e.id === r);
				let i = await t.request(`/api/v1/admin/domain_blocks/${r}`);
				return e.parse(Lt, i.json);
			},
			createDomainBlock: async (r, i) => {
				if (t.features.version.software === "Pleroma" || t.features.version.software === "Akkoma") {
					let { configs: e } = await n.config.getPleromaConfig(), a = e.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || {
						group: ":pleroma",
						key: ":mrf_simple",
						value: []
					};
					return sa(a, r, i || { severity: "silence" }), await t.request("/api/v1/pleroma/admin/config", {
						method: "POST",
						body: { configs: [a] }
					}), {};
				} else if (t.features.version.software === "Iceshrimp.NET") return await t.getIceshrimpAccessToken(), (await t.request(`/api/iceshrimp/admin/instances/${r}/block`, {
					method: "POST",
					params: { reason: i?.public_comment }
				})).json;
				let a = await t.request("/api/v1/admin/domain_blocks", {
					method: "POST",
					body: {
						...i,
						domain: r
					}
				});
				return e.parse(Lt, a.json);
			},
			updateDomainBlock: async (r, i) => {
				if (t.features.version.software === "Pleroma" || t.features.version.software === "Akkoma") {
					let { configs: e } = await n.config.getPleromaConfig(), a = e.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || {
						group: ":pleroma",
						key: ":mrf_simple",
						value: []
					};
					return sa(a, r, i), await t.request("/api/v1/pleroma/admin/config", {
						method: "POST",
						body: { configs: [a] }
					}), {};
				} else if (t.features.version.software === "Iceshrimp.NET") return await t.getIceshrimpAccessToken(), await t.request(`/api/iceshrimp/admin/instances/${r}/unblock`, { method: "POST" }), (await t.request(`/api/iceshrimp/admin/instances/${r}/block`, {
					method: "POST",
					params: { reason: i.public_comment }
				})).json;
				let a = await t.request(`/api/v1/admin/domain_blocks/${r}`, {
					method: "PUT",
					body: i
				});
				return e.parse(Lt, a.json);
			},
			deleteDomainBlock: async (e) => {
				if (t.features.version.software === "Pleroma" || t.features.version.software === "Akkoma") {
					let { configs: r } = await n.config.getPleromaConfig(), i = r.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || void 0;
					return i && ([
						":media_removal",
						":report_removal",
						":federated_timeline_removal",
						":reject"
					].forEach((t) => {
						let n = i.value.find(({ tuple: e }) => e[0] === t);
						n && (n.tuple[1] = n.tuple[1].filter(({ tuple: t }) => t[0] !== e));
					}), await t.request("/api/v1/pleroma/admin/config", {
						method: "POST",
						body: { configs: [i] }
					})), {};
				} else if (t.features.version.software === "Iceshrimp.NET") return await t.getIceshrimpAccessToken(), (await t.request(`/api/iceshrimp/admin/instances/${e}/unblock`, { method: "POST" })).json;
				return (await t.request(`/api/v1/admin/domain_blocks/${e}`, { method: "DELETE" })).json;
			},
			expireDomainKeys: async (n) => {
				let r = await t.request("/api/v1/admin/domain_keys_expire", {
					method: "POST",
					body: { domain: n },
					formData: !0
				});
				return e.parse(wt, r.json);
			}
		},
		reports: {
			getReports: async (e) => t.features.mastodonAdmin ? (e?.unresolved && t.features.version.software === "GoToSocial" && !t.features.mastodonAdminUnresolvedReports ? (e ||= {}, e.resolved = !1) : e?.unresolved && !e?.resolved && t.features.version.software === "GoToSocial" && t.features.mastodonAdminUnresolvedReports && (delete e.unresolved, delete e.resolved), t.paginatedGet("/api/v1/admin/reports", { params: e }, q)) : t.features.version.software === "Iceshrimp.NET" ? (await t.getIceshrimpAccessToken(), t.paginatedGet("/api/iceshrimp/moderation/reports", { params: e }, q)) : aa(t, {
				state: e?.resolved === !0 ? "resolved" : "open",
				page_size: e?.limit || 100
			}),
			getReport: async (n) => {
				let r;
				return t.features.mastodonAdmin ? r = await t.request(`/api/v1/admin/reports/${n}`) : t.features.version.software === "Iceshrimp.NET" ? (await t.getIceshrimpAccessToken(), r = await t.request(`/api/iceshrimp/moderation/reports/${n}`)) : r = await t.request(`/api/v1/pleroma/admin/reports/${n}`), e.parse(q, r.json);
			},
			updateReport: async (n, r) => {
				let i = await t.request(`/api/v1/admin/reports/${n}`, {
					method: "PUT",
					body: r
				});
				return e.parse(q, i.json);
			},
			assignReportToSelf: async (n) => {
				let r = await t.request(`/api/v1/admin/reports/${n}/assign_to_self`, { method: "POST" });
				return e.parse(q, r.json);
			},
			unassignReport: async (n) => {
				let r = await t.request(`/api/v1/admin/reports/${n}/unassign`, { method: "POST" });
				return e.parse(q, r.json);
			},
			resolveReport: async (r, i) => {
				let a;
				if (t.features.mastodonAdmin) a = await t.request(`/api/v1/admin/reports/${r}/resolve`, {
					method: "POST",
					body: { action_taken_comment: i }
				});
				else if (t.features.version.software === "Iceshrimp.NET") return await t.getIceshrimpAccessToken(), await t.request(`/api/iceshrimp/moderation/reports/${r}/resolve`, { method: "POST" }), n.reports.getReport(r);
				else a = await t.request(`/api/v1/pleroma/admin/reports/${r}`, {
					method: "PATCH",
					body: { reports: [{
						id: r,
						state: "resolved"
					}] }
				});
				return e.parse(q, a.json);
			},
			reopenReport: async (n) => {
				let r;
				return r = t.features.mastodonAdmin ? await t.request(`/api/v1/admin/reports/${n}/reopen`, { method: "POST" }) : await t.request(`/api/v1/pleroma/admin/reports/${n}`, {
					method: "PATCH",
					body: { reports: [{
						id: n,
						state: "open"
					}] }
				}), e.parse(q, r.json);
			},
			forwardReport: async (e) => (await t.getIceshrimpAccessToken(), await t.request(`/api/iceshrimp/moderation/reports/${e}/forward`, { method: "POST" }), n.reports.getReport(e))
		},
		statuses: {
			getStatuses: (e) => oa(t, void 0, {
				page_size: e?.limit || 100,
				page: 1,
				local_only: e?.local_only,
				with_reblogs: e?.with_reblogs,
				godmode: e?.with_private
			}),
			getStatus: async (n) => {
				let r = await t.request(`/api/v1/pleroma/admin/statuses/${n}`);
				return e.parse(K, r.json);
			},
			updateStatus: async (n, r) => {
				let i = await t.request(`/api/v1/pleroma/admin/statuses/${n}`, {
					method: "PUT",
					body: r
				});
				return e.parse(K, i.json);
			},
			deleteStatus: async (e) => (await t.request(t.features.version.software === "Mitra" ? `/api/v1/admin/posts/${e}` : t.features.iceshrimpAdmin ? `/api/iceshrimp/moderation/notes/${e}` : `/api/v1/pleroma/admin/statuses/${e}`, { method: "DELETE" })).json,
			redactStatus: async (n, r) => {
				let i = await t.request(`/api/v1/pleroma/admin/statuses/${n}/redact`, {
					method: "PATCH",
					body: r
				});
				return e.parse(K, i.json);
			},
			getStatusSource: async (n) => {
				let r = await t.request(`/api/v1/pleroma/admin/statuses/${n}/source`);
				return e.parse(Oi, r.json);
			}
		},
		trends: {
			getTrendingLinks: async () => {
				let n = await t.request("/api/v1/admin/trends/links");
				return e.parse(_(ea), n.json);
			},
			getTrendingStatuses: async () => {
				let n = await t.request("/api/v1/admin/trends/statuses");
				return e.parse(_(K), n.json);
			},
			getTrendingTags: async () => {
				let n = await t.request("/api/v1/admin/trends/tags");
				return e.parse(_(Yn), n.json);
			}
		},
		canonicalEmailBlocks: {
			getCanonicalEmailBlocks: (e) => t.paginatedGet("/api/v1/admin/canonical_email_blocks", { params: e }, At),
			getCanonicalEmailBlock: async (n) => {
				let r = await t.request(`/api/v1/admin/canonical_email_blocks/${n}`);
				return e.parse(At, r.json);
			},
			testCanonicalEmailBlock: async (n) => {
				let r = await t.request("/api/v1/admin/canonical_email_blocks/test", {
					method: "POST",
					body: { email: n }
				});
				return e.parse(_(At), r.json);
			},
			createCanonicalEmailBlock: async (n, r) => {
				let i = await t.request("/api/v1/admin/canonical_email_blocks", {
					method: "POST",
					body: {
						email: n,
						canonical_email_hash: r
					}
				});
				return e.parse(At, i.json);
			},
			deleteCanonicalEmailBlock: async (e) => (await t.request(`/api/v1/admin/canonical_email_blocks/${e}`, { method: "DELETE" })).json
		},
		dimensions: { getDimensions: async (n, r) => {
			let i = await t.request("/api/v1/admin/dimensions", {
				method: "POST",
				params: {
					...r,
					keys: n
				}
			});
			return e.parse(_(Pt), i.json);
		} },
		domainAllows: {
			getDomainAllows: async (e) => {
				if (t.features.version.software === "Pleroma" || t.features.version.software === "Akkoma") {
					let { configs: e } = await n.config.getPleromaConfig(), t = e.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || void 0, r = [];
					return t && (r = (t.value.find(({ tuple: e }) => e[0] === ":accept")?.tuple[1] || []).map(({ tuple: e }) => ({
						id: e[0],
						domain: e[0],
						created_at: null,
						is_imported: !1
					}))), new R(r);
				}
				let r;
				return t.features.version.software === "Iceshrimp.NET" ? (await t.getIceshrimpAccessToken(), r = "/api/iceshrimp/admin/instances/allowed") : r = "/api/v1/admin/domain_allows", t.paginatedGet(r, { params: e }, It);
			},
			getDomainAllow: async (r) => {
				if (t.features.version.software === "Pleroma" || t.features.version.software === "Akkoma") return (await n.domainAllows.getDomainAllows()).items.find((e) => e.id === r);
				let i = await t.request(`/api/v1/admin/domain_allows/${r}`);
				return e.parse(It, i.json);
			},
			createDomainAllow: async (r) => {
				if (t.features.version.software === "Pleroma" || t.features.version.software === "Akkoma") {
					let { configs: e } = await n.config.getPleromaConfig(), i = e.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || void 0;
					if (i) {
						let e = i.value.find(({ tuple: e }) => e[0] === ":accept");
						if (e || (e = { tuple: [":accept", []] }, i.value.push(e)), e.tuple[1].find(({ tuple: e }) => e[0] === r)) return {};
						e.tuple[1].push({ tuple: [r, ""] }), await t.request("/api/v1/pleroma/admin/config", {
							method: "POST",
							body: { configs: [i] }
						});
					}
					return {};
				} else if (t.features.version.software === "Iceshrimp.NET") return await t.getIceshrimpAccessToken(), (await t.request(`/api/iceshrimp/admin/instances/${r}/allow`, { method: "POST" })).json;
				let i = await t.request("/api/v1/admin/domain_allows", {
					method: "POST",
					body: { domain: r }
				});
				return e.parse(It, i.json);
			},
			deleteDomainAllow: async (e) => {
				if (t.features.version.software === "Pleroma" || t.features.version.software === "Akkoma") {
					let { configs: r } = await n.config.getPleromaConfig(), i = r.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || void 0;
					if (i) {
						let n = i.value.find(({ tuple: e }) => e[0] === ":accept");
						n && (n.tuple[1] = n.tuple[1].filter(({ tuple: t }) => t[0] !== e), await t.request("/api/v1/pleroma/admin/config", {
							method: "POST",
							body: { configs: [i] }
						}));
					}
					return {};
				} else if (t.features.version.software === "Iceshrimp.NET") return await t.getIceshrimpAccessToken(), (await t.request(`/api/iceshrimp/admin/instances/${e}/disallow`, { method: "POST" })).json;
				return (await t.request(`/api/v1/admin/domain_allows/${e}`, { method: "DELETE" })).json;
			}
		},
		emailDomainBlocks: {
			getEmailDomainBlocks: (e) => t.paginatedGet("/api/v1/admin/email_domain_blocks", { params: e }, Wt),
			getEmailDomainBlock: async (n) => {
				let r = await t.request(`/api/v1/admin/email_domain_blocks/${n}`);
				return e.parse(Wt, r.json);
			},
			createEmailDomainBlock: async (n) => {
				let r = await t.request("/api/v1/admin/email_domain_blocks", {
					method: "POST",
					body: { domain: n }
				});
				return e.parse(Wt, r.json);
			},
			deleteEmailDomainBlock: async (e) => (await t.request(`/api/v1/admin/email_domain_blocks/${e}`, { method: "DELETE" })).json
		},
		ipBlocks: {
			getIpBlocks: (e) => t.paginatedGet("/api/v1/admin/ip_blocks", { params: e }, Yt),
			getIpBlock: async (n) => {
				let r = await t.request(`/api/v1/admin/ip_blocks/${n}`);
				return e.parse(Yt, r.json);
			},
			createIpBlock: async (n) => {
				let r = await t.request("/api/v1/admin/ip_blocks", {
					method: "POST",
					body: n
				});
				return e.parse(Yt, r.json);
			},
			updateIpBlock: async (n, r) => {
				let i = await t.request(`/api/v1/admin/ip_blocks/${n}`, {
					method: "PUT",
					body: r
				});
				return e.parse(Yt, i.json);
			},
			deleteIpBlock: async (e) => (await t.request(`/api/v1/admin/ip_blocks/${e}`, { method: "DELETE" })).json
		},
		measures: { getMeasures: async (n, r, i, a) => {
			let o = await t.request("/api/v1/admin/measures", {
				method: "POST",
				params: {
					...a,
					keys: n,
					start_at: r,
					end_at: i
				}
			});
			return e.parse(_(Xt), o.json);
		} },
		retention: { getRetention: async (n, r, i) => {
			let a = await t.request("/api/v1/admin/retention", {
				method: "POST",
				params: {
					start_at: n,
					end_at: r,
					frequency: i
				}
			});
			return e.parse(_(jt), a.json);
		} },
		announcements: {
			getAnnouncements: async (r) => {
				let i = await t.request("/api/v1/pleroma/admin/announcements", { params: r }), a = e.parse(_(kt), i.json);
				return new R(a, {
					next: a.length ? () => n.announcements.getAnnouncements({
						...r,
						offset: (r?.offset || 0) + a.length
					}) : null,
					partial: !1
				});
			},
			getAnnouncement: async (n) => {
				let r = await t.request(`/api/v1/pleroma/admin/announcements/${n}`);
				return e.parse(kt, r.json);
			},
			createAnnouncement: async (n) => {
				let r = await t.request("/api/v1/pleroma/admin/announcements", {
					method: "POST",
					body: n
				});
				return e.parse(kt, r.json);
			},
			updateAnnouncement: async (n, r) => {
				let i = await t.request(`/api/v1/pleroma/admin/announcements/${n}`, {
					method: "PATCH",
					body: r
				});
				return e.parse(kt, i.json);
			},
			deleteAnnouncement: async (e) => (await t.request(`/api/v1/pleroma/admin/announcements/${e}`, { method: "DELETE" })).json
		},
		domains: {
			getDomains: async () => {
				let n = await t.request("/api/v1/pleroma/admin/domains");
				return e.parse(_(Ft), n.json);
			},
			createDomain: async (n) => {
				let r = await t.request("/api/v1/pleroma/admin/domains", {
					method: "POST",
					body: n
				});
				return e.parse(Ft, r.json);
			},
			updateDomain: async (n, r) => {
				let i = await t.request(`/api/v1/pleroma/admin/domains/${n}`, {
					method: "PATCH",
					body: { public: r }
				});
				return e.parse(Ft, i.json);
			},
			deleteDomain: async (e) => (await t.request(`/api/v1/pleroma/admin/domains/${e}`, { method: "DELETE" })).json
		},
		moderationLog: { getModerationLog: async ({ limit: r, ...i } = {}) => {
			let a = await t.request("/api/v1/pleroma/admin/moderation_log", { params: {
				page_size: r,
				...i
			} });
			return new R(e.parse(_(Zt), a.json.items), {
				previous: i.page && i.page > 1 ? () => n.moderationLog.getModerationLog({
					...i,
					page: i.page - 1
				}) : null,
				next: a.json.total > (i.page || 1) * (r || 50) ? () => n.moderationLog.getModerationLog({
					...i,
					page: (i.page || 1) + 1
				}) : null,
				partial: a.status === 206
			});
		} },
		relays: {
			getRelays: async () => {
				let n;
				return t.features.adminRelaySubscriptions ? n = await t.request("/api/v1/admin/relay_subscriptions") : t.features.version.software === "Iceshrimp.NET" ? (await t.getIceshrimpAccessToken(), n = await t.request("/api/iceshrimp/admin/relays")) : (n = await t.request("/api/v1/pleroma/admin/relay"), n.json = n.json.relays), e.parse(_(H), n.json);
			},
			followRelay: async (n, r) => {
				let i;
				return t.features.adminRelaySubscriptions ? i = await t.request("/api/v1/admin/relay_subscriptions", {
					method: "POST",
					body: {
						...r,
						relay_actor_uri: n
					}
				}) : t.features.version.software === "Iceshrimp.NET" ? (await t.getIceshrimpAccessToken(), i = await t.request("/api/iceshrimp/admin/relays", {
					method: "POST",
					body: { inbox: n }
				})) : i = await t.request("/api/v1/pleroma/admin/relay", {
					method: "POST",
					body: { relay_url: n }
				}), e.parse(e.optional(H), i.json);
			},
			unfollowRelay: async (n, r = !1) => {
				let i;
				return t.features.adminRelaySubscriptions ? i = await t.request(`/api/v1/admin/relay_subscriptions/${n}`, { method: "DELETE" }) : t.features.version.software === "Iceshrimp.NET" ? (await t.getIceshrimpAccessToken(), i = await t.request(`/api/iceshrimp/admin/relays/${n}`, { method: "DELETE" })) : i = await t.request("/api/v1/pleroma/admin/relay", {
					method: "DELETE",
					body: {
						relay_url: n,
						force: r
					}
				}), e.parse(e.optional(H), i.json);
			},
			getRelay: async (n) => {
				let r = await t.request(`/api/v1/admin/relay_subscriptions/${n}`);
				return e.parse(H, r.json);
			},
			updateRelay: async (n, r) => {
				let i = await t.request(`/api/v1/admin/relay_subscriptions/${n}`, {
					method: "PUT",
					body: r
				});
				return e.parse(H, i.json);
			},
			createRelayMatcher: async (n, r) => {
				let i = await t.request(`/api/v1/admin/relay_subscriptions/${n}/matchers`, {
					method: "POST",
					body: r
				});
				return e.parse(H, i.json);
			},
			deleteRelayMatcher: async (n, r) => {
				let i = await t.request(`/api/v1/admin/relay_subscriptions/${n}/matchers/${r}`, { method: "DELETE" });
				return e.parse(H, i.json);
			},
			updateRelayMatcher: async (n, r, i) => {
				let a = await t.request(`/api/v1/admin/relay_subscriptions/${n}/matchers/${r}`, {
					method: "PUT",
					body: i
				});
				return e.parse(H, a.json);
			}
		},
		rules: {
			getRules: async () => {
				let n = await t.request(t.features.version.software === "GoToSocial" ? "/api/v1/admin/instance/rules" : "/api/v1/pleroma/admin/rules");
				return e.parse(_(Jn), n.json);
			},
			createRule: async (n) => {
				let r = await t.request(t.features.version.software === "GoToSocial" ? "/api/v1/admin/instance/rules" : "/api/v1/pleroma/admin/rules", {
					method: "POST",
					body: n
				});
				return e.parse(Jn, r.json);
			},
			updateRule: async (n, r) => {
				let i = await t.request(`/api/v1/${t.features.version.software === "GoToSocial" ? "admin/instance" : "pleroma/admin"}/rules/${n}`, {
					method: "PATCH",
					body: r
				});
				return e.parse(Jn, i.json);
			},
			deleteRule: async (e) => (await t.request(`/api/v1/${t.features.version.software === "GoToSocial" ? "admin/instance" : "pleroma/admin"}/rules/${e}`, { method: "DELETE" })).json
		},
		config: {
			getPleromaConfigDescriptions: async () => {
				let n = await t.request("/api/v1/pleroma/admin/config/descriptions");
				return e.parse(e.array(en), n.json);
			},
			getPleromaConfig: async () => {
				let n = await t.request("/api/v1/pleroma/admin/config");
				return e.parse(Qt, n.json);
			},
			updatePleromaConfig: async (n) => {
				let r = await t.request("/api/v1/pleroma/admin/config", {
					method: "POST",
					body: { configs: n }
				});
				return e.parse(Qt, r.json);
			}
		},
		customEmojis: {
			getCustomEmojis: (e) => t.paginatedGet("/api/v1/admin/custom_emojis", { params: e }, Mt),
			getCustomEmojiCategories: async () => {
				let n = await t.request("/api/v1/admin/custom_emojis/categories");
				return e.parse(_(Nt), n.json);
			},
			getCustomEmoji: async (n) => {
				let r = await t.request(`/api/v1/admin/custom_emojis/${n}`);
				return e.parse(Mt, r.json);
			},
			createCustomEmoji: async (n) => {
				let r = await t.request("/api/v1/admin/custom_emojis", {
					method: "POST",
					body: n,
					formData: !0
				});
				return e.parse(Mt, r.json);
			},
			updateCustomEmoji: async (n, r) => {
				let i = await t.request(`/api/v1/admin/custom_emojis/${n}`, {
					method: "PATCH",
					body: r,
					formData: !0
				});
				return e.parse(Mt, i.json);
			},
			deleteCustomEmoji: async (n) => {
				let r = await t.request(`/api/v1/admin/custom_emojis/${n}`, { method: "DELETE" });
				return e.parse(Mt, r.json);
			}
		},
		invites: {
			getInvites: async () => {
				let n = await t.request("/api/v1/pleroma/admin/users/invites");
				return e.parse(_(Jt), n.json?.invites);
			},
			createInviteToken: async (n = {}) => {
				if (t.features.iceshrimpAdmin) {
					await t.getIceshrimpAccessToken();
					let n = await t.request("/api/iceshrimp/admin/invites/generate", { method: "POST" });
					return e.parse(Jt, { token: n.json.code });
				}
				let r = await t.request("/api/v1/pleroma/admin/users/invite_token", {
					method: "POST",
					body: n
				});
				return e.parse(Jt, r.json);
			},
			revokeInviteToken: async (e) => t.features.iceshrimpAdmin ? (await t.getIceshrimpAccessToken(), t.request(`/api/iceshrimp/admin/invites/${e}/revoke`, { method: "POST" })) : t.request("/api/v1/pleroma/admin/users/revoke_invite", {
				method: "POST",
				body: { token: e }
			}),
			emailInvite: async (e) => {
				await t.request("/api/v1/pleroma/admin/users/email_invite", {
					method: "POST",
					body: e
				});
			}
		},
		domainLimits: {
			getDomainLimits: (e) => t.paginatedGet("/api/v1/admin/domain_limits", { params: e }, Ht),
			createDomainLimit: async (n) => {
				let r = await t.request("/api/v1/admin/domain_limits", {
					method: "POST",
					body: n
				});
				return e.parse(Ht, r.json);
			},
			updateDomainLimit: async (n, r) => {
				let i = await t.request(`/api/v1/admin/domain_limits/${n}`, {
					method: "PUT",
					body: r
				});
				return e.parse(Ht, i.json);
			},
			deleteDomainLimit: async (n) => {
				let r = await t.request(`/api/v1/admin/domain_limits/${n}`, { method: "DELETE" });
				return e.parse(Ht, r.json);
			}
		},
		domainPermissionDrafts: {
			getDomainPermissionDrafts: (e) => t.paginatedGet("/api/v1/admin/domain_permission_drafts", { params: e }, V),
			getDomainPermissionDraft: async (n) => {
				let r = await t.request(`/api/v1/admin/domain_permission_drafts/${n}`);
				return e.parse(V, r.json);
			},
			createDomainPermissionDraft: async (n) => {
				let r = await t.request("/api/v1/admin/domain_permission_drafts", {
					method: "POST",
					body: n
				});
				return e.parse(V, r.json);
			},
			acceptDomainPermissionDraft: async (n, r) => {
				let i = await t.request(`/api/v1/admin/domain_permission_drafts/${n}/accept`, {
					method: "POST",
					body: { overwrite: r }
				});
				return e.parse(V, i.json);
			},
			removeDomainPermissionDraft: async (n, r) => {
				let i = await t.request(`/api/v1/admin/domain_permission_drafts/${n}/remove`, {
					method: "POST",
					body: { exclude_target: r }
				});
				return e.parse(V, i.json);
			}
		},
		domainPermissionExcludes: {
			getDomainPermissionExcludes: (e) => t.paginatedGet("/api/v1/admin/domain_permission_excludes", { params: e }, V),
			getDomainPermissionExclude: async (n) => {
				let r = await t.request(`/api/v1/admin/domain_permission_excludes/${n}`);
				return e.parse(V, r.json);
			},
			createDomainPermissionExclude: async (n) => {
				let r = await t.request("/api/v1/admin/domain_permission_excludes", {
					method: "POST",
					body: n
				});
				return e.parse(V, r.json);
			},
			deleteDomainPermissionExclude: async (n) => {
				let r = await t.request(`/api/v1/admin/domain_permission_excludes/${n}`, { method: "DELETE" });
				return e.parse(V, r.json);
			}
		},
		domainPermissionSubscriptions: {
			getDomainPermissionSubscriptions: (e) => t.paginatedGet("/api/v1/admin/domain_permission_subscriptions", { params: e }, Ut),
			getDomainPermissionSubscriptionsPreview: async (n) => {
				let r = await t.request("/api/v1/admin/domain_permission_subscriptions/preview", { params: { permission_type: n } });
				return e.parse(_(Ut), r.json);
			},
			getDomainPermissionSubscription: async (n) => {
				let r = await t.request(`/api/v1/admin/domain_permission_subscriptions/${n}`);
				return e.parse(Ut, r.json);
			},
			createDomainPermissionSubscription: async (n) => {
				let r = await t.request("/api/v1/admin/domain_permission_subscriptions", {
					method: "POST",
					body: n
				});
				return e.parse(Ut, r.json);
			},
			updateDomainPermissionSubscription: async (n, r) => {
				let i = await t.request(`/api/v1/admin/domain_permission_subscriptions/${n}`, {
					method: "PATCH",
					body: r
				});
				return e.parse(Ut, i.json);
			},
			testDomainPermissionSubscription: async (n) => {
				let r = await t.request(`/api/v1/admin/domain_permission_subscriptions/${n}/test`, { method: "POST" });
				return e.parse(_(V), r.json);
			},
			removeDomainPermissionSubscription: async (n, r) => {
				let i = await t.request(`/api/v1/admin/domain_permission_subscriptions/${n}/remove`, {
					method: "POST",
					body: { remove_children: r }
				});
				return e.parse(Ut, i.json);
			}
		},
		headerFilters: {
			getHeaderAllows: async () => {
				let n = await t.request("/api/v1/admin/header_allows");
				return e.parse(_(Gt), n.json);
			},
			getHeaderAllow: async (n) => {
				let r = await t.request(`/api/v1/admin/header_allows/${n}`);
				return e.parse(Gt, r.json);
			},
			createHeaderAllow: async (n) => {
				let r = await t.request("/api/v1/admin/header_allows", {
					method: "POST",
					body: n
				});
				return e.parse(Gt, r.json);
			},
			deleteHeaderAllow: async (e) => (await t.request(`/api/v1/admin/header_allows/${e}`, { method: "DELETE" })).json,
			getHeaderBlocks: async () => {
				let n = await t.request("/api/v1/admin/header_blocks");
				return e.parse(_(Gt), n.json);
			},
			getHeaderBlock: async (n) => {
				let r = await t.request(`/api/v1/admin/header_blocks/${n}`);
				return e.parse(Gt, r.json);
			},
			createHeaderBlock: async (n) => {
				let r = await t.request("/api/v1/admin/header_blocks", {
					method: "POST",
					body: n
				});
				return e.parse(Gt, r.json);
			},
			deleteHeaderBlock: async (e) => (await t.request(`/api/v1/admin/header_blocks/${e}`, { method: "DELETE" })).json
		},
		instances: {
			getInstances: (e) => t.paginatedGet("/api/v1/admin/instances", { params: e }, qt),
			getInstance: async (n) => {
				let r = await t.request(`/api/v1/admin/instances/${n}`);
				return e.parse(qt, r.json);
			},
			clearInstanceDeliveryErrors: async (n) => {
				let r = await t.request(`/api/v1/admin/instances/${n}/clear_delivery_errors`, { method: "POST" });
				return e.parse(qt, r.json);
			}
		},
		media: {
			cleanupMedia: async (e) => (await t.request("/api/v1/admin/media_cleanup", {
				method: "POST",
				params: e
			})).json,
			purgeMedia: async (e) => (await t.request("/api/v1/admin/media_purge", {
				method: "POST",
				params: { domain: e }
			})).json,
			refetchMedia: async (e) => (await t.request("/api/v1/admin/media_refetch", {
				method: "POST",
				params: { domain: e }
			})).json
		},
		email: { sendTestEmail: async (e, n) => (await t.request("/api/v1/admin/email/test", {
			method: "POST",
			body: {
				email: e,
				message: n
			},
			formData: !0
		})).json },
		policies: {
			getPolicies: async () => (await t.getIceshrimpAccessToken(), (await t.request("/api/iceshrimp/admin/policy")).json),
			getPolicy: async (e) => (await t.getIceshrimpAccessToken(), (await t.request(`/api/iceshrimp/admin/policy/${e}`)).json),
			setPolicy: async (e, n) => (await t.getIceshrimpAccessToken(), (await t.request(`/api/iceshrimp/admin/policy/${e}`, {
				method: "PUT",
				body: n
			})).json)
		}
	};
	return n;
}, la = (t) => ({
	getAnnouncements: async () => {
		let n = await t.request("/api/v1/announcements");
		return e.parse(_(Ot), n.json);
	},
	dismissAnnouncements: async (e) => (await t.request(`/api/v1/announcements/${e}`, { method: "POST" })).json,
	addAnnouncementReaction: async (e, n) => (await t.request(`/api/v1/announcements/${e}/reactions/${n}`, { method: "PUT" })).json,
	deleteAnnouncementReaction: async (e, n) => (await t.request(`/api/v1/announcements/${e}/reactions/${n}`, { method: "DELETE" })).json
}), ua = (t) => ({
	fetchAntennas: async () => {
		let n = await t.request("/api/v1/antennas");
		return e.parse(_(Y), n.json);
	},
	getAntennas: async (n) => {
		let r = await t.request(`/api/v1/antennas/${n}`);
		return e.parse(Y, r.json);
	},
	createAntenna: async (n) => {
		let r = await t.request("/api/v1/antennas", {
			method: "POST",
			body: n
		});
		return e.parse(Y, r.json);
	},
	updateAntenna: async (n, r) => {
		let i = await t.request(`/api/v1/antennas/${n}`, {
			method: "PUT",
			body: r
		});
		return e.parse(Y, i.json);
	},
	deleteAntenna: async (e) => (await t.request(`/api/v1/antennas/${e}`, { method: "DELETE" })).json,
	getAntennaAccounts: (e) => t.paginatedGet(`/api/v1/antennas/${e}/accounts`, {}, y),
	addAntennaAccounts: async (e, n) => (await t.request(`/api/v1/antennas/${e}/accounts`, {
		method: "POST",
		body: { account_ids: n }
	})).json,
	removeAntennaAccounts: async (e, n) => (await t.request(`/api/v1/antennas/${e}/accounts`, {
		method: "DELETE",
		body: { account_ids: n }
	})).json,
	getAntennaExcludedAccounts: (e) => t.paginatedGet(`/api/v1/antennas/${e}/exclude_accounts`, {}, y),
	addAntennaExcludedAccounts: async (e, n) => (await t.request(`/api/v1/antennas/${e}/exclude_accounts`, {
		method: "POST",
		body: { account_ids: n }
	})).json,
	removeAntennaExcludedAccounts: async (e, n) => (await t.request(`/api/v1/antennas/${e}/exclude_accounts`, {
		method: "DELETE",
		body: { account_ids: n }
	})).json,
	getAntennaDomains: async (n) => {
		let r = await t.request(`/api/v1/antennas/${n}/domains`);
		return e.parse(e.object({
			domains: _(e.string()),
			exclude_domains: _(e.string())
		}), r.json);
	},
	addAntennaDomains: async (e, n) => (await t.request(`/api/v1/antennas/${e}/domains`, {
		method: "POST",
		body: { domains: n }
	})).json,
	removeAntennaDomains: async (e, n) => (await t.request(`/api/v1/antennas/${e}/domains`, {
		method: "DELETE",
		body: { domains: n }
	})).json,
	addAntennaExcludedDomains: async (e, n) => (await t.request(`/api/v1/antennas/${e}/exclude_domains`, {
		method: "POST",
		body: { domains: n }
	})).json,
	removeAntennaExcludedDomains: async (e, n) => (await t.request(`/api/v1/antennas/${e}/exclude_domains`, {
		method: "DELETE",
		body: { domains: n }
	})).json,
	getAntennaKeywords: async (n) => {
		let r = await t.request(`/api/v1/antennas/${n}/keywords`);
		return e.parse(e.object({
			keywords: _(e.string()),
			exclude_keywords: _(e.string())
		}), r.json);
	},
	addAntennaKeywords: async (e, n) => (await t.request(`/api/v1/antennas/${e}/keywords`, {
		method: "POST",
		body: { keywords: n }
	})).json,
	removeAntennaKeywords: async (e, n) => (await t.request(`/api/v1/antennas/${e}/keywords`, {
		method: "DELETE",
		body: { keywords: n }
	})).json,
	addAntennaExcludedKeywords: async (e, n) => (await t.request(`/api/v1/antennas/${e}/exclude_keywords`, {
		method: "POST",
		body: { keywords: n }
	})).json,
	removeAntennaExcludedKeywords: async (e, n) => (await t.request(`/api/v1/antennas/${e}/exclude_keywords`, {
		method: "DELETE",
		body: { keywords: n }
	})).json,
	getAntennaTags: async (n) => {
		let r = await t.request(`/api/v1/antennas/${n}/tags`);
		return e.parse(e.object({
			tags: _(e.string()),
			exclude_tags: _(e.string())
		}), r.json);
	},
	addAntennaTags: async (e, n) => (await t.request(`/api/v1/antennas/${e}/tags`, {
		method: "POST",
		body: { tags: n }
	})).json,
	removeAntennaTags: async (e, n) => (await t.request(`/api/v1/antennas/${e}/tags`, {
		method: "DELETE",
		body: { tags: n }
	})).json,
	addAntennaExcludedTags: async (e, n) => (await t.request(`/api/v1/antennas/${e}/exclude_tags`, {
		method: "POST",
		body: { tags: n }
	})).json,
	removeAntennaExcludedTags: async (e, n) => (await t.request(`/api/v1/antennas/${e}/exclude_tags`, {
		method: "DELETE",
		body: { tags: n }
	})).json
}), da = (t) => ({
	createApplication: async (n) => {
		let r = await t.request("/api/v1/apps", {
			method: "POST",
			body: n
		});
		return e.parse(Qn, r.json);
	},
	verifyApplication: async () => {
		let n = await t.request("/api/v1/apps/verify_credentials");
		return e.parse(Zn, n.json);
	}
}), fa = (t) => ({ show: async (n) => {
	let r = await t.request(`/api/v1_alpha/async_refreshes/${n}`);
	return e.parse($n, r.json);
} }), pa = (t) => ({
	createChat: async (n) => {
		let r = await t.request(`/api/v1/pleroma/chats/by-account-id/${n}`, { method: "POST" });
		return e.parse(ir, r.json);
	},
	getChat: async (n) => {
		let r = await t.request(`/api/v1/pleroma/chats/${n}`);
		return e.parse(ir, r.json);
	},
	markChatAsRead: async (n, r) => {
		let i = await t.request(`/api/v1/pleroma/chats/${n}/read`, {
			method: "POST",
			body: { last_read_id: r }
		});
		return e.parse(ir, i.json);
	},
	markChatMessageAsRead: async (n, r) => {
		let i = await t.request(`/api/v1/pleroma/chats/${n}/messages/${r}/read`, { method: "POST" });
		return e.parse(ir, i.json);
	},
	getChats: (e) => t.paginatedGet("/api/v2/pleroma/chats", { params: e }, ir),
	getChatMessages: (e, n) => t.paginatedGet(`/api/v1/pleroma/chats/${e}/messages`, { params: n }, rr),
	createChatMessage: async (n, r) => {
		let i = await t.request(`/api/v1/pleroma/chats/${n}/messages`, {
			method: "POST",
			body: r
		});
		return e.parse(rr, i.json);
	},
	deleteChatMessage: async (n, r) => {
		let i = await t.request(`/api/v1/pleroma/chats/${n}/messages/${r}`, { method: "DELETE" });
		return e.parse(rr, i.json);
	},
	deleteChat: async (n) => {
		let r = await t.request(`/api/v1/pleroma/chats/${n}`, { method: "DELETE" });
		return e.parse(ir, r.json);
	}
}), ma = (t) => ({
	fetchCircles: async () => {
		let n = await t.request("/api/v1/circles");
		return e.parse(_(ar), n.json);
	},
	getCircle: async (n) => {
		let r = await t.request(`/api/v1/circles/${n}`);
		return e.parse(ar, r.json);
	},
	createCircle: async (n) => {
		let r = await t.request("/api/v1/circles", {
			method: "POST",
			body: { title: n }
		});
		return e.parse(ar, r.json);
	},
	updateCircle: async (n, r) => {
		let i = await t.request(`/api/v1/circles/${n}`, {
			method: "PUT",
			body: { title: r }
		});
		return e.parse(ar, i.json);
	},
	deleteCircle: async (e) => (await t.request(`/api/v1/circles/${e}`, { method: "DELETE" })).json,
	getCircleAccounts: (e, n) => t.paginatedGet(`/api/v1/circles/${e}/accounts`, { params: n }, y),
	addCircleAccounts: async (e, n) => (await t.request(`/api/v1/circles/${e}/accounts`, {
		method: "POST",
		body: { account_ids: n }
	})).json,
	deleteCircleAccounts: async (e, n) => (await t.request(`/api/v1/circles/${e}/accounts`, {
		method: "DELETE",
		body: { account_ids: n }
	})).json,
	getCircleStatuses: (e, n) => t.paginatedGet(`/api/v1/circles/${e}/statuses`, { params: n }, K)
}), ha = (t) => {
	let n = async (r, i) => {
		let a = await t.request(r, { params: i }), { prev: o, next: s } = ht(a);
		return new R(e.parse(_(U), a.json?.collections), {
			previous: o ? () => n(o) : null,
			next: s ? () => n(s) : null,
			partial: a.status === 206
		});
	};
	return {
		createCollection: async (n) => {
			let r = await t.request("/api/v1/collections", {
				method: "POST",
				body: n
			});
			return e.parse(U, r.json?.collection);
		},
		getCollection: async (n) => {
			let r = await t.request(`/api/v1/collections/${n}`);
			return e.parse(an, r.json);
		},
		getAccountCollections: (e, t) => n(`/api/v1/accounts/${e}/collections`, t),
		getAccountInCollections: (e, t) => n(`/api/v1/accounts/${e}/in_collections`, t),
		updateCollection: async (n, r) => {
			let i = await t.request(`/api/v1/collections/${n}`, {
				method: "PATCH",
				body: r
			});
			return e.parse(U, i.json?.collection);
		},
		deleteCollection: async (e) => (await t.request(`/api/v1/collections/${e}`, { method: "DELETE" })).json,
		addCollectionItem: async (n, r) => {
			let i = await t.request(`/api/v1/collections/${n}/items`, {
				method: "POST",
				body: { account_id: r }
			});
			return e.parse(rn, i.json?.collection_item);
		},
		removeCollectionItem: async (e, n) => (await t.request(`/api/v1/collections/${e}/items/${n}`, { method: "DELETE" })).json,
		revokeCollectionItem: async (e, n) => (await t.request(`/api/v1/collections/${e}/items/${n}/revoke`, { method: "POST" })).json
	};
}, ga = (t) => ({
	getDrive: async () => {
		await t.getIceshrimpAccessToken();
		let n = await t.request("/api/iceshrimp/drive/folder");
		return e.parse(gr, n.json);
	},
	getFolder: async (n) => {
		await t.getIceshrimpAccessToken();
		let r = await t.request(`/api/iceshrimp/drive/folder/${n}`);
		return e.parse(gr, r.json);
	},
	createFolder: async (n, r) => {
		await t.getIceshrimpAccessToken();
		let i = await t.request("/api/iceshrimp/drive/folder", {
			method: "POST",
			body: {
				name: n,
				parentId: r || null
			}
		});
		return e.parse(gr, i.json);
	},
	updateFolder: async (n, r) => {
		await t.getIceshrimpAccessToken();
		let i = await t.request(`/api/iceshrimp/drive/folder/${n}`, {
			method: "PUT",
			body: r
		});
		return e.parse(gr, i.json);
	},
	deleteFolder: async (e) => (await t.getIceshrimpAccessToken(), await t.request(`/api/iceshrimp/drive/folder/${e}`, { method: "DELETE" })),
	moveFolder: async (n, r) => {
		await t.getIceshrimpAccessToken();
		let i = await t.request(`/api/iceshrimp/drive/folder/${n}/move`, {
			method: "POST",
			body: { folderId: r || null }
		});
		return e.parse(gr, i.json);
	},
	getFile: async (n) => {
		await t.getIceshrimpAccessToken();
		let r = await t.request(`/api/iceshrimp/drive/${n}`);
		return e.parse(pr, r.json);
	},
	createFile: async (n, r) => {
		await t.getIceshrimpAccessToken();
		let i = await t.request("/api/iceshrimp/drive", {
			method: "POST",
			body: { file: n },
			params: { folderId: r },
			formData: !0
		});
		return e.parse(pr, i.json);
	},
	updateFile: async (n, r) => {
		await t.getIceshrimpAccessToken();
		let i = await t.request(`/api/iceshrimp/drive/${n}`, {
			method: "PATCH",
			body: r
		});
		return e.parse(pr, i.json);
	},
	deleteFile: async (e) => (await t.getIceshrimpAccessToken(), await t.request(`/api/iceshrimp/drive/${e}`, { method: "DELETE" })),
	moveFile: async (n, r) => {
		await t.getIceshrimpAccessToken();
		let i = await t.request(`/api/iceshrimp/drive/${n}/move`, {
			method: "POST",
			body: { folderId: r || null }
		});
		return e.parse(pr, i.json);
	},
	getDriveStatus: async () => {
		await t.getIceshrimpAccessToken();
		let n = await t.request("/api/iceshrimp/drive/status");
		return e.parse(_r, n.json);
	}
}), _a = (e) => ({ resendConfirmationEmail: async (t) => (await e.request("/api/v1/emails/confirmations", {
	method: "POST",
	body: { email: t }
})).json }), va = (t) => ({
	createEvent: async (n) => {
		let r = await t.request("/api/v1/pleroma/events", {
			method: "POST",
			body: n
		});
		return e.parse(K, r.json);
	},
	editEvent: async (n, r) => {
		let i = await t.request(`/api/v1/pleroma/events/${n}`, {
			method: "PUT",
			body: r
		});
		return e.parse(K, i.json);
	},
	getJoinedEvents: (e, n) => t.paginatedGet("/api/v1/pleroma/events/joined_events", { params: {
		...n,
		state: e
	} }, K),
	getEventParticipations: (e, n) => t.paginatedGet(`/api/v1/pleroma/events/${e}/participations`, { params: n }, y),
	getEventParticipationRequests: (n, r) => t.paginatedGet(`/api/v1/pleroma/events/${n}/participation_requests`, { params: r }, e.object({
		account: y,
		participation_message: e.fallback(e.string(), "")
	})),
	acceptEventParticipationRequest: async (n, r) => {
		let i = await t.request(`/api/v1/pleroma/events/${n}/participation_requests/${r}/authorize`, { method: "POST" });
		return e.parse(K, i.json);
	},
	rejectEventParticipationRequest: async (n, r) => {
		let i = await t.request(`/api/v1/pleroma/events/${n}/participation_requests/${r}/reject`, { method: "POST" });
		return e.parse(K, i.json);
	},
	joinEvent: async (n, r) => {
		let i = await t.request(`/api/v1/pleroma/events/${n}/join`, {
			method: "POST",
			body: { participation_message: r }
		});
		return e.parse(K, i.json);
	},
	leaveEvent: async (n) => {
		let r = await t.request(`/api/v1/pleroma/events/${n}/leave`, { method: "POST" });
		return e.parse(K, r.json);
	},
	getEventIcs: async (e) => (await t.request(`/api/v1/pleroma/events/${e}/ics`, { formData: !0 })).data
}), ya = (t) => {
	let n = {
		admin: { groups: {
			getGroups: async (n) => {
				let r = await t.request("/api/v1/admin/groups", { params: n });
				return e.parse(_(W), r.json);
			},
			getGroup: async (n) => {
				let r = await t.request(`/api/v1/admin/groups/${n}`);
				return e.parse(W, r.json);
			},
			suspendGroup: async (n) => {
				let r = await t.request(`/api/v1/admin/groups/${n}/suspend`, { method: "POST" });
				return e.parse(W, r.json);
			},
			unsuspendGroup: async (n) => {
				let r = await t.request(`/api/v1/admin/groups/${n}/unsuspend`, { method: "POST" });
				return e.parse(W, r.json);
			},
			deleteGroup: async (n) => {
				let r = await t.request(`/api/v1/admin/groups/${n}`, { method: "DELETE" });
				return e.parse(W, r.json);
			}
		} },
		groups: {
			getGroups: async () => {
				let n;
				return n = t.features.version.software === "Pixelfed" ? await t.request("/api/v0/groups/self/list") : await t.request("/api/v1/groups"), e.parse(_(W), n.json);
			},
			createGroup: async (r) => {
				let i;
				if (t.features.version.software === "Pixelfed") {
					if (i = await t.request("/api/v0/groups/create", {
						method: "POST",
						body: {
							...r,
							name: r.display_name,
							description: r.note,
							membership: "public"
						},
						formData: !!(r.avatar || r.header)
					}), i.json?.id) return n.groups.getGroup(i.json.id);
				} else i = await t.request("/api/v1/groups", {
					method: "POST",
					body: r,
					formData: !!(r.avatar || r.header)
				});
				return e.parse(W, i.json);
			},
			getGroup: async (n) => {
				let r;
				return r = t.features.version.software === "Pixelfed" ? await t.request(`/api/v0/groups/${n}`) : await t.request(`/api/v1/groups/${n}`), e.parse(W, r.json);
			},
			updateGroup: async (n, r) => {
				let i = await t.request(`/api/v1/groups/${n}`, {
					method: "PUT",
					body: r,
					formData: !!(r.avatar || r.header)
				});
				return e.parse(W, i.json);
			},
			deleteGroup: async (e) => {
				let n;
				return n = t.features.version.software === "Pixelfed" ? await t.request("/api/v0/groups/delete", {
					method: "POST",
					params: { gid: e }
				}) : await t.request(`/api/v1/groups/${e}`, { method: "DELETE" }), n.json;
			},
			getGroupMemberships: (e, n, r) => t.paginatedGet(t.features.version.software === "Pixelfed" ? `/api/v0/groups/members/list?gid=${e}` : `/api/v1/groups/${e}/memberships`, { params: {
				...r,
				role: n
			} }, gn),
			getGroupMembershipRequests: (e, n) => t.paginatedGet(t.features.version.software === "Pixelfed" ? `/api/v0/groups/members/requests?gid=${e}` : `/api/v1/groups/${e}/membership_requests`, { params: n }, y),
			acceptGroupMembershipRequest: async (e, n) => (await t.request(`/api/v1/groups/${e}/membership_requests/${n}/authorize`, { method: "POST" })).json,
			rejectGroupMembershipRequest: async (e, n) => (await t.request(`/api/v1/groups/${e}/membership_requests/${n}/reject`, { method: "POST" })).json,
			deleteGroupStatus: async (n, r) => {
				let i = await t.request(`/api/v1/groups/${n}/statuses/${r}`, { method: "DELETE" });
				return e.parse(K, i.json);
			},
			getGroupBlocks: (e, n) => t.paginatedGet(`/api/v1/groups/${e}/blocks`, { params: n }, y),
			blockGroupUsers: async (e, n) => (await t.request(`/api/v1/groups/${e}/blocks`, {
				method: "POST",
				params: { account_ids: n }
			})).json,
			unblockGroupUsers: async (e, n) => (await t.request(`/api/v1/groups/${e}/blocks`, {
				method: "DELETE",
				params: { account_ids: n }
			})).json,
			joinGroup: async (n) => {
				let r = await t.request(`/api/v1/groups/${n}/join`, { method: "POST" });
				return e.parse(_n, r.json);
			},
			leaveGroup: async (n) => {
				let r = await t.request(`/api/v1/groups/${n}/leave`, { method: "POST" });
				return e.parse(_n, r.json);
			},
			kickGroupUsers: async (e, n) => (await t.request(`/api/v1/groups/${e}/kick`, {
				method: "POST",
				params: { account_ids: n }
			})).json,
			promoteGroupUsers: async (n, r, i) => {
				let a = await t.request(`/api/v1/groups/${n}/promote`, {
					method: "POST",
					params: {
						account_ids: r,
						role: i
					}
				});
				return e.parse(_(gn), a.json);
			},
			demoteGroupUsers: async (n, r, i) => {
				let a = await t.request(`/api/v1/groups/${n}/demote`, {
					method: "POST",
					params: {
						account_ids: r,
						role: i
					}
				});
				return e.parse(_(gn), a.json);
			},
			getGroupRelationships: async (n) => {
				let r = await t.request("/api/v1/groups/relationships", { params: { id: n } });
				return e.parse(_(_n), r.json);
			}
		}
	};
	return n;
}, ba = (t) => ({
	blockAccount: async (n, r) => {
		let i = await t.request(`/api/v1/accounts/${n}/block`, {
			method: "POST",
			body: r
		});
		return e.parse(h, i.json);
	},
	unblockAccount: async (n) => {
		let r = await t.request(`/api/v1/accounts/${n}/unblock`, { method: "POST" });
		return e.parse(h, r.json);
	},
	muteAccount: async (n, r) => {
		let i = await t.request(`/api/v1/accounts/${n}/mute`, {
			method: "POST",
			body: r
		});
		return e.parse(h, i.json);
	},
	unmuteAccount: async (n) => {
		let r = await t.request(`/api/v1/accounts/${n}/unmute`, { method: "POST" });
		return e.parse(h, r.json);
	},
	getMutes: (e) => t.paginatedGet("/api/v1/mutes", { params: e }, we),
	getBlocks: (e) => t.paginatedGet("/api/v1/blocks", { params: e }, Ce),
	getDomainBlocks: (n) => t.paginatedGet("/api/v1/domain_blocks", { params: n }, e.string()),
	blockDomain: async (e) => (await t.request("/api/v1/domain_blocks", {
		method: "POST",
		body: { domain: e }
	})).json,
	unblockDomain: async (e) => (await t.request("/api/v1/domain_blocks", {
		method: "DELETE",
		body: { domain: e }
	})).json,
	getFilters: async () => {
		let n = await t.request(t.features.filtersV2 ? "/api/v2/filters" : "/api/v1/filters");
		return e.parse(_(fn), n.json);
	},
	getFilter: async (n) => {
		let r = await t.request(t.features.filtersV2 ? `/api/v2/filters/${n}` : `/api/v1/filters/${n}`);
		return e.parse(fn, r.json);
	},
	createFilter: async (n) => {
		let { filtersV2: r } = t.features, i = await t.request(r ? "/api/v2/filters" : "/api/v1/filters", {
			method: "POST",
			body: r ? n : {
				phrase: n.keywords_attributes[0]?.keyword,
				context: n.context,
				irreversible: n.filter_action === "hide",
				whole_word: n.keywords_attributes[0]?.whole_word,
				expires_in: n.expires_in
			}
		});
		return e.parse(fn, i.json);
	},
	updateFilter: async (n, r) => {
		let { filtersV2: i } = t.features, a = await t.request(i ? `/api/v2/filters/${n}` : `/api/v1/filters/${n}`, {
			method: "PUT",
			body: i ? r : {
				phrase: r.keywords_attributes?.[0]?.keyword,
				context: r.context,
				irreversible: r.filter_action === "hide",
				whole_word: r.keywords_attributes?.[0]?.whole_word,
				expires_in: r.expires_in
			}
		});
		return e.parse(fn, a.json);
	},
	deleteFilter: async (e) => (await t.request(t.features.filtersV2 ? `/api/v2/filters/${e}` : `/api/v1/filters/${e}`, { method: "DELETE" })).json,
	getFilterKeywords: async (n) => {
		let r = await t.request(`/api/v2/filters/${n}/keywords`);
		return e.parse(_(ln), r.json);
	},
	addFilterKeyword: async (n, r, i) => {
		let a = await t.request(`/api/v2/filters/${n}/keywords`, {
			method: "POST",
			body: {
				keyword: r,
				whole_word: i
			}
		});
		return e.parse(ln, a.json);
	},
	getFilterKeyword: async (n) => {
		let r = await t.request(`/api/v2/filters/keywords/${n}`);
		return e.parse(ln, r.json);
	},
	updateFilterKeyword: async (n, r, i) => {
		let a = await t.request(`/api/v2/filters/keywords/${n}`, {
			method: "PUT",
			body: {
				keyword: r,
				whole_word: i
			}
		});
		return e.parse(ln, a.json);
	},
	deleteFilterKeyword: async (e) => (await t.request(`/api/v2/filters/keywords/${e}`, { method: "DELETE" })).json,
	getFilterStatuses: async (n) => {
		let r = await t.request(`/api/v2/filters/${n}/statuses`);
		return e.parse(_(un), r.json);
	},
	addFilterStatus: async (n, r) => {
		let i = await t.request(`/api/v2/filters/${n}/statuses`, {
			method: "POST",
			body: { status_id: r }
		});
		return e.parse(un, i.json);
	},
	getFilterStatus: async (n) => {
		let r = await t.request(`/api/v2/filters/statuses/${n}`);
		return e.parse(un, r.json);
	},
	deleteFilterStatus: async (e) => (await t.request(`/api/v2/filters/statuses/${e}`, { method: "DELETE" })).json
}), xa = (t) => ({ searchGifs: async (n, r) => {
	let i = await t.request("/api/v1/gifs", {
		...r,
		params: { q: n }
	});
	return e.parse(Sr, i.json);
} }), Sa = [
	"chat_mention",
	"emoji_reaction",
	"report",
	"participation_accepted",
	"participation_request",
	"event_reminder",
	"event_update",
	"subscribed_reaction"
], Ca = (e) => [...e, ...e.filter((e) => Sa.includes(e)).map((e) => `pleroma:${e}`)], wa = [
	"favourite",
	"reblog",
	"emoji_reaction",
	"event_reminder",
	"participation_accepted",
	"participation_request"
], Ta = ({ previous: e, next: t, items: n, ...r }, i) => {
	let a = [];
	for (let e of n) {
		let t;
		(i?.grouped_types || wa).includes(e.type) && (t = a.find((t) => t.type === e.type && (e.type === "emoji_reaction" && t.type === "emoji_reaction" ? e.emoji === t.emoji : !0) && t.status_id === e.status?.id)), t ? (t.notifications_count += 1, t.page_min_id = e.id, t.sample_account_ids.push(e.account.id)) : a.push({
			...ne(e, [
				"account",
				"status",
				"target"
			]),
			group_key: e.id,
			notifications_count: 1,
			most_recent_notification_id: e.id,
			page_min_id: e.id,
			page_max_id: e.id,
			latest_page_notification_at: e.created_at,
			sample_account_ids: [e.account.id],
			status_id: e.status?.id,
			target_id: e.target?.id
		});
	}
	let o = {
		accounts: Object.values(n.reduce((e, t) => (e[t.account.id] = t.account, "target" in t && (e[t.target.id] = t.target), e), {})),
		statuses: Object.values(n.reduce((e, t) => ("status" in t && t.status && (e[t.status.id] = t.status), e), {})),
		notification_groups: a
	};
	return {
		...r,
		previous: e ? async () => Ta(await e(), i) : null,
		next: t ? async () => Ta(await t(), i) : null,
		items: o
	};
}, Ea = (t) => {
	let n = {
		getGroupedNotifications: async (e, n) => t.features.groupedNotifications ? (e?.types && (e.types = Ca(e.types)), e?.exclude_types && (e.exclude_types = Ca(e.exclude_types)), t.paginatedGet("/api/v2/notifications", {
			...n,
			params: e
		}, zr, !1)) : Ta(await t.notifications.getNotifications(p(e, [
			"max_id",
			"since_id",
			"limit",
			"min_id",
			"types",
			"exclude_types",
			"account_id",
			"include_filtered"
		])), e),
		getNotificationGroup: async (n) => {
			if (t.features.groupedNotifications) {
				let r = await t.request(`/api/v2/notifications/${n}`);
				return e.parse(zr, r.json);
			}
			return Ta(new R([(await t.request(`/api/v1/notifications/${n}`)).json], { partial: !1 })).items;
		},
		dismissNotificationGroup: async (e) => t.features.groupedNotifications ? (await t.request(`/api/v2/notifications/${e}/dismiss`, { method: "POST" })).json : t.notifications.dismissNotification(e),
		getNotificationGroupAccounts: async (r) => {
			if (t.features.groupedNotifications) {
				let n = await t.request(`/api/v2/notifications/${r}/accounts`);
				return e.parse(_(y), n.json);
			}
			return (await n.getNotificationGroup(r)).accounts;
		},
		getUnreadNotificationGroupCount: async (n) => {
			if (t.features.groupedNotifications) {
				let r = await t.request("/api/v2/notifications/unread_count", { params: n });
				return e.parse(e.object({ count: e.number() }), r.json);
			}
			return t.notifications.getUnreadNotificationCount(p(n || {}, [
				"limit",
				"types",
				"exclude_types",
				"account_id"
			]));
		}
	};
	return n;
}, Da = (t) => ({
	getInstance: async () => {
		let n;
		try {
			n = await t.request("/api/v2/instance");
		} catch {
			n = await t.request("/api/v1/instance");
		}
		let r = e.parse(e.pipe(He, e.readonly()), n.json);
		return t.setInstance(r), r;
	},
	getInstancePeers: async () => {
		let n = await t.request("/api/v1/instance/peers");
		return e.parse(e.array(e.string()), n.json);
	},
	getInstanceActivity: async () => {
		let n = await t.request("/api/v1/instance/activity");
		return e.parse(e.array(e.object({
			week: e.string(),
			statuses: e.pipe(e.unknown(), e.transform(String)),
			logins: e.pipe(e.unknown(), e.transform(String)),
			registrations: e.pipe(e.unknown(), e.transform(String))
		})), n.json);
	},
	getInstanceRules: async () => {
		let n = await t.request("/api/v1/instance/rules");
		return e.parse(_(Ee), n.json);
	},
	getInstanceDomainBlocks: async () => {
		let n = await t.request("/api/v1/instance/rules");
		return e.parse(_(fr), n.json);
	},
	getInstanceExtendedDescription: async () => {
		let n = await t.request("/api/v1/instance/extended_description");
		return e.parse(vr, n.json);
	},
	getInstanceTranslationLanguages: async () => {
		if (t.features.version.software === "Akkoma") {
			let e = await t.request("/api/v1/akkoma/translation/languages");
			return Object.fromEntries(e.json.source.map((t) => [t.code.toLocaleLowerCase(), e.json.target.map((e) => e.code).filter((e) => e !== t.code).map((e) => e.toLocaleLowerCase())]));
		}
		let n = await t.request("/api/v1/instance/translation_languages");
		return e.parse(e.record(e.string(), e.array(e.string())), n.json);
	},
	profileDirectory: async (n) => {
		let r = await t.request("/api/v1/directory", { params: n });
		return e.parse(_(y), r.json);
	},
	getCustomEmojis: async () => {
		let n = await t.request("/api/v1/custom_emojis");
		return e.parse(_(m), n.json);
	},
	getFrontendConfigurations: async () => {
		let n;
		switch (t.features.version.software) {
			case A:
				if (!t.accessToken) return {};
				n = (await t.request("/api/v1/accounts/verify_credentials")).json?.client_config;
				break;
			default: n = (await t.request("/api/pleroma/frontend_configurations")).json;
		}
		return e.parse(e.fallback(e.record(e.string(), e.record(e.string(), e.any())), {}), n);
	},
	getInstancePrivacyPolicy: async () => {
		let n = await t.request("/api/v1/instance/privacy_policy");
		return e.parse(xi, n.json);
	},
	getInstanceTermsOfService: async () => {
		let n = await t.request("/api/v1/instance/terms_of_service");
		return e.parse(Qi, n.json);
	},
	getInstanceTermsOfServiceForDate: async (n) => {
		let r = await t.request(`/api/v1/instance/terms_of_service/${n}`);
		return e.parse(Qi, r.json);
	},
	getInstanceBubbleDomains: async () => {
		let n = await t.request("/api/v1/instance/bubble_domains");
		return e.parse(e.array(e.string()), n.json);
	}
}), Oa = (t) => ({
	getInteractionRequests: (e) => t.paginatedGet("/api/v1/interaction_requests", { params: e }, Br),
	getInteractionRequest: async (n) => {
		let r = await t.request(`/api/v1/interaction_requests/${n}`);
		return e.parse(Br, r.json);
	},
	authorizeInteractionRequest: async (n) => {
		let r = await t.request(`/api/v1/interaction_requests/${n}/authorize`, { method: "POST" });
		return e.parse(Br, r.json);
	},
	rejectInteractionRequest: async (n) => {
		let r = await t.request(`/api/v1/interaction_requests/${n}/authorize`, { method: "POST" });
		return e.parse(Br, r.json);
	}
}), ka = (t) => ({
	getLists: async () => {
		let n = await t.request("/api/v1/lists");
		return e.parse(_(J), n.json);
	},
	getList: async (n) => {
		let r = await t.request(`/api/v1/lists/${n}`);
		return e.parse(J, r.json);
	},
	createList: async (n) => {
		let r = await t.request("/api/v1/lists", {
			method: "POST",
			body: n
		});
		return e.parse(J, r.json);
	},
	updateList: async (n, r) => {
		let i = await t.request(`/api/v1/lists/${n}`, {
			method: "PUT",
			body: r
		});
		return e.parse(J, i.json);
	},
	deleteList: async (e) => (await t.request(`/api/v1/lists/${e}`, { method: "DELETE" })).json,
	getListAccounts: (e, n) => t.paginatedGet(`/api/v1/lists/${e}/accounts`, { params: n }, y),
	addListAccounts: async (e, n) => (await t.request(`/api/v1/lists/${e}/accounts`, {
		method: "POST",
		body: { account_ids: n }
	})).json,
	deleteListAccounts: async (e, n) => (await t.request(`/api/v1/lists/${e}/accounts`, {
		method: "DELETE",
		body: { account_ids: n }
	})).json,
	favouriteList: async (n) => {
		let r = await t.request(`/api/v1/lists/${n}/favourite`, { method: "POST" });
		return e.parse(J, r.json);
	},
	unfavouriteList: async (n) => {
		let r = await t.request(`/api/v1/lists/${n}/unfavourite`, { method: "POST" });
		return e.parse(J, r.json);
	}
}), Aa = (t) => ({
	uploadMedia: async (n, r) => {
		let i = await t.request(t.features.mediaV2 ? "/api/v2/media" : "/api/v1/media", {
			...r,
			method: "POST",
			body: n,
			formData: !0
		});
		return e.parse(G, i.json);
	},
	getMedia: async (n) => {
		let r = await t.request(`/api/v1/media/${n}`);
		return e.parse(G, r.json);
	},
	updateMedia: async (n, r) => {
		let i = await t.request(`/api/v1/media/${n}`, {
			method: "PUT",
			body: r,
			formData: !!r.thumbnail
		});
		return e.parse(G, i.json);
	},
	deleteMedia: async (e) => (await t.request(`/api/v1/media/${e}`, { method: "DELETE" })).json
}), ja = async (e, t, n) => {
	let r = await e.request(t, {
		method: "POST",
		body: n
	});
	return e.setIceshrimpAccessToken(r.json.token), r.json;
}, Ma = async (t, { appName: n, scopes: r }) => {
	let i = await t.request("/api/iceshrimp/sessions/mastodon", {
		method: "POST",
		body: {
			appName: n,
			scopes: r?.split(" "),
			flags: {
				supportsHtmlFormatting: !0,
				autoDetectQuotes: !1,
				isPleroma: !0,
				supportsInlineMedia: !0
			}
		}
	});
	return e.parse($i, {
		access_token: i.json.token,
		token_type: "Bearer",
		scope: i.json.scopes.join(" "),
		created_at: new Date(i.json.created_at).getTime(),
		id: i.json.id
	});
}, Na = async (e, t, n = void 0, r) => {
	await e.getIceshrimpAccessToken();
	let i = await e.request(t, n ? { params: n } : void 0), a = r(i.json), o = await e.accounts.getAccounts(a), { prev: s, next: c } = ht(i);
	return new R(o, {
		previous: s ? () => Na(e, s, void 0, r) : null,
		next: c ? () => Na(e, c, void 0, r) : null,
		partial: i.status === 206
	});
}, Pa = async (e, t, n = void 0, r) => {
	await e.getIceshrimpAccessToken();
	let i = await e.request(t, n ? { params: n } : void 0), a = r(i.json), o = (await e.statuses.getStatuses(a)).toReversed(), { prev: s, next: c } = ht(i);
	return new R(o, {
		previous: s ? () => Pa(e, s, void 0, r) : null,
		next: c ? () => Pa(e, c, void 0, r) : null,
		partial: i.status === 206
	});
}, Fa = (t) => ({
	getBookmarks: (e) => t.paginatedGet(t.features.bookmarkFoldersMultiple && e?.folder_id ? `/api/v1/bookmark_categories/${e.folder_id}/statuses` : "/api/v1/bookmarks", { params: e }, K),
	getFavourites: (e) => t.paginatedGet("/api/v1/favourites", { params: e }, K),
	getFollowRequests: (e) => t.paginatedGet("/api/v1/follow_requests", { params: e }, y),
	getOutgoingFollowRequests: (e) => {
		if (t.features.version.software === "Iceshrimp.NET") return Na(t, "/api/iceshrimp/follow_requests/outgoing", e, (e) => e.map(({ user: e }) => e.id));
		switch (t.features.version.software) {
			case T:
			case A: return t.paginatedGet("/api/v1/follow_requests/outgoing", { params: e }, y);
			default: return t.paginatedGet("/api/v1/pleroma/outgoing_follow_requests", { params: e }, y);
		}
	},
	acceptFollowRequest: async (n) => {
		let r = await t.request(`/api/v1/follow_requests/${n}/authorize`, { method: "POST" });
		return e.parse(h, r.json);
	},
	rejectFollowRequest: async (n) => {
		let r = await t.request(`/api/v1/follow_requests/${n}/reject`, { method: "POST" });
		return e.parse(h, r.json);
	},
	getEndorsements: (e) => t.paginatedGet("/api/v1/endorsements", { params: e }, y),
	getFeaturedTags: async () => {
		let n = await t.request("/api/v1/featured_tags");
		return e.parse(_(br), n.json);
	},
	featureTag: async (n) => {
		let r = await t.request("/api/v1/featured_tags", {
			method: "POST",
			body: { name: n }
		});
		return e.parse(br, r.json);
	},
	unfeatureTag: async (e) => (await t.request(`/api/v1/featured_tags/${e}`, { method: "DELETE" })).json,
	getFeaturedTagsSuggestions: async () => {
		let n = await t.request("/api/v1/featured_tags/suggestions");
		return e.parse(_(B), n.json);
	},
	getFollowedTags: (e) => t.paginatedGet("/api/v1/followed_tags", { params: e }, B),
	getTag: async (n) => {
		let r = await t.request(`/api/v1/tags/${n}`);
		return e.parse(B, r.json);
	},
	followTag: async (n) => {
		let r = await t.request(`/api/v1/tags/${n}/follow`, { method: "POST" });
		return e.parse(B, r.json);
	},
	unfollowTag: async (n) => {
		let r = await t.request(`/api/v1/tags/${n}/unfollow`, { method: "POST" });
		return e.parse(B, r.json);
	},
	getSuggestions: async (n) => {
		let r = await t.request(t.features.version.software === "Pixelfed" ? "/api/v1.1/discover/accounts/popular" : t.features.suggestionsV2 ? "/api/v2/suggestions" : "/api/v1/suggestions", { params: { limit: n } });
		return e.parse(_(Zi), r.json);
	},
	dismissSuggestions: async (e) => (await t.request(`/api/v1/suggestions/${e}`, { method: "DELETE" })).json,
	getBookmarkFolders: async () => {
		let n = await t.request(t.features.version.software === "Pleroma" ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories");
		return e.parse(_(nr), n.json);
	},
	createBookmarkFolder: async (n) => {
		let r = await t.request(t.features.version.software === "Pleroma" ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories", {
			method: "POST",
			body: {
				title: n.name,
				...n
			}
		});
		return e.parse(nr, r.json);
	},
	updateBookmarkFolder: async (n, r) => {
		let i = await t.request(`${t.features.version.software === "Pleroma" ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories"}/${n}`, {
			method: "PATCH",
			body: {
				title: r.name,
				...r
			}
		});
		return e.parse(nr, i.json);
	},
	deleteBookmarkFolder: async (n) => {
		let r = await t.request(`${t.features.version.software === "Pleroma" ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories"}/${n}`, { method: "DELETE" });
		return e.parse(nr, r.json);
	},
	addBookmarkToFolder: async (e, n) => (await t.request(`/api/v1/bookmark_categories/${n}/statuses`, {
		method: "POST",
		params: { status_ids: [e] }
	})).json,
	removeBookmarkFromFolder: async (e, n) => (await t.request(`/api/v1/bookmark_categories/${n}/statuses`, {
		method: "DELETE",
		params: { status_ids: [e] }
	})).json,
	getMutedThreads: (e) => Pa(t, "/api/iceshrimp/misc/muted_threads", e, (e) => e.map(({ id: e }) => e))
}), Ia = (t) => ({
	getNotifications: (e, n) => (e?.types && (e.types = Ca(e.types)), e?.exclude_types && (e.exclude_types = Ca(e.exclude_types)), t.paginatedGet("/api/v1/notifications", {
		...n,
		params: e
	}, gi)),
	getNotification: async (n) => {
		let r = await t.request(`/api/v1/notifications/${n}`);
		return e.parse(gi, r.json);
	},
	dismissNotifications: async () => (await t.request("/api/v1/notifications/clear", { method: "POST" })).json,
	dismissNotification: async (e) => (await t.request(`/api/v1/notifications/${e}/dismiss`, { method: "POST" })).json,
	getUnreadNotificationCount: async (n) => {
		let r = await t.request("/api/v1/notifications/unread_count", { params: n });
		return e.parse(e.object({ count: e.number() }), r.json);
	},
	getNotificationPolicy: async () => {
		let n = await t.request("/api/v2/notifications/policy");
		return e.parse(vi, n.json);
	},
	updateNotificationPolicy: async (n) => {
		let r = await t.request("/api/v2/notifications/policy", {
			method: "PATCH",
			body: n
		});
		return e.parse(vi, r.json);
	},
	getNotificationRequests: (e) => t.paginatedGet("/api/v1/notifications/requests", { params: e }, yi),
	getNotificationRequest: async (n) => {
		let r = await t.request(`/api/v1/notifications/requests/${n}`);
		return e.parse(yi, r.json);
	},
	acceptNotificationRequest: async (e) => (await t.request(`/api/v1/notifications/requests/${e}/accept`, { method: "POST" })).json,
	dismissNotificationRequest: async (e) => (await t.request(`/api/v1/notifications/requests/${e}/dismiss`, { method: "POST" })).json,
	acceptMultipleNotificationRequests: async (e) => (await t.request("/api/v1/notifications/requests/accept", {
		method: "POST",
		body: { id: e }
	})).json,
	dismissMultipleNotificationRequests: async (e) => (await t.request("/api/v1/notifications/requests/dismiss", {
		method: "POST",
		body: { id: e }
	})).json,
	checkNotificationRequestsMerged: async () => {
		let n = await t.request("/api/v1/notifications/requests/merged");
		return e.parse(e.object({ merged: e.boolean() }), n.json);
	},
	dismissMultipleNotifications: async (e) => (await t.request("/api/v1/notifications/destroy_multiple", {
		params: { ids: e },
		method: "DELETE"
	})).json
}), La = (t) => ({
	authorize: async (n) => {
		let r = await t.request("/oauth/authorize", {
			params: n,
			formData: !0
		});
		return e.parse(e.string(), r.json);
	},
	getToken: async (n) => {
		if (t.features.version.software === "Iceshrimp.NET" && n.grant_type === "password") {
			if ((await ja(t, "/api/iceshrimp/auth/login", {
				username: n.username,
				password: n.password
			})).status === "two_factor") throw { response: { json: { error: "mfa_required" } } };
			return Ma(t, {
				appName: n.client_id,
				scopes: n.scope
			});
		}
		let r = await t.request("/oauth/token", {
			method: "POST",
			body: n,
			formData: !0
		});
		return e.parse($i, {
			scope: n.scope || "",
			...r.json
		});
	},
	revokeToken: async (e) => {
		let n = await t.request("/oauth/revoke", {
			method: "POST",
			body: e,
			formData: !0
		});
		return t.socket?.close(), n.json;
	},
	userinfo: async () => {
		let n = await t.request("/oauth/userinfo");
		return e.parse(ta, n.json);
	},
	authorizationServerMetadata: async () => {
		let n = await t.request("/.well-known/oauth-authorization-server");
		return e.parse(er, n.json);
	},
	getCaptcha: async () => {
		let n = await t.request("/api/pleroma/captcha");
		return e.parse(e.intersect([e.object({ type: e.string() }), e.record(e.string(), e.any())]), n.json);
	},
	mfaChallenge: async (n) => {
		if (t.features.version.software === "Iceshrimp.NET") return await ja(t, "/api/iceshrimp/auth/2fa", { code: n.code }), Ma(t, {
			appName: n.client_id,
			scopes: n.scope
		});
		let r = await t.request("/oauth/mfa/challenge", {
			method: "POST",
			body: n
		});
		return e.parse($i, r.json);
	}
}), Ra = (t) => ({ getOembed: async (n, r, i) => {
	let a = await t.request("/api/oembed", { params: {
		url: n,
		maxwidth: r,
		maxheight: i
	} });
	return e.parse(e.object({
		type: e.fallback(e.string(), "rich"),
		version: e.fallback(e.string(), ""),
		author_name: e.fallback(e.string(), ""),
		author_url: e.fallback(e.string(), ""),
		provider_name: e.fallback(e.string(), ""),
		provider_url: e.fallback(e.string(), ""),
		cache_age: e.number(),
		html: e.string(),
		width: e.fallback(e.nullable(e.number()), null),
		height: e.fallback(e.nullable(e.number()), null)
	}), a.json);
} }), za = (t) => ({
	getPoll: async (n) => {
		let r = await t.request(`/api/v1/polls/${n}`);
		return e.parse(jn, r.json);
	},
	vote: async (n, r) => {
		let i = await t.request(`/api/v1/polls/${n}/votes`, {
			method: "POST",
			body: { choices: r }
		});
		return e.parse(jn, i.json);
	}
}), Ba = (t) => ({
	createSubscription: async (n) => {
		let r = await t.request("/api/v1/push/subscription", {
			method: "POST",
			body: n
		});
		return e.parse(na, r.json);
	},
	getSubscription: async () => {
		let n = await t.request("/api/v1/push/subscription");
		return e.parse(na, n.json);
	},
	updateSubscription: async (n) => {
		let r = await t.request("/api/v1/push/subscription", {
			method: "PUT",
			body: n
		});
		return e.parse(na, r.json);
	},
	deleteSubscription: async () => (await t.request("/api/v1/push/subscription", { method: "DELETE" })).json
}), Va = (t) => ({
	fetchRssFeedSubscriptions: async () => {
		let n = await t.request("/api/v1/pleroma/rss_feed_subscriptions");
		return e.parse(_(Rn), n.json);
	},
	createRssFeedSubscription: async (n) => {
		let r = await t.request("/api/v1/pleroma/rss_feed_subscriptions", {
			method: "POST",
			body: { url: n }
		});
		return e.parse(Rn, r.json);
	},
	deleteRssFeedSubscription: async (e) => (await t.request("/api/v1/pleroma/rss_feed_subscriptions", {
		method: "DELETE",
		body: { url: e }
	})).json
}), Ha = (t) => ({
	getScheduledStatuses: (e) => t.paginatedGet("/api/v1/scheduled_statuses", { params: e }, Ci),
	getScheduledStatus: async (n) => {
		let r = await t.request(`/api/v1/scheduled_statuses/${n}`);
		return e.parse(Ci, r.json);
	},
	updateScheduledStatus: async (n, r) => {
		let i = await t.request(`/api/v1/scheduled_statuses/${n}`, {
			method: "PUT",
			body: { scheduled_at: r }
		});
		return e.parse(Ci, i.json);
	},
	cancelScheduledStatus: async (e) => (await t.request(`/api/v1/scheduled_statuses/${e}`, { method: "DELETE" })).json
}), Ua = (t) => ({
	search: async (n, r, i) => {
		let a = await t.request("/api/v2/search", {
			...i,
			params: {
				...r,
				q: n
			}
		}), o = e.parse(Ti, a.json);
		if (r && r.resolve && r.offset && r.offset > 0) {
			let e = o.accounts[0];
			e && [e.url, e.acct].includes(n) && (o.accounts = o.accounts.slice(1));
			let t = o.statuses[0];
			t && [t.uri, t.url].includes(n) && (o.statuses = o.statuses.slice(1));
		}
		return o;
	},
	searchLocation: async (n, r) => {
		let i = await t.request("/api/v1/pleroma/search/location", {
			...r,
			params: { q: n }
		});
		return e.parse(_(ei), i.json);
	}
}), Wa = (t) => ({
	createAccount: async (n) => {
		if (t.features.version.software === "Iceshrimp.NET") return await ja(t, "/api/iceshrimp/auth/register", {
			username: n.username,
			password: n.password,
			invite: n.invite_code
		}), Ma(t, {
			appName: n.client_id,
			scopes: n.scopes
		});
		let r = await t.request("/api/v1/accounts", {
			method: "POST",
			body: {
				language: n.locale,
				birthday: n.date_of_birth,
				...n
			}
		});
		return "identifier" in r.json ? e.parse(e.object({
			message: e.string(),
			identifier: e.string()
		}), r.json) : e.parse($i, r.json);
	},
	verifyCredentials: async () => {
		let n = await t.request("/api/v1/accounts/verify_credentials"), r = e.parse(Se, n.json);
		if (t.features.version.software === "Iceshrimp.NET") {
			await t.getIceshrimpAccessToken();
			try {
				let e = await t.request("/api/iceshrimp/auth");
				r.is_admin = e.json.isAdmin, r.is_moderator = e.json.isModerator;
			} catch {}
		}
		return r;
	},
	updateCredentials: async (n) => {
		n.background_image && (n.pleroma_background_image = n.background_image, delete n.background_image), n.settings_store && (n.pleroma_settings_store = n.settings_store, t.features.version.software === "Mitra" && await t.request("/api/v1/settings/client_config", {
			method: "POST",
			body: n.settings_store
		}), delete n.settings_store);
		let r = await t.request("/api/v1/accounts/update_credentials", {
			method: "PATCH",
			formData: !!(t.features.version.software === "GoToSocial" || t.features.version.software === "Iceshrimp.NET" || n.avatar || n.header),
			body: n
		});
		return e.parse(Se, r.json);
	},
	deleteAvatar: async () => {
		let n = await t.request("/api/v1/profile/avatar", { method: "DELETE" });
		return e.parse(Se, n.json);
	},
	deleteHeader: async () => {
		let n = await t.request("/api/v1/profile/header", { method: "DELETE" });
		return e.parse(Se, n.json);
	},
	getPreferences: async () => (await t.request("/api/v1/preferences")).json,
	createBackup: async () => {
		let n = await t.request("/api/v1/pleroma/backups", { method: "POST" });
		return e.parse(tr, n.json);
	},
	getBackups: async () => {
		let n = await t.request("/api/v1/pleroma/backups");
		return e.parse(_(tr), n.json);
	},
	getAccountAliases: async () => {
		let n = await t.request("/api/pleroma/aliases");
		return e.parse(e.object({ aliases: _(e.string()) }), n.json);
	},
	addAccountAlias: async (n) => {
		let r = await t.request("/api/pleroma/aliases", {
			method: "PUT",
			body: { alias: n }
		});
		return e.parse(e.object({ status: e.literal("success") }), r.json);
	},
	deleteAccountAlias: async (n) => {
		let r = await t.request("/api/pleroma/aliases", {
			method: "DELETE",
			body: { alias: n }
		});
		return e.parse(e.object({ status: e.literal("success") }), r.json);
	},
	getOauthTokens: async () => {
		let e;
		switch (t.features.version.software) {
			case T:
				e = "/api/v1/tokens";
				break;
			case O:
				await t.getIceshrimpAccessToken(), e = "/api/iceshrimp/sessions/mastodon";
				break;
			case A:
				e = "/api/v1/settings/sessions";
				break;
			default:
				e = "/api/oauth_tokens";
				break;
		}
		return t.paginatedGet(e, {}, bi);
	},
	deleteOauthToken: async (e) => {
		let n;
		switch (t.features.version.software) {
			case T:
				n = await t.request(`/api/v1/tokens/${e}/invalidate`, { method: "POST" });
				break;
			case A:
				n = await t.request(`/api/v1/settings/sessions/${e}`, { method: "DELETE" });
				break;
			default:
				n = await t.request(`/api/oauth_tokens/${e}`, { method: "DELETE" });
				break;
		}
		return n.json;
	},
	changePassword: async (e, n) => {
		let r;
		switch (t.features.version.software) {
			case T:
				r = await t.request("/api/v1/user/password_change", {
					method: "POST",
					body: {
						old_password: e,
						new_password: n
					}
				});
				break;
			case O:
				await t.getIceshrimpAccessToken(), r = await t.request("/api/iceshrimp/auth/change-password", {
					method: "POST",
					body: {
						oldPassword: e,
						newPassword: n
					}
				});
				break;
			case A:
				r = await t.request("/api/v1/settings/change_password", {
					method: "POST",
					body: { new_password: n }
				});
				break;
			case M:
				if (r = await t.request("/api/v1.1/accounts/change-password", {
					method: "POST",
					body: {
						current_password: e,
						new_password: n,
						confirm_password: n
					}
				}), r.redirected) throw r;
				break;
			default: r = await t.request("/api/pleroma/change_password", {
				method: "POST",
				body: {
					password: e,
					new_password: n,
					new_password_confirmation: n
				}
			});
		}
		return r.json;
	},
	resetPassword: async (e, n) => (await t.request("/auth/password", {
		method: "POST",
		body: {
			email: e,
			nickname: n
		}
	})).json,
	changeEmail: async (e, n) => {
		let r;
		switch (t.features.version.software) {
			case T:
				r = await t.request("/api/v1/user/email_change", {
					method: "POST",
					body: {
						new_email: e,
						password: n
					}
				});
				break;
			default: r = await t.request("/api/pleroma/change_email", {
				method: "POST",
				body: {
					email: e,
					password: n
				}
			});
		}
		if (r.json?.error) throw r.json.error;
		return r.json;
	},
	deleteAccount: async (e) => {
		let n;
		switch (t.features.version.software) {
			case T:
				n = await t.request("/api/v1/accounts/delete", {
					method: "POST",
					body: { password: e }
				});
				break;
			default: n = await t.request("/api/pleroma/delete_account", {
				method: "POST",
				body: { password: e }
			});
		}
		if (n.json?.error) throw n.json.error;
		return n.json;
	},
	deleteAccountWithoutPassword: async () => (await t.request("/api/v1/settings/delete_account", { method: "POST" })).json,
	disableAccount: async (e) => {
		let n = await t.request("/api/pleroma/disable_account", {
			method: "POST",
			body: { password: e }
		});
		if (n.json?.error) throw n.json.error;
		return n.json;
	},
	moveAccount: async (e, n) => {
		let r = await t.request("/api/pleroma/move_account", {
			method: "POST",
			body: {
				password: n,
				target_account: e
			}
		});
		if (r.json?.error) throw r.json.error;
		return r.json;
	},
	mfa: {
		getMfaSettings: async () => {
			let n;
			switch (t.features.version.software) {
				case T:
					n = await t.request("/api/v1/user").then(({ json: e }) => ({ settings: {
						enabled: !!e?.two_factor_enabled_at,
						totp: !!e?.two_factor_enabled_at
					} }));
					break;
				case O:
					await t.getIceshrimpAccessToken(), n = await t.request("/api/iceshrimp/settings").then(({ json: e }) => ({ settings: {
						enabled: e.twoFactorEnrolled,
						totp: e.twoFactorEnrolled
					} }));
					break;
				default: n = (await t.request("/api/pleroma/accounts/mfa")).json;
			}
			return e.parse(e.object({ settings: v({
				enabled: e.boolean(),
				totp: e.boolean()
			}) }), n);
		},
		getMfaBackupCodes: async () => {
			let n = await t.request("/api/pleroma/accounts/mfa/backup_codes");
			return e.parse(e.object({ codes: e.array(e.string()) }), n.json);
		},
		getMfaSetup: async (n) => {
			let r;
			switch (t.features.version.software) {
				case T:
					r = await t.request("/api/v1/user/2fa/qruri").then(({ data: e }) => ({
						provisioning_uri: e,
						key: new URL(e).searchParams.get("secret")
					}));
					break;
				case O:
					await t.getIceshrimpAccessToken(), r = await t.request("/api/iceshrimp/settings/2fa/enroll", { method: "POST" }).then(({ json: e }) => ({
						provisioning_uri: e.url,
						key: e.secret
					}));
					break;
				default: r = (await t.request(`/api/pleroma/accounts/mfa/setup/${n}`)).json;
			}
			return e.parse(e.object({
				key: e.fallback(e.string(), ""),
				provisioning_uri: e.string()
			}), r);
		},
		confirmMfaSetup: async (e, n, r) => {
			let i;
			switch (t.features.version.software) {
				case T:
					i = await t.request("/api/v1/user/2fa/enable", {
						method: "POST",
						body: { code: n }
					});
					break;
				case O:
					await t.getIceshrimpAccessToken(), i = await t.request("/api/iceshrimp/settings/2fa/confirm", {
						method: "POST",
						body: { code: n }
					});
					break;
				default: i = (await t.request(`/api/pleroma/accounts/mfa/confirm/${e}`, {
					method: "POST",
					body: {
						code: n,
						password: r
					}
				})).json;
			}
			if (i?.error) throw i.error;
			return i;
		},
		disableMfa: async (e, n) => {
			let r;
			switch (t.features.version.software) {
				case T:
					r = await t.request("/api/v1/user/2fa/disable", {
						method: "POST",
						body: { password: n }
					});
					break;
				default: r = await t.request(`/api/pleroma/accounts/mfa/${e}`, {
					method: "DELETE",
					body: { password: n }
				});
			}
			if (r.json?.error) throw r.json.error;
			return r.json;
		},
		disableMfaWithCode: async (e) => {
			await t.getIceshrimpAccessToken();
			let n = await t.request("/api/iceshrimp/settings/2fa/disable", {
				method: "POST",
				body: { code: e }
			});
			if (n.json?.error) throw n.json.error;
			return n.json;
		}
	},
	importFollows: async (e, n) => {
		let r;
		switch (t.features.version.software) {
			case T:
				r = await t.request("/api/v1/import", {
					method: "POST",
					body: {
						data: e,
						type: "following",
						mode: n
					},
					formData: !0
				});
				break;
			case O:
				r = await t.request("/api/iceshrimp/settings/import/following", {
					method: "POST",
					body: { file: e },
					formData: !0
				});
				break;
			case A:
				r = await t.request("/api/v1/settings/import_follows", {
					method: "POST",
					body: { follows_csv: typeof e == "string" ? e : await e.text() }
				});
				break;
			default: r = await t.request("/api/pleroma/follow_import", {
				method: "POST",
				body: { list: e },
				formData: !0
			});
		}
		return r.json;
	},
	importFollowers: async (e, n) => (await t.request("/api/v1/settings/import_followers", {
		method: "POST",
		body: {
			from_actor_id: n,
			followers_csv: typeof e == "string" ? e : await e.text()
		}
	})).json,
	importBlocks: async (e, n) => {
		let r;
		switch (t.features.version.software) {
			case T:
				r = await t.request("/api/v1/import", {
					method: "POST",
					body: {
						data: e,
						type: "blocks",
						mode: n
					},
					formData: !0
				});
				break;
			case O:
				r = await t.request("/api/iceshrimp/settings/import/blocking", {
					method: "POST",
					body: { file: e },
					formData: !0
				});
				break;
			default: r = await t.request("/api/pleroma/blocks_import", {
				method: "POST",
				body: { list: e },
				formData: !0
			});
		}
		return r.json;
	},
	importMutes: async (e, n) => {
		let r;
		switch (t.features.version.software) {
			case T:
				r = await t.request("/api/v1/import", {
					method: "POST",
					body: {
						data: e,
						type: "blocks",
						mode: n
					},
					formData: !0
				});
				break;
			case O:
				r = await t.request("/api/iceshrimp/settings/import/muting", {
					method: "POST",
					body: { file: e },
					formData: !0
				});
				break;
			default: r = await t.request("/api/pleroma/mutes_import", {
				method: "POST",
				body: { list: e },
				formData: !0
			});
		}
		return r.json;
	},
	exportFollowers: async () => {
		let e;
		switch (t.features.version.software) {
			case T:
				e = await t.request("/api/v1/exports/followers.csv", { method: "GET" });
				break;
			default: e = await t.request("/api/v1/settings/export_followers", { method: "GET" });
		}
		return e.data;
	},
	exportFollows: async () => {
		let e;
		switch (t.features.version.software) {
			case T:
				e = await t.request("/api/v1/exports/following.csv", { method: "GET" });
				break;
			default: e = await t.request("/api/v1/settings/export_follows", { method: "GET" });
		}
		return e.data;
	},
	exportLists: async () => (await t.request("/api/v1/exports/lists.csv", { method: "GET" })).data,
	exportBlocks: async () => (await t.request("/api/v1/exports/blocks.csv", { method: "GET" })).data,
	exportMutes: async () => (await t.request("/api/v1/exports/mutes.csv", { method: "GET" })).data,
	updateNotificationSettings: async (n) => {
		let r = await t.request("/api/pleroma/notification_settings", {
			method: "PUT",
			body: n
		});
		if (r.json?.error) throw r.json.error;
		return e.parse(e.object({ status: e.string() }), r.json);
	},
	getInteractionPolicies: async () => {
		let n = await t.request("/api/v1/interaction_policies/defaults");
		return e.parse(xn, n.json);
	},
	updateInteractionPolicies: async (n) => {
		let r = await t.request("/api/v1/interaction_policies/defaults", {
			method: "PATCH",
			body: n
		});
		return e.parse(xn, r.json);
	},
	getAvailableFrontends: async () => {
		let n = await t.request("/api/v1/akkoma/preferred_frontend/available");
		return e.parse(e.array(e.string()), n.json);
	},
	setPreferredFrontend: async (n) => {
		let r = await t.request("/api/v1/akkoma/preferred_frontend", {
			method: "PUT",
			body: { frontend_name: n }
		});
		return e.parse(e.object({ frontend_name: e.string() }), r.json);
	},
	authorizeIceshrimp: async () => (await t.request("/api/v1/accounts/authorize_iceshrimp", { method: "POST" })).json
}), Ga = (t) => ({ connect: (n, { onMessage: r, onMessages: i }) => {
	let o = 2, s;
	if (t.shoutSocket) return t.shoutSocket;
	let c = new a(pt("/socket/websocket", t.baseURL, {
		token: n,
		vsn: "2.0.0"
	}));
	return c.onmessage = (t) => {
		let [n, a, o, s, c] = JSON.parse(t.data);
		s === "new_msg" ? r(e.parse(Ei, c)) : s === "messages" && i(e.parse(_(Ei), c.messages));
	}, c.onopen = () => {
		c.send(JSON.stringify([
			"3",
			`${++o}`,
			"chat:public",
			"phx_join",
			{}
		])), s = setInterval(() => {
			c.send(JSON.stringify([
				null,
				`${++o}`,
				"phoenix",
				"heartbeat",
				{}
			]));
		}, 5e3);
	}, c.onclose = () => {
		clearInterval(s);
	}, t.shoutSocket = {
		message: (e) => {
			c.send(JSON.stringify([
				"3",
				`${++o}`,
				"chat:public",
				"new_msg",
				{ text: e }
			]));
		},
		close: () => {
			c.close(), t.shoutSocket = void 0, clearInterval(s);
		}
	}, t.shoutSocket;
} }), Ka = (t) => {
	let n = {
		createStatus: async (n) => {
			let r = n;
			n.content_type === "text/markdown" && t.instanceInformation.api_versions["kmyblue_markdown.fedibird.pl-api"] >= 1 && (r.markdown = !0), n.visibility?.startsWith("api/v1/bookmark_categories") && (r.circle_id = n.visibility.slice(7), r.visibility = "circle"), n.quote_id && t.instanceInformation.api_versions.mastodon >= 7 ? n.quoted_status_id = n.quote_id : n.quoted_status_id && (t.instanceInformation.api_versions.mastodon || 0) < 7 && (n.quote_id = n.quoted_status_id);
			let i = n.preview && t.features.version.software === "Mitra" ? "/api/v1/statuses/preview" : "/api/v1/statuses", a = await t.request(i, {
				method: "POST",
				body: r
			});
			return a.json?.scheduled_at ? e.parse(Ci, a.json) : e.parse(K, a.json);
		},
		previewStatus: async (n) => {
			let r = t.features.version.software === "Pleroma" || t.features.version.software === "Akkoma" ? "/api/v1/statuses" : "/api/v1/statuses/preview";
			(t.features.version.software === "Pleroma" || t.features.version.software === "Akkoma") && (n.preview = !0);
			let i = await t.request(r, {
				method: "POST",
				body: n
			});
			return e.parse(e.partial(qn), i.json);
		},
		getStatus: async (n, r) => {
			let i = await t.request(`/api/v1/statuses/${n}`, { params: r });
			return e.parse(K, i.json);
		},
		getStatuses: async (n, r) => {
			let i = await t.request("/api/v1/statuses", { params: {
				...r,
				id: n
			} });
			return e.parse(_(K), i.json);
		},
		deleteStatus: async (n, r) => {
			let i = await t.request(`/api/v1/statuses/${n}`, {
				method: "DELETE",
				params: { delete_media: r }
			});
			return e.parse(Oi, i.json);
		},
		getContext: async (n, r) => {
			let i = await t.request(`/api/v1/statuses/${n}/context`, { params: r });
			return {
				asyncRefreshHeader: _t(i),
				...e.parse(or, i.json)
			};
		},
		translateStatus: async (n, r) => {
			let i;
			return i = t.features.version.software === "Akkoma" ? await t.request(`/api/v1/statuses/${n}/translations/${r}`) : await t.request(`/api/v1/statuses/${n}/translate`, {
				method: "POST",
				body: { lang: r }
			}), e.parse(Vn, i.json);
		},
		translateStatuses: async (n, r) => {
			let i = await t.request("/api/v1/pl/statuses/translate", {
				method: "POST",
				body: {
					ids: n,
					lang: r
				}
			});
			return e.parse(_(Vn), i.json);
		},
		getRebloggedBy: (e, n) => t.paginatedGet(`/api/v1/statuses/${e}/reblogged_by`, { params: n }, y),
		getFavouritedBy: (e, n) => t.paginatedGet(`/api/v1/statuses/${e}/favourited_by`, { params: n }, y),
		favouriteStatus: async (n) => {
			let r = await t.request(`/api/v1/statuses/${n}/favourite`, { method: "POST" });
			return e.parse(K, r.json);
		},
		unfavouriteStatus: async (n) => {
			let r = await t.request(`/api/v1/statuses/${n}/unfavourite`, { method: "POST" });
			return e.parse(K, r.json);
		},
		reblogStatus: async (n, r, i) => {
			let a = await t.request(`/api/v1/statuses/${n}/reblog`, {
				method: "POST",
				body: {
					visibility: r,
					scheduled_at: i
				}
			});
			return a.json?.scheduled_at ? e.parse(Ci, a.json) : e.parse(K, a.json);
		},
		unreblogStatus: async (n) => {
			let r = await t.request(`/api/v1/statuses/${n}/unreblog`, { method: "POST" });
			return e.parse(K, r.json);
		},
		bookmarkStatus: async (r, i) => {
			if (t.features.bookmarkFoldersMultiple) i && t.features.bookmarkFoldersMultiple && await t.request(`/api/v1/bookmark_categories/${i}/statuses`, {
				method: "POST",
				params: { status_ids: [r] }
			});
			else {
				let n = await t.request(`/api/v1/statuses/${r}/bookmark`, {
					method: "POST",
					body: { folder_id: i }
				});
				return e.parse(K, n.json);
			}
			return n.getStatus(r);
		},
		unbookmarkStatus: async (e) => (await t.request(`/api/v1/statuses/${e}/unbookmark`, { method: "POST" }), n.getStatus(e)),
		revokeQuote: async (n, r) => {
			let i = await t.request(`/api/v1/statuses/${n}/quotes/${r}/revoke`, { method: "POST" });
			return e.parse(K, i.json);
		},
		muteStatus: async (n) => {
			let r = await t.request(`/api/v1/statuses/${n}/mute`, { method: "POST" });
			return e.parse(K, r.json);
		},
		unmuteStatus: async (n) => {
			let r = await t.request(`/api/v1/statuses/${n}/unmute`, { method: "POST" });
			return e.parse(K, r.json);
		},
		pinStatus: async (n) => {
			let r = await t.request(`/api/v1/statuses/${n}/pin`, { method: "POST" });
			return e.parse(K, r.json);
		},
		unpinStatus: async (n) => {
			let r = await t.request(`/api/v1/statuses/${n}/unpin`, { method: "POST" });
			return e.parse(K, r.json);
		},
		editStatus: async (n, r) => {
			let i = r;
			r.content_type === "text/markdown" && t.instanceInformation.api_versions["kmyblue_markdown.fedibird.pl-api"] >= 1 && (i.markdown = !0);
			let a = await t.request(`/api/v1/statuses/${n}`, {
				method: "PUT",
				body: i
			});
			return e.parse(K, a.json);
		},
		editInteractionPolicy: async (n, r) => {
			let i = await t.request(`/api/v1/statuses/${n}`, {
				method: "PUT",
				body: r
			});
			return e.parse(K, i.json);
		},
		getStatusHistory: async (n) => {
			let r = await t.request(`/api/v1/statuses/${n}/history`);
			return e.parse(_(Di), r.json);
		},
		getStatusSource: async (n) => {
			let r = await t.request(`/api/v1/statuses/${n}/source`);
			return e.parse(Oi, r.json);
		},
		getStatusReactions: async (n, r) => {
			let i = t.instanceInformation.api_versions, a;
			return i["emoji_reactions.pleroma.pl-api"] >= 1 || t.features.version.software === "Iceshrimp.NET" ? a = await t.request(`/api/v1/pleroma/statuses/${n}/reactions${r ? `/${r}` : ""}`) : (a = i["emoji_reaction.fedibird.pl-api"] >= 1 ? await t.request(`/api/v1/statuses/${n}/emoji_reactioned_by`) : await t.request(`/api/v1/statuses/${n}/reactions`, { params: { emoji: r } }), a.json = a.json?.reduce((e, t) => {
				if (r && t.name !== r) return e;
				let n = e.find((e) => e.name === t.name);
				return n ? (n.accounts.push(t.account), n.account_ids.push(t.account.id), n.count += 1) : e.push({
					count: 1,
					accounts: [t.account],
					account_ids: [t.account.id],
					...t
				}), e;
			}, [])), e.parse(_(cn), a?.json || []);
		},
		createStatusReaction: async (n, r) => {
			let i = t.instanceInformation.api_versions, a;
			return a = i["emoji_reactions.pleroma.pl-api"] >= 1 || t.features.version.software === "Mitra" ? await t.request(`/api/v1/pleroma/statuses/${n}/reactions/${encodeURIComponent(r)}`, { method: "PUT" }) : await t.request(`/api/v1/statuses/${n}/react/${encodeURIComponent(r)}`, { method: "POST" }), e.parse(K, a.json);
		},
		deleteStatusReaction: async (n, r) => {
			let i = t.instanceInformation.api_versions, a;
			return a = i["emoji_reactions.pleroma.pl-api"] >= 1 || t.features.version.software === "Mitra" ? await t.request(`/api/v1/pleroma/statuses/${n}/reactions/${r}`, { method: "DELETE" }) : await t.request(`/api/v1/statuses/${n}/unreact/${encodeURIComponent(r)}`, { method: "POST" }), e.parse(K, a.json);
		},
		getStatusQuotes: (e, n) => t.paginatedGet(t.instanceInformation.api_versions.mastodon >= 7 ? `/api/v1/statuses/${e}/quotes` : `/api/v1/pleroma/statuses/${e}/quotes`, { params: n }, K),
		getDislikedBy: (e) => t.paginatedGet(`/api/v1/statuses/${e}/disliked_by`, {}, y),
		dislikeStatus: async (n) => {
			let r = await t.request(`/api/friendica/statuses/${n}/dislike`, { method: "POST" });
			return e.parse(K, r.json);
		},
		undislikeStatus: async (n) => {
			let r = await t.request(`/api/friendica/statuses/${n}/undislike`, { method: "POST" });
			return e.parse(K, r.json);
		},
		getStatusReferences: (e, n) => t.paginatedGet(`/api/v1/statuses/${e}/referred_by`, { params: n }, K),
		getStatusMentionedUsers: (e, n) => t.paginatedGet(`/api/v1/statuses/${e}/mentioned_by`, { params: n }, y),
		loadConversation: async (e) => (await t.request(`/api/v1/statuses/${e}/load_conversation`, { method: "POST" })).json,
		getStatusBookmarkFolders: async (n) => {
			let r = await t.request(`/api/v1/statuses/${n}/bookmark_categories`, { method: "GET" });
			return e.parse(_(nr), r.json);
		},
		biteStatus: async (e) => (await t.getIceshrimpAccessToken(), (await t.request(`/api/iceshrimp/notes/${e}/bite`, { method: "POST" })).json)
	};
	return n;
}, qa = (t) => ({
	getRecentStories: async () => {
		let n = await t.request("/api/web/stories/v1/recent");
		return e.parse(_(ki), n.json);
	},
	getStoryViewers: async (n) => {
		let r = await t.request("/api/web/stories/v1/viewers", { params: { sid: n } });
		return e.parse(_(y), r.json);
	},
	getStoriesForProfile: async (n) => {
		let r = await t.request(`/api/web/stories/v1/profile/${n}`);
		return e.parse(_(Mi), r.json);
	},
	storyExists: async (n) => {
		let r = await t.request(`/api/web/stories/v1/exists/${n}`);
		return e.parse(e.boolean(), r.json);
	},
	getStoryPollResults: async (n) => {
		let r = await t.request("/api/web/stories/v1/poll/results", { params: { sid: n } });
		return e.parse(e.array(e.number()), r.json);
	},
	markStoryAsViewed: async (e) => (await t.request("/api/web/stories/v1/viewed", {
		method: "POST",
		body: { id: e }
	})).json,
	createStoryReaction: async (e, n) => (await t.request("/api/web/stories/v1/react", {
		method: "POST",
		body: {
			sid: e,
			reaction: n
		}
	})).json,
	createStoryComment: async (e, n) => (await t.request("/api/web/stories/v1/comment", {
		method: "POST",
		body: {
			sid: e,
			caption: n
		}
	})).json,
	createStoryPoll: async (e) => (await t.request("/api/web/stories/v1/publish/poll", {
		method: "POST",
		body: e
	})).json,
	storyPollVote: async (e, n) => (await t.request("/api/web/stories/v1/publish/poll", {
		method: "POST",
		body: {
			sid: e,
			ci: n
		}
	})).json,
	reportStory: async (e, n) => (await t.request("/api/web/stories/v1/report", {
		method: "POST",
		body: {
			id: e,
			type: n
		}
	})).json,
	addMedia: async (n) => {
		let r = await t.request("/api/web/stories/v1/add", {
			method: "POST",
			body: { file: n },
			formData: !0
		});
		return e.parse(Ai, r.json);
	},
	cropPhoto: async (e, n) => (await t.request("/api/web/stories/v1/crop", {
		method: "POST",
		body: {
			media_id: e,
			...n
		}
	})).json,
	createStory: async (e, n) => (await t.request("/api/web/stories/v1/publish", {
		method: "POST",
		body: {
			media_id: e,
			...n
		}
	})).json,
	deleteStory: async (e) => (await t.request(`/api/web/stories/v1/delete/${e}`, { method: "DELETE" })).json
}), Ja = (t) => ({
	health: async () => {
		let n = await t.request("/api/v1/streaming/health");
		return e.parse(e.literal("OK"), n.json);
	},
	connect: () => {
		if (t.socket) return t.socket;
		let n = new a(pt("/api/v1/streaming", t.instanceInformation?.configuration.urls.streaming, { access_token: t.accessToken }), t.accessToken), r = [], i = [], o = (e) => n.readyState === a.CONNECTING ? i.push(e) : e();
		n.onmessage = (t) => {
			let n = e.parse(qi, JSON.parse(t.data));
			r.filter(({ listener: e, stream: t }) => (!t || n.stream.includes(t)) && e(n));
		};
		let s = [], c = !1, l = (e) => {
			c || (c = !0, t.socket = void 0, s.forEach((t) => t(e)));
		};
		return n.onopen = () => {
			i.forEach((e) => e()), i.length = 0;
		}, n.onclose = (e) => {
			l(e);
		}, t.socket = {
			listen: (e, t) => r.push({
				listener: e,
				stream: t
			}),
			unlisten: (e) => r = r.filter((t) => t.listener !== e),
			subscribe: (e, t = {}) => o(() => n.send(JSON.stringify({
				type: "subscribe",
				stream: e,
				...t
			}))),
			unsubscribe: (e, t = {}) => o(() => n.send(JSON.stringify({
				type: "unsubscribe",
				stream: e,
				...t
			}))),
			onDisconnect: (e) => (s.push(e), () => {
				s = s.filter((t) => t !== e);
			}),
			close: () => {
				n.close(), t.socket = void 0;
			}
		}, t.socket;
	}
}), Ya = (t) => ({
	createSubscription: async (n, r) => {
		let i = await t.request("/api/v1/subscriptions", {
			method: "POST",
			body: {
				subscriber_id: n,
				duration: r
			}
		});
		return e.parse(Ji, i.json);
	},
	getSubscriptionOptions: async () => {
		let n = await t.request("/api/v1/subscriptions/options");
		return e.parse(_(Xi), n.json);
	},
	updateSubscription: async (n, r, i, a) => {
		let o = await t.request("/api/v1/subscriptions/options", {
			method: "POST",
			body: {
				type: n,
				chain_id: r,
				price: i,
				payout_address: a
			}
		});
		return e.parse(y, o.json);
	},
	findSubscription: async (n, r) => {
		let i = await t.request("/api/v1/subscriptions/find", { params: {
			sender_id: n,
			recipient_id: r
		} });
		return e.parse(Ji, i.json);
	},
	createInvoice: async (n, r, i, a) => {
		let o = await t.request("/api/v1/subscriptions/invoices", {
			method: "POST",
			body: {
				sender_id: n,
				recipient_id: r,
				chain_id: i,
				amount: a
			}
		});
		return e.parse(Yi, o.json);
	},
	getInvoice: async (n) => {
		let r = await t.request(`/api/v1/subscriptions/invoices/${n}`);
		return e.parse(Yi, r.json);
	},
	cancelInvoice: async (n) => {
		let r = await t.request(`/api/v1/subscriptions/invoices/${n}`, { method: "DELETE" });
		return e.parse(Yi, r.json);
	}
}), Xa = (t) => ({
	publicTimeline: (e) => e?.instance && t.features.version.software === "Iceshrimp.NET" ? Pa(t, `/api/iceshrimp/timelines/remote/${e.instance}`, e, (e) => e.map(({ id: e }) => e)) : t.paginatedGet("/api/v1/timelines/public", { params: e }, K),
	hashtagTimeline: (e, n) => t.paginatedGet(`/api/v1/timelines/tag/${e}`, { params: n }, K),
	homeTimeline: (e) => t.paginatedGet("/api/v1/timelines/home", { params: e }, K),
	linkTimeline: (e, n) => t.paginatedGet("/api/v1/timelines/link", { params: {
		...n,
		url: e
	} }, K),
	listTimeline: (e, n) => t.paginatedGet(`/api/v1/timelines/list/${e}`, { params: n }, K),
	getConversations: (e) => t.paginatedGet("/api/v1/conversations", { params: e }, sr),
	deleteConversation: async (e) => (await t.request(`/api/v1/conversations/${e}`, { method: "DELETE" })).json,
	markConversationRead: async (n) => {
		let r = await t.request(`/api/v1/conversations/${n}/read`, { method: "POST" });
		return e.parse(sr, r.json);
	},
	getMarkers: async (n) => {
		let r = await t.request("/api/v1/markers", { params: { timeline: n } });
		return e.parse(ni, r.json);
	},
	saveMarkers: async (n) => {
		let r = await t.request("/api/v1/markers", {
			method: "POST",
			body: n
		});
		return e.parse(ni, r.json);
	},
	groupTimeline: (e, n) => t.paginatedGet(t.features.version.software === "Pixelfed" ? `/api/v0/groups/${e}/feed` : `/api/v1/timelines/group/${e}`, { params: n }, K),
	bubbleTimeline: (e) => t.paginatedGet("/api/v1/timelines/bubble", { params: e }, K),
	antennaTimeline: (e, n) => t.paginatedGet(`/api/v1/timelines/antenna/${e}`, { params: n }, K),
	wrenchedTimeline: (e) => t.paginatedGet("/api/v1/pleroma/timelines/wrenched", { params: e }, K)
}), Za = (t) => ({
	getTrendingTags: async (n) => {
		let r = await t.request(t.features.version.software === "Pixelfed" ? "/api/v1.1/discover/posts/hashtags" : "/api/v1/trends/tags", { params: n });
		return e.parse(_(B), r.json);
	},
	getTrendingStatuses: async (n) => {
		let r = await t.request(t.features.version.software === "Pixelfed" ? "/api/pixelfed/v2/discover/posts/trending" : "/api/v1/trends/statuses", { params: n });
		return e.parse(_(K), r.json);
	},
	getTrendingLinks: async (n) => {
		let r = await t.request("/api/v1/trends/links", { params: n });
		return e.parse(_(ea), r.json);
	}
}), Qa = (e) => ({ paginatedGet: e.paginatedGet.bind(e) }), $a = class extends bt {
	accounts = ra(this);
	admin = ca(this);
	announcements = la(this);
	antennas = ua(this);
	apps = da(this);
	asyncRefreshes = fa(this);
	chats = pa(this);
	circles = ma(this);
	collections = ha(this);
	drive = ga(this);
	emails = _a(this);
	events = va(this);
	experimental = ya(this);
	filtering = ba(this);
	gifs = xa(this);
	groupedNotifications = Ea(this);
	instance = Da(this);
	interactionRequests = Oa(this);
	lists = ka(this);
	media = Aa(this);
	myAccount = Fa(this);
	notifications = Ia(this);
	oauth = La(this);
	oembed = Ra(this);
	polls = za(this);
	pushNotifications = Ba(this);
	rssFeedSubscriptions = Va(this);
	scheduledStatuses = Ha(this);
	search = Ua(this);
	settings = Wa(this);
	shoutbox = Ga(this);
	statuses = Ka(this);
	stories = qa(this);
	streaming = Ja(this);
	subscriptions = Ya(this);
	timelines = Xa(this);
	trends = Za(this);
	utils = Qa(this);
	#e;
	constructor(e, t, { fetchInstance: n, fetchInstanceSignal: r, onInstanceFetchSuccess: i, onInstanceFetchError: a, iceshrimpAccessToken: o, onFetchIceshrimpAccessToken: s, ...c } = {}) {
		super(e, t, c), n && this.instance.getInstance().then((e) => {
			if (!r?.aborted) return i?.(e);
		}).catch((e) => {
			r?.aborted || a?.(e);
		}), o && this.setIceshrimpAccessToken(o), s && (this.#e = s);
	}
	getIceshrimpAccessToken = async () => {
		if (!this.iceshrimpAccessToken && this.features.version.software === "Iceshrimp.NET") {
			let e = await this.settings.authorizeIceshrimp();
			this.setIceshrimpAccessToken(e), this.#e?.(e);
		}
	};
}, eo = class {
	accessToken = void 0;
	iceshrimpAccessToken = void 0;
	customAuthorizationToken = void 0;
	baseURL;
	request = yt.bind(this);
	constructor(e) {
		this.baseURL = e;
	}
	async getStatistics() {
		let t = await this.request("/statistics");
		return e.parse(_(dr), t.json);
	}
	async getCategories(t) {
		let n = await this.request("/categories", { params: t });
		return e.parse(_(cr), n.json);
	}
	async getLanguages(t) {
		let n = await this.request("/languages", { params: t });
		return e.parse(_(lr), n.json);
	}
	async getServers(t) {
		let n = await this.request("/servers", { params: t });
		return e.parse(_(ur), n.json);
	}
};
//#endregion
export { L as AKKOMA, S as DITTO, rt as EGREGOROS, C as FIREFISH, w as FRIENDICA, ot as GLITCH, T as GOTOSOCIAL, hn as GroupRoles, E as HOLLO, st as HOMETOWN, D as ICESHRIMP, O as ICESHRIMP_NET, k as MASTODON, A as MITRA, j as NEODB, M as PIXELFED, N as PLEROMA, R as PaginatedResponse, bt as PlApiBaseClient, $a as PlApiClient, eo as PlApiDirectoryClient, P as SHARKEY, F as SNAC, it as TAKAHE, I as TOKI, ct as UNRELEASED, at as WORDPRESS, y as accountSchema, St as accountWarningSchema, ra as accountsCategory, z as adminAccountSchema, wt as adminActionResponseSchema, kt as adminAnnouncementSchema, At as adminCanonicalEmailBlockSchema, ca as adminCategory, jt as adminCohortSchema, Nt as adminCustomEmojiCategorySchema, Mt as adminCustomEmojiSchema, Pt as adminDimensionSchema, It as adminDomainAllowSchema, Lt as adminDomainBlockSchema, Ht as adminDomainLimitSchema, V as adminDomainPermissionSchema, Ut as adminDomainPermissionSubscriptionSchema, Ft as adminDomainSchema, Wt as adminEmailDomainBlockSchema, Gt as adminHeaderFilterSchema, Kt as adminInstanceDeliveryErrorSchema, qt as adminInstanceSchema, Jt as adminInviteSchema, Yt as adminIpBlockSchema, Ct as adminIpSchema, Xt as adminMeasureSchema, Zt as adminModerationLogEntrySchema, tn as adminRelayMatcherSchema, H as adminRelaySchema, q as adminReportSchema, Jn as adminRuleSchema, Yn as adminTagSchema, Kr as albumSchema, Tt as announcementReactionSchema, Ot as announcementSchema, la as announcementsCategory, Y as antennaSchema, ua as antennasCategory, Zn as applicationSchema, da as appsCategory, $n as asyncRefreshSchema, fa as asyncRefreshesCategory, er as authorizationServerMetadataSchema, tr as backupSchema, dn as baseFilterSchema, Ce as blockedAccountSchema, Sn as blurhashSchema, nr as bookmarkFolderSchema, rr as chatMessageSchema, ir as chatSchema, pa as chatsCategory, ar as circleSchema, ma as circlesCategory, rn as collectionItemSchema, U as collectionSchema, an as collectionWithAccountsSchema, ha as collectionsCategory, or as contextSchema, sr as conversationSchema, Se as credentialAccountSchema, Qn as credentialApplicationSchema, m as customEmojiSchema, cr as directoryCategorySchema, lr as directoryLanguageSchema, ur as directoryServerSchema, dr as directoryStatisticsPeriodSchema, fr as domainBlockSchema, ga as driveCategory, pr as driveFileSchema, gr as driveFolderSchema, _r as driveStatusSchema, Hr as editionSchema, _a as emailsCategory, cn as emojiReactionSchema, va as eventsCategory, ya as experimentalCategory, vr as extendedDescriptionSchema, yr as familiarFollowersSchema, ye as featureApprovalSchema, br as featuredTagSchema, ln as filterKeywordSchema, mn as filterResultSchema, fn as filterSchema, un as filterStatusSchema, ba as filteringCategory, Ni as followRelationshipUpdateSchema, Jr as gameSchema, lt as getFeatures, xr as gifResultSchema, Sr as gifResultsSchema, gn as groupMemberSchema, _n as groupRelationshipSchema, W as groupSchema, Ea as groupedNotificationsCategory, zr as groupedNotificationsResultsSchema, Dt as historySchema, Da as instanceCategory, He as instanceSchema, xn as interactionPoliciesSchema, bn as interactionPolicySchema, Br as interactionRequestSchema, Oa as interactionRequestsCategory, $r as itemSchema, J as listSchema, ka as listsCategory, ei as locationSchema, ti as markerSchema, ni as markersSchema, G as mediaAttachmentSchema, Aa as mediaCategory, Et as mentionSchema, Gr as movieSchema, we as mutedAccountSchema, Fa as myAccountCategory, Rr as notificationGroupSchema, vi as notificationPolicySchema, yi as notificationRequestSchema, gi as notificationSchema, Ia as notificationsCategory, La as oauthCategory, bi as oauthTokenSchema, Ra as oembedCategory, qn as partialStatusSchema, Yr as performanceSchema, $t as pleromaConfigDescriptionChildSchema, en as pleromaConfigDescriptionSchema, Qt as pleromaConfigSchema, Xr as podcastEpisodeSchema, qr as podcastSchema, jn as pollSchema, za as pollsCategory, Mn as previewCardAuthorSchema, Nn as previewCardSchema, xi as privacyPolicySchema, Ba as pushNotificationsCategory, Ln as quoteApprovalSchema, Fn as quoteSchema, h as relationshipSchema, Cr as relationshipSeveranceEventSchema, wr as reportSchema, Si as reviewSchema, ue as roleSchema, Rn as rssFeedSchema, Va as rssFeedSubscriptionsCategory, Ee as ruleSchema, Ci as scheduledStatusSchema, Ha as scheduledStatusesCategory, wi as scrobbleSchema, Ua as searchCategory, Ti as searchSchema, Wa as settingsCategory, In as shallowQuoteSchema, nn as shallowTagSchema, Ei as shoutMessageSchema, Ga as shoutboxCategory, Di as statusEditSchema, K as statusSchema, Oi as statusSourceSchema, Kn as statusWithoutAccountSchema, Ka as statusesCategory, qa as storiesCategory, ki as storyCarouselItemSchema, Ai as storyMediaSchema, ji as storyNodeSchema, Mi as storyProfileSchema, Ja as streamingCategory, qi as streamingEventSchema, Ji as subscriptionDetailsSchema, Yi as subscriptionInvoiceSchema, Xi as subscriptionOptionSchema, Ya as subscriptionsCategory, Zi as suggestionSchema, B as tagSchema, Qi as termsOfServiceSchema, Xa as timelinesCategory, $i as tokenSchema, Vn as translationSchema, Za as trendsCategory, ea as trendsLinkSchema, Wr as tvSeasonSchema, Ur as tvShowSchema, ta as userInfoSchema, Qa as utilsCategory, na as webPushSubscriptionSchema };

//# sourceMappingURL=main.es.js.map